// 配信版の指紋（CDNキャッシュ判別用）。PUTのたびにこの時刻を更新すること。
console.log('[ua-body] build 2026-07-29T17:51+09:00 wizard-qty-follows-sizes-r2-stated-note');

(function () {
  'use strict';

  var VARIANT_RESOLUTION_TIMEOUT_MS = 4000;
  // 1秒あたりの variant 同期シグナル上限。これを超えたら variant 再描画ピンポンの暴走とみなし、
  // 我々の反応（MutationObserver等）を停止してマイクロタスク層ループの片翼を折る。
  var VARIANT_SIGNAL_LIMIT = 30;
  function nowMs() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
  var MAGNIFIER_ZOOM = 3;
  var MAGNIFIER_ENABLED = false;
  var EDITOR_ZOOM = 3;
  var TEXT_MODE_SAME = 'same';
  var TEXT_MODE_INDIVIDUAL = 'individual';
  var CONFIGURATOR_TAG = 'p2b';
  var MINIBAR_DISMISS_KEY = 'ua-body-minibar-dismissed';
  var LINE_KEYS = Object.freeze(['1', '2']);
  // 共通の代表色ルール。商品設定の featuredColors 配列があれば、その商品だけ明示順で上書きできる。
  var FEATURED_COLOR_LIMIT = 10;
  var FEATURED_COLOR_RULES = Object.freeze([
    Object.freeze(['ホワイト', '白', 'white']),
    Object.freeze(['ブラック', '黒', 'black']),
    Object.freeze(['ミックスグレー', '杢グレー', 'グレー', 'アッシュ', 'gray', 'grey']),
    Object.freeze(['ナチュラル', 'アイボリー', '生成り', 'natural', 'ivory']),
    Object.freeze(['ネイビー', '紺', 'navy']),
    Object.freeze(['ロイヤルブルー', 'ブルー', '青', 'blue']),
    Object.freeze(['レッド', '赤', 'red']),
    Object.freeze(['グリーン', '緑', 'green']),
    Object.freeze(['イエロー', '黄', 'yellow']),
    Object.freeze(['ピンク', '桃', 'pink'])
  ]);
  var LOCATIONS = Object.freeze([
    '胸（左）',
    '胸（右）',
    '胸（中央）',
    '背中（上部）',
    '裾'
  ]);
  var THREAD_COLORS = Object.freeze([
    'しろ',
    'くろ',
    'あか',
    'だいだい',
    'きいろ',
    'きみどり',
    'みどり',
    'みずいろ',
    'あお',
    'ピンク',
    'エンジ',
    '茶',
    'ベージュ',
    '金',
    '銀'
  ]);
  var FONTS = Object.freeze(['角ゴシック', '明朝', '丸ゴシック', '勘亭流', '行書', '楷書']);
  var FONT_FAMILIES = Object.freeze({
    '角ゴシック': 'UaNuihouKakuGothic',
    '明朝': 'UaNuihouMincho',
    '丸ゴシック': 'UaNuihouMaruGothic',
    '勘亭流': 'UaNuihouKanteiryu',
    '行書': 'UaNuihouGyosho',
    '楷書': 'UaNuihouKaisho'
  });
  var THREAD_COLOR_HEX = Object.freeze({
    'しろ': '#FFFFFF',
    'くろ': '#111111',
    'あか': '#E50012',
    'だいだい': '#EF7E00',
    'きいろ': '#F2D200',
    'きみどり': '#95C11F',
    'みどり': '#009A44',
    'みずいろ': '#45BCC4',
    'あお': '#1B2A6B',
    'ピンク': '#EA8FAD',
    'エンジ': '#7A1A2B',
    '茶': '#8A4B1A',
    'ベージュ': '#D2B58B',
    '金': '#C8A028',
    '銀': '#BCBEC0'
  });
  // nuihouと同じ「実寸枠 + 画像較正」の考え方。初期枠は10×3cm。
  // 500101の画像は2000px角、基準Mサイズの身幅52cmを画像上883pxとして換算する。
  var NAME_EDITOR_FRAME = Object.freeze({
    widthCm: 10,
    heightCm: 3,
    widthPercent: (10 * (883 / 52) / 2000) * 100,
    heightPercent: (3 * (883 / 52) / 2000) * 100
  });
  var DEFAULT_CHARACTER_WIDTH_CM = 1;
  var DEFAULT_CHARACTER_HEIGHT_CM = 1.2;
  // CSS/SVGのfont-sizeは字面の実高より大きい。約1.4倍で指定し、見える文字高を設定値へ近づける。
  var CHARACTER_HEIGHT_RENDER_SCALE = 1.4;
  var EDITOR_POSITIONS = Object.freeze({
    '胸（左）': Object.freeze({ view: 'front', x: 60.5, y: 39.5 }),
    '胸（右）': Object.freeze({ view: 'front', x: 39.5, y: 39.5 }),
    '胸（中央）': Object.freeze({ view: 'front', x: 50, y: 39.5 }),
    '背中（上部）': Object.freeze({ view: 'back', x: 50, y: 31.5 }),
    '裾': Object.freeze({ view: 'front', x: 61, y: 76 })
  });
  var EDITOR_POSITION_KEYS = Object.freeze({
    '胸（左）': 'chestLeft',
    '胸（右）': 'chestRight',
    '胸（中央）': 'chestCenter',
    '背中（上部）': 'backUpper',
    '裾': 'hem'
  });
  var initializedRoots = new WeakSet();
  var yenFormatter = new Intl.NumberFormat('ja-JP');

  function parseConfig(root) {
    var productId = root.getAttribute('data-product-id');
    var configNodes = document.querySelectorAll('[data-ua-body-config]');
    var configNode = Array.prototype.find.call(configNodes, function (node) {
      return node.getAttribute('data-product-id') === productId;
    });

    if (!configNode) throw new Error('商品設定が見つかりません。');

    return JSON.parse(configNode.textContent);
  }

  function parseEditorConfig(root) {
    var configNode = root.querySelector('[data-ua-body-editor-config]');
    if (!configNode) throw new Error('プレビュー位置設定が見つかりません。');

    var configured = JSON.parse(configNode.textContent);
    var configuredPositions = configured.positions || {};
    var useSavedFrameSize = Number(configured.version) >= 2;
    var configuredPercentPerCm = Number(configured.percentPerCm);
    var percentPerCm = Number.isFinite(configuredPercentPerCm) && configuredPercentPerCm >= 0.1 && configuredPercentPerCm <= 3
      ? configuredPercentPerCm
      : NAME_EDITOR_FRAME.widthPercent / NAME_EDITOR_FRAME.widthCm;
    var positions = {};

    Object.keys(EDITOR_POSITIONS).forEach(function (location) {
      var fallback = EDITOR_POSITIONS[location];
      var position = configuredPositions[EDITOR_POSITION_KEYS[location]] || configuredPositions[location] || {};
      var x = Number(position.x);
      var y = Number(position.y);
      var width = Number(position.width);
      var height = Number(position.height);
      var widthCm = Number(position.widthCm);
      var heightCm = Number(position.heightCm);
      var templateWidth = Number.isFinite(widthCm) ? widthCm * percentPerCm : NaN;
      var templateHeight = Number.isFinite(heightCm) ? heightCm * percentPerCm : NaN;

      var resolvedWidth = Number.isFinite(templateWidth) && templateWidth >= 0.1 && templateWidth <= 100
        ? templateWidth
        : useSavedFrameSize && Number.isFinite(width) && width >= 0.1 && width <= 100
          ? width
          : NAME_EDITOR_FRAME.widthPercent;
      var resolvedHeight = Number.isFinite(templateHeight) && templateHeight >= 0.1 && templateHeight <= 100
        ? templateHeight
        : useSavedFrameSize && Number.isFinite(height) && height >= 0.1 && height <= 100
          ? height
          : NAME_EDITOR_FRAME.heightPercent;

      positions[location] = {
        view: fallback.view,
        x: Number.isFinite(x) && x >= 0 && x <= 100 ? x : fallback.x,
        y: Number.isFinite(y) && y >= 0 && y <= 100 ? y : fallback.y,
        width: resolvedWidth,
        height: resolvedHeight,
        widthCm: resolvedWidth / percentPerCm,
        heightCm: resolvedHeight / percentPerCm
      };
    });

    var fontSizePx = Number(configured.fontSizePx);
    var characterWidthCm = Number(configured.characterWidthCm);
    var characterHeightCm = Number(configured.characterHeightCm);
    var configuredEnabledLocations = Array.isArray(configured.enabledLocations)
      ? configured.enabledLocations
      : Object.keys(EDITOR_POSITION_KEYS);
    var enabledLocationKeys = {};
    configuredEnabledLocations.forEach(function (key) {
      if (typeof key === 'string') enabledLocationKeys[key] = true;
    });
    var enabledLocations = LOCATIONS.filter(function (location) {
      return enabledLocationKeys[EDITOR_POSITION_KEYS[location]];
    });
    if (!enabledLocations.length) enabledLocations = LOCATIONS.slice();

    return {
      positions: positions,
      enabledLocations: enabledLocations,
      fontSizePx: Number.isFinite(fontSizePx) && fontSizePx >= 4 && fontSizePx <= 12 ? fontSizePx : 7,
      characterWidthCm: Number.isFinite(characterWidthCm) && characterWidthCm >= 0.5 && characterWidthCm <= 2.5
        ? characterWidthCm
        : DEFAULT_CHARACTER_WIDTH_CM,
      characterHeightCm: Number.isFinite(characterHeightCm) && characterHeightCm >= 0.5 && characterHeightCm <= 2.5
        ? characterHeightCm
        : DEFAULT_CHARACTER_HEIGHT_CM
    };
  }

  function getLineElements(root, lineKey) {
    return {
      key: lineKey,
      slot: '1',
      modes: Array.prototype.slice.call(
        root.querySelectorAll('[data-ua-body-line-mode="' + lineKey + '"]')
      ),
      sameWrap: root.querySelector('[data-ua-body-line-same-wrap="' + lineKey + '"]'),
      individualWrap: root.querySelector('[data-ua-body-line-individual-wrap="' + lineKey + '"]'),
      text: root.querySelector('[data-ua-body-line-text="' + lineKey + '"]'),
      rows: root.querySelector('[data-ua-body-line-rows="' + lineKey + '"]'),
      rowsHelp: root.querySelector('[data-ua-body-rows-help="' + lineKey + '"]'),
      hasSize: lineKey === '1',
      progress: root.querySelector('[data-ua-body-line-progress="' + lineKey + '"]')
    };
  }

  function getLocation2LineElements(root, lineKey) {
    return {
      key: lineKey,
      slot: '2',
      rowAttr: lineKey === '1'
        ? 'data-ua-body-row-location2-name'
        : 'data-ua-body-row-location2-name2',
      modes: Array.prototype.slice.call(
        root.querySelectorAll('[data-ua-body-location2-line-mode="' + lineKey + '"]')
      ),
      sameWrap: root.querySelector('[data-ua-body-location2-line-same-wrap="' + lineKey + '"]'),
      individualWrap: null,
      text: root.querySelector('[data-ua-body-location2-line-text="' + lineKey + '"]'),
      rows: root.querySelector('[data-ua-body-location2-rows]'),
      rowsHelp: root.querySelector('[data-ua-body-location2-rows-help]'),
      hasSize: false,
      progress: root.querySelector('[data-ua-body-location2-progress]')
    };
  }

  function getElements(root) {
    return {
      lines: LINE_KEYS.map(function (lineKey) {
        return getLineElements(root, lineKey);
      }),
      line2Enable: root.querySelector('[data-ua-body-line2-enable]'),
      line2Body: root.querySelector('[data-ua-body-line2-body]'),
      font: root.querySelector('[data-ua-body-font]'),
      fontPicker: root.querySelector('[data-ua-body-font-picker]'),
      fontTrigger: root.querySelector('[data-ua-body-font-trigger]'),
      fontOptions: root.querySelector('[data-ua-body-font-options]'),
      fontSelected: root.querySelector('[data-ua-body-font-selected]'),
      fontSelectedSample: root.querySelector('[data-ua-body-font-selected-sample]'),
      fontChips: Array.prototype.slice.call(root.querySelectorAll('[data-ua-body-font-chip]')),
      fontSamples: Array.prototype.slice.call(root.querySelectorAll('[data-ua-body-font-sample]')),
      location: root.querySelector('[data-ua-body-location]'),
      locationField: root.querySelector('[data-ua-body-location-field]'),
      locationChips: root.querySelector('[data-ua-body-location-chips]'),
      chips: Array.prototype.slice.call(root.querySelectorAll('[data-ua-body-location-chip]')),
      threadColor: root.querySelector('[data-ua-body-thread-color]'),
      threadColorField: root.querySelector('[data-ua-body-thread-color-field]'),
      threadColorChips: root.querySelector('[data-ua-body-thread-color-chips]'),
      threadColorChipButtons: Array.prototype.slice.call(root.querySelectorAll('[data-ua-body-thread-color-chip]')),
      location2Add: root.querySelector('[data-ua-body-location2-add]'),
      location2Panel: root.querySelector('[data-ua-body-location2-panel]'),
      location2Remove: root.querySelector('[data-ua-body-location2-remove]'),
      location2Select: root.querySelector('[data-ua-body-location2-select]'),
      location2Chips: root.querySelector('[data-ua-body-location2-chips]'),
      location2ChipButtons: Array.prototype.slice.call(root.querySelectorAll('[data-ua-body-location2-chip]')),
      location2ContentModes: Array.prototype.slice.call(root.querySelectorAll('[data-ua-body-location2-content-mode]')),
      location2Different: root.querySelector('[data-ua-body-location2-different]'),
      location2Lines: LINE_KEYS.map(function (lineKey) {
        return getLocation2LineElements(root, lineKey);
      }),
      location2Line2Enable: root.querySelector('[data-ua-body-location2-line2-enable]'),
      location2Line2Body: root.querySelector('[data-ua-body-location2-line2-body]'),
      location2Rows: root.querySelector('[data-ua-body-location2-rows]'),
      location2RowsHelp: root.querySelector('[data-ua-body-location2-rows-help]'),
      location2Progress: root.querySelector('[data-ua-body-location2-progress]'),
      location2Font: root.querySelector('[data-ua-body-location2-font]'),
      location2Thread: root.querySelector('[data-ua-body-location2-thread]'),
      location2ThreadIndividual: root.querySelector('[data-ua-body-location2-thread-individual]'),
      editor: root.querySelector('[data-ua-body-editor]'),
      editorSlots: root.querySelector('[data-ua-body-editor-slots]'),
      editorSlotButtons: Array.prototype.slice.call(root.querySelectorAll('[data-ua-body-editor-slot]')),
      editorToggle: root.querySelector('[data-ua-body-editor-toggle]'),
      adminShortcut: root.querySelector('[data-ua-body-admin-shortcut]'),
      editorStage: root.querySelector('[data-ua-body-editor-stage]'),
      editorCanvas: root.querySelector('[data-ua-body-preview-canvas]'),
      editorImage: root.querySelector('[data-ua-body-editor-image]'),
      editorFrame: root.querySelector('[data-ua-body-editor-frame]'),
      editorName: root.querySelector('[data-ua-body-editor-name]'),
      editorNameText: root.querySelector('[data-ua-body-editor-name-text]'),
      editorNameText2: root.querySelector('[data-ua-body-editor-name-text-2]'),
      editorFrame2: root.querySelector('[data-ua-body-editor-frame-2]'),
      editorName2: root.querySelector('[data-ua-body-editor-name-2]'),
      editorName2Text: root.querySelector('[data-ua-body-editor-name-2-text]'),
      editorName2Text2: root.querySelector('[data-ua-body-editor-name-2-text-2]'),
      editorPreviewToggle: root.querySelector('[data-ua-body-preview-toggle]'),
      editorPreviewToggleImage: root.querySelector('[data-ua-body-preview-toggle-image]'),
      editorPreviewToggleLabel: root.querySelector('[data-ua-body-preview-toggle-label]'),
      magnifier: root.querySelector('[data-ua-body-magnifier]'),
      magnifierFrame: root.querySelector('[data-ua-body-magnifier-frame]'),
      magnifierName: root.querySelector('[data-ua-body-magnifier-name]'),
      magnifierNameText: root.querySelector('[data-ua-body-magnifier-name-text]'),
      magnifierNameText2: root.querySelector('[data-ua-body-magnifier-name-text-2]'),
      editorMessage: root.querySelector('[data-ua-body-editor-message]'),
      compactPreview: root.querySelector('[data-ua-body-compact-preview]'),
      compactImage: root.querySelector('[data-ua-body-compact-image]'),
      compactName: root.querySelector('[data-ua-body-compact-name]'),
      compactSummary: root.querySelector('[data-ua-body-compact-summary]'),
      compactOpen: root.querySelector('[data-ua-body-compact-open]'),
      compactDismiss: root.querySelector('[data-ua-body-compact-dismiss]'),
      editorViewButtons: Array.prototype.slice.call(root.querySelectorAll('[data-ua-body-editor-view]')),
      editorFrontThumbnail: root.querySelector('[data-ua-body-editor-thumbnail="front"]'),
      editorBackThumbnail: root.querySelector('[data-ua-body-editor-thumbnail="back"]'),
      editorSummary: root.querySelector('[data-ua-body-editor-summary]'),
      quantity: root.querySelector('[data-ua-body-quantity]'),
      sizeRows: root.querySelector('[data-ua-body-size-rows]'),
      sizeAddButton: root.querySelector('[data-ua-body-size-add]'),
      matrixTotal: root.querySelector('[data-ua-body-total]'),
      attrIndividualToggle: root.querySelector('[data-ua-body-attr-individual]'),
      threadColorLegend: root.querySelector('[data-ua-body-thread-color-legend]'),
      threadColorRequired: root.querySelector('[data-ua-body-thread-color-required]'),
      rowsNote: root.querySelector('[data-ua-body-rows-note]'),
      pieceRows: root.querySelector('[data-ua-body-piece-rows]'),
      embroideryBreakdown: root.querySelector('[data-ua-body-embroidery-breakdown]'),
      embroideryTotal: root.querySelector('[data-ua-body-embroidery-total]'),
      bodyBreakdown: root.querySelector('[data-ua-body-body-breakdown]'),
      bodyTotal: root.querySelector('[data-ua-body-body-total]'),
      orderTotal: root.querySelector('[data-ua-body-order-total]'),
      purchaseBar: root.querySelector('[data-ua-body-purchase-bar]'),
      purchaseTotal: root.querySelector('[data-ua-body-purchase-total]'),
      purchaseSubmit: root.querySelector('[data-ua-body-purchase-submit]'),
      error: root.querySelector('[data-ua-body-error]'),

      // 質問形式（ウィザード）用。既存ブロックの出し分けに使う参照と、ウィザード自身のDOM。
      // 欠けていてもウィザードを起動しないだけ＝現行フォームはそのまま動く（fail-open）。
      fields: root.querySelector('.ua-body-configurator__fields'),
      intro: root.querySelector('.ua-body-configurator__intro'),
      pricing: root.querySelector('.ua-body-configurator__pricing'),
      delivery: root.querySelector('.ua-body-configurator__delivery'),
      colorSlot: root.querySelector('[data-ua-body-color-slot]'),
      sizeField: root.querySelector('[data-ua-body-size-field]'),
      textField: root.querySelector('[data-ua-body-text-field]'),
      location2Field: root.querySelector('[data-ua-body-location2]'),
      wizard: root.querySelector('[data-ua-body-wizard]'),
      wizardSteps: root.querySelector('[data-ua-body-wizard-steps]'),
      wizardNum: root.querySelector('[data-ua-body-wizard-num]'),
      wizardQuestion: root.querySelector('[data-ua-body-wizard-q]'),
      wizardSub: root.querySelector('[data-ua-body-wizard-sub]'),
      wizardResume: root.querySelector('[data-ua-body-wizard-resume]'),
      wizardBulkSlots: {
        '1': root.querySelector('[data-ua-body-bulk-slot="1"]'),
        '2': root.querySelector('[data-ua-body-bulk-slot="2"]')
      },
      wizardQty: root.querySelector('[data-ua-body-wizard-qty]'),
      wizardQtyBands: Array.prototype.slice.call(root.querySelectorAll('[data-ua-body-wizard-qty-band]')),
      wizardQtyNumWrap: root.querySelector('[data-ua-body-wizard-qty-num-wrap]'),
      wizardQtyNum: root.querySelector('[data-ua-body-wizard-qty-num]'),
      wizardPreviewSlot: root.querySelector('[data-ua-body-wizard-preview-slot]'),
      wizardReview: root.querySelector('[data-ua-body-wizard-review]'),
      wizardNav: root.querySelector('[data-ua-body-wizard-nav]'),
      wizardHint: root.querySelector('[data-ua-body-wizard-hint]'),
      wizardBack: root.querySelector('[data-ua-body-wizard-back]'),
      wizardNext: root.querySelector('[data-ua-body-wizard-next]'),
      wizardTotal: root.querySelector('[data-ua-body-wizard-total]'),
      wizardTotalRow: root.querySelector('[data-ua-body-wizard-total-row]'),
      wizardTotalLabel: root.querySelector('[data-ua-body-wizard-total-label]'),
      wizardEscape: root.querySelector('[data-ua-body-wizard-escape]')
    };
  }

  function validateElements(elements) {
    var requiredKeys = [
      'line2Enable',
      'line2Body',
      'font',
      'fontPicker',
      'fontTrigger',
      'fontOptions',
      'fontSelected',
      'fontSelectedSample',
      'location',
      'locationField',
      'locationChips',
      'threadColor',
      'threadColorField',
      'threadColorChips',
      'location2Add',
      'location2Panel',
      'location2Remove',
      'location2Select',
      'location2Chips',
      'location2Different',
      'location2Line2Enable',
      'location2Line2Body',
      'location2Rows',
      'location2RowsHelp',
      'location2Progress',
      'location2Font',
      'location2Thread',
      'location2ThreadIndividual',
      'editor',
      'editorSlots',
      'adminShortcut',
      'editorStage',
      'editorCanvas',
      'editorImage',
      'editorFrame',
      'editorName',
      'editorNameText',
      'editorNameText2',
      'editorFrame2',
      'editorName2',
      'editorName2Text',
      'editorName2Text2',
      'editorPreviewToggle',
      'editorPreviewToggleImage',
      'editorPreviewToggleLabel',
      'magnifier',
      'magnifierFrame',
      'magnifierName',
      'magnifierNameText',
      'magnifierNameText2',
      'editorMessage',
      'compactPreview',
      'compactImage',
      'compactName',
      'compactSummary',
      'compactOpen',
      'compactDismiss',
      'editorFrontThumbnail',
      'editorBackThumbnail',
      'editorSummary',
      'quantity',
      'sizeRows',
      'sizeAddButton',
      'matrixTotal',
      'attrIndividualToggle',
      'embroideryBreakdown',
      'embroideryTotal',
      'bodyBreakdown',
      'bodyTotal',
      'orderTotal',
      'purchaseBar',
      'purchaseTotal',
      'purchaseSubmit',
      'error'
    ];
    var missing = requiredKeys.find(function (key) {
      return !elements[key];
    });

    if (missing) throw new Error('入力UIが不足しています: ' + missing);
    if (!Array.isArray(elements.lines) || elements.lines.length !== LINE_KEYS.length) {
      throw new Error('刺繍する文字の行UIが不足しています。');
    }
    elements.lines.forEach(function (line) {
      if (line.modes.length !== 2 || !line.sameWrap || !line.text) {
        throw new Error(line.key + '行目の入力UIが不足しています。');
      }
    });
    if (elements.location2ContentModes.length !== 2 || elements.editorSlotButtons.length !== 2) {
      throw new Error('2箇所目の切替UIが不足しています。');
    }
    if (!Array.isArray(elements.location2Lines) || elements.location2Lines.length !== LINE_KEYS.length) {
      throw new Error('2箇所目の文字入力UIが不足しています。');
    }
    elements.location2Lines.forEach(function (line) {
      if (line.modes.length !== 2 || !line.sameWrap || !line.text) {
        throw new Error('2箇所目' + line.key + '行目の入力UIが不足しています。');
      }
    });
    // ピース行リスト・進捗・行ヘルプは1行目（hasSize）が所有する唯一のリスト。
    var pieceLine = elements.lines.find(function (line) { return line.hasSize; });
    if (!pieceLine || !pieceLine.rows || !pieceLine.progress || !pieceLine.rowsHelp) {
      throw new Error('刺繍する文字の行UIが不足しています。');
    }
    if (elements.fontChips.length !== FONTS.length || elements.fontSamples.length !== FONTS.length) {
      throw new Error('書体の候補数が一致しません。');
    }
    if (elements.editorViewButtons.length !== 2) throw new Error('プレビューの向き選択が不足しています。');
    if (elements.chips.length !== LOCATIONS.length) throw new Error('刺繍箇所の候補数が一致しません。');
    if (elements.location2ChipButtons.length !== LOCATIONS.length) throw new Error('2箇所目の刺繍箇所の候補数が一致しません。');
    if (elements.threadColorChipButtons.length !== THREAD_COLORS.length) throw new Error('糸色の候補数が一致しません。');
  }

  function validateSizePrices(config) {
    var sizeOrder = config.sizeOrder;
    var sizePrices = config.sizePrices;
    if (!Array.isArray(sizeOrder) || sizeOrder.length < 1 || sizeOrder.length > 20) {
      throw new Error('サイズ順が設定されていません。');
    }
    if (!sizePrices || typeof sizePrices !== 'object' || Array.isArray(sizePrices)) {
      throw new Error('サイズ別ボディ単価がありません。');
    }

    var seenSizes = {};
    sizeOrder.forEach(function (size) {
      if (typeof size !== 'string' || !size.trim() || seenSizes[size]) {
        throw new Error('サイズ順が不正です。');
      }
      seenSizes[size] = true;
      if (
        !Object.prototype.hasOwnProperty.call(sizePrices, size) ||
        typeof sizePrices[size] !== 'number' ||
        !Number.isFinite(sizePrices[size]) ||
        sizePrices[size] < 0 ||
        !Number.isInteger(sizePrices[size])
      ) {
        throw new Error(size + 'のボディ単価が不正です。');
      }
    });

    var configuredSizes = Object.keys(sizePrices);
    if (
      configuredSizes.length !== sizeOrder.length ||
      configuredSizes.some(function (size) { return !seenSizes[size]; })
    ) {
      throw new Error('サイズ別ボディ単価の件数が一致しません。');
    }

    var byColor = config.variantsByColor;
    if (!byColor || typeof byColor !== 'object' || Array.isArray(byColor) || !Object.keys(byColor).length) {
      throw new Error('カラー・サイズ対応表がありません。');
    }
    Object.keys(byColor).forEach(function (color) {
      var sizes = byColor[color];
      if (!sizes || typeof sizes !== 'object' || Array.isArray(sizes)) {
        throw new Error(color + 'のサイズ対応表が不正です。');
      }
      sizeOrder.forEach(function (size) {
        var entry = sizes[size];
        var variantId = entry ? Number(entry.id) : NaN;
        var price = entry ? Number(entry.price) : NaN;
        if (
          !entry ||
          !Number.isSafeInteger(variantId) ||
          variantId <= 0 ||
          !Number.isFinite(price) ||
          price !== sizePrices[size]
        ) {
          throw new Error(color + ' ' + size + 'のボディvariantが不正です。');
        }
      });
    });
  }

  function validateCore() {
    var core = window.EmbroideryPricingCore;
    if (
      !core ||
      !Array.isArray(core.namePriceBands) ||
      core.MAX_NAME_CHARACTERS !== 10 ||
      typeof core.getNameBandByLength !== 'function' ||
      typeof core.getNameUnitPriceByLength !== 'function' ||
      typeof core.textLength !== 'function' ||
      typeof core.isValidNameText !== 'function' ||
      typeof core.isValidQty !== 'function'
    ) {
      throw new Error('刺繍料金coreを読み込めません。');
    }

    return core;
  }

  function validateBootstrap(state) {
    var config = state.config;
    var productId = Number(config.productId);
    var expectedProductId = Number(config.expectedProductId);
    if (
      !Number.isSafeInteger(productId) ||
      productId <= 0 ||
      !Number.isSafeInteger(expectedProductId) ||
      productId !== expectedProductId
    ) {
      throw new Error('対象商品IDが一致しません。');
    }

    validateElements(state.elements);
    validateSizePrices(config);
    state.sizeOrder = config.sizeOrder.slice();
    state.core = validateCore();

    // ワークマン基準の文字数帯を共通coreと突合し、価格・variantをfail-closed検証する。
    var configuredBands = config.embroideryBands;
    if (!configuredBands || typeof configuredBands !== 'object' || Array.isArray(configuredBands)) {
      throw new Error('刺繍加工variantが設定されていません。');
    }
    var seenVariantIds = {};
    state.embroideryBands = state.core.namePriceBands.map(function (band) {
      var entry = configuredBands[band.code];
      var variantId = entry ? Number(entry.variantId) : NaN;
      if (
        !entry ||
        !Number.isSafeInteger(variantId) ||
        variantId <= 0 ||
        Number(entry.price) !== band.unitPrice ||
        Number(entry.maxCharacters) !== band.maxCharacters
      ) {
        throw new Error('刺繍加工variantが設定されていません（' + band.code + '）。');
      }
      if (seenVariantIds[variantId]) {
        throw new Error('刺繍加工variantが重複しています（' + band.code + '）。');
      }
      seenVariantIds[variantId] = true;
      return {
        code: band.code,
        maxCharacters: band.maxCharacters,
        unitPrice: band.unitPrice,
        variantId: variantId
      };
    });

    // 1枚ごとに内容が分かれる加算（個別ネーム・糸色個別）のvariantを検証する。
    var configuredSurcharges = config.surcharges;
    var surchargeDefinitions = [
      { key: 'individualName', code: 'INDIVIDUAL_NAME', label: '個別ネーム指定', unitPrice: 200 },
      { key: 'individualThread', code: 'INDIVIDUAL_THREAD', label: '糸色個別指定', unitPrice: 100 }
    ];
    if (!configuredSurcharges || typeof configuredSurcharges !== 'object' || Array.isArray(configuredSurcharges)) {
      throw new Error('個別指定料金variantが設定されていません。');
    }
    state.surcharges = {};
    surchargeDefinitions.forEach(function (definition) {
      var entry = configuredSurcharges[definition.key];
      var variantId = entry ? Number(entry.variantId) : NaN;
      var unitPrice = entry ? Number(entry.price) : NaN;
      if (
        !entry ||
        entry.code !== definition.code ||
        !Number.isSafeInteger(variantId) ||
        variantId <= 0 ||
        unitPrice !== definition.unitPrice
      ) {
        throw new Error('個別指定料金variantが不正です（' + definition.code + '）。');
      }
      if (seenVariantIds[variantId]) {
        throw new Error('加工料金variantが重複しています（' + definition.code + '）。');
      }
      seenVariantIds[variantId] = true;
      state.surcharges[definition.key] = {
        code: definition.code,
        label: definition.label,
        unitPrice: unitPrice,
        variantId: variantId
      };
    });

    var configuredSmallLotFee = config.smallLotFee;
    var smallLotVariantId = configuredSmallLotFee ? Number(configuredSmallLotFee.variantId) : NaN;
    if (
      !configuredSmallLotFee ||
      configuredSmallLotFee.code !== 'SMALL_LOT_FEE' ||
      !Number.isSafeInteger(smallLotVariantId) ||
      smallLotVariantId <= 0 ||
      Number(configuredSmallLotFee.price) !== 2200 ||
      Number(configuredSmallLotFee.maxQuantity) !== 9 ||
      seenVariantIds[smallLotVariantId]
    ) {
      throw new Error('小ロット対応費variantが不正です。');
    }
    state.smallLotFee = {
      code: configuredSmallLotFee.code,
      label: '小ロット対応費',
      unitPrice: 2200,
      maxQuantity: 9,
      variantId: smallLotVariantId
    };

    if (!state.form || !state.variantInput || !state.submitButton) {
      throw new Error('商品購入フォームを取得できません。');
    }
    var sizeSelection = getCurrentSizeSelection(state);
    if (!sizeSelection.size) throw new Error('選択中のサイズを取得できません。');
    if (sizeSelection.price === null) throw new Error('選択中サイズのボディ単価がありません。');
    if (!getCurrentVariantId(state)) throw new Error('選択中のボディvariant IDを取得できません。');
    if (typeof window.MutationObserver !== 'function') throw new Error('variant変更の監視を開始できません。');
    if (!window.routes || typeof window.routes.cart_add_url !== 'string' || typeof fetchConfig !== 'function') {
      throw new Error('カートAPI設定を取得できません。');
    }
  }

  function formatYen(value) {
    return yenFormatter.format(Math.round(value)) + '円';
  }

  // USPチップ用「1枚あたり最低額」= 最安サイズのボディ単価 + 最安の文字数帯（5文字以下）。
  // 商品ごとに変わるためハードコードしない。算出できないときは null を返し、チップ自体を出さない。
  function minPiecePrice(state) {
    try {
      var sizePrices = state.config && state.config.sizePrices;
      var sizes = sizePrices ? Object.keys(sizePrices) : [];
      if (!sizes.length) return null;
      var minBody = null;
      sizes.forEach(function (size) {
        var price = Number(sizePrices[size]);
        if (!Number.isFinite(price) || price < 0) return;
        if (minBody === null || price < minBody) minBody = price;
      });

      var bands = (state.core && state.core.namePriceBands) || state.embroideryBands;
      if (!Array.isArray(bands) || !bands.length) return null;
      var minName = null;
      bands.forEach(function (band) {
        var price = Number(band && band.unitPrice);
        if (!Number.isFinite(price) || price <= 0) return;
        if (minName === null || price < minName) minName = price;
      });

      if (minBody === null || minName === null) return null;
      return minBody + minName;
    } catch (error) {
      return null;
    }
  }

  // clone した USP チップ群のうち「1枚あたり最低額」チップだけを、算出額で埋めて表示する。
  function applyUspMinPriceChip(state, container) {
    if (!container) return;
    var chip = container.querySelector('[data-ua-body-usp-min-price]');
    var text = chip ? chip.querySelector('[data-ua-body-usp-min-price-text]') : null;
    if (!chip || !text) return;
    var price = minPiecePrice(state);
    if (price === null) {
      chip.hidden = true; // 誤った金額を出すより無表示（残り3チップだけ表示）
      return;
    }
    // チップ内の表記は他のチップ（¥11,000以上で送料無料）に合わせて「¥」記号で揃える。
    text.textContent = '10枚以上なら1枚 ¥' + yenFormatter.format(price) + '〜';
    chip.hidden = false;
  }

  function resolveForm(state) {
    if (!state.config || !state.config.formId) {
      state.form = null;
      state.variantInput = null;
      state.productForm = null;
      state.submitButton = null;
      state.submitButtonText = null;
      state.spinner = null;
      return;
    }

    state.form = document.getElementById(state.config.formId);
    state.variantInput = state.form ? state.form.querySelector('[name="id"]') : null;
    state.productForm = state.form ? state.form.closest('product-form') : null;
    state.submitButton = state.form ? state.form.querySelector('[type="submit"]') : null;
    if (state.submitButton) state.submitButton.classList.add('ua-body-configurator__submit');
    state.submitButtonText = state.submitButton ? state.submitButton.querySelector('span') : null;
    state.spinner = state.submitButton ? state.submitButton.querySelector('.loading__spinner') : null;
    observeVariantInput(state);
  }

  function observeVariantInput(state) {
    if (!state.variantObserver || !state.variantInput || state.observedVariantInput === state.variantInput) return;

    state.variantObserver.disconnect();
    state.variantObserver.observe(state.variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
    state.observedVariantInput = state.variantInput;
  }

  function setSubmitLabel(state) {
    resolveForm(state);
    if (state.submitButtonText) state.submitButtonText.textContent = cartSubmitLabel(state);
    if (state.elements.purchaseSubmit && !state.submitting) {
      state.elements.purchaseSubmit.textContent = cartSubmitLabel(state);
    }
  }

  function showError(state, message, focusTarget) {
    if (state.elements.error) {
      state.elements.error.textContent = message;
      state.elements.error.hidden = false;
    }

    resolveForm(state);
    if (state.productForm && typeof state.productForm.handleErrorMessage === 'function') {
      state.productForm.handleErrorMessage(message);
    }

    if (focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus({ preventScroll: true });
      focusTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function clearError(state) {
    state.elements.error.textContent = '';
    state.elements.error.hidden = true;

    resolveForm(state);
    if (state.productForm && typeof state.productForm.handleErrorMessage === 'function') {
      state.productForm.handleErrorMessage();
    }
  }

  function clearInvalidState(state) {
    var targets = [
      state.elements.font,
      state.elements.location,
      state.elements.threadColor,
      state.elements.quantity
    ];
    state.elements.lines.forEach(function (line) {
      targets.push(line.text);
    });
    state.elements.location2Lines.forEach(function (line) {
      targets.push(line.text);
    });
    targets.push(state.elements.location2Select);
    targets.push(state.elements.location2Font);
    targets.push(state.elements.location2Thread);
    if (state.elements.sizeRows) {
      Array.prototype.slice.call(
        state.elements.sizeRows.querySelectorAll('[data-ua-body-sizerow-select], [data-ua-body-sizerow-qty]')
      ).forEach(function (element) {
        targets.push(element);
      });
    }
    Array.prototype.slice.call(
      pieceRowsContainer(state).querySelectorAll(
        '[data-ua-body-row-name], [data-ua-body-row-name2], [data-ua-body-row-location2-name], [data-ua-body-row-location2-name2], [data-ua-body-row-color], [data-ua-body-row-thread]'
      )
    ).forEach(function (element) {
      targets.push(element);
    });
    Array.prototype.slice.call(
      state.elements.location2Rows.querySelectorAll(
        '[data-ua-body-row-location2-name], [data-ua-body-row-location2-name2], [data-ua-body-row-location2-thread]'
      )
    ).forEach(function (element) {
      targets.push(element);
    });
    targets.forEach(function (element) {
      if (element) element.removeAttribute('aria-invalid');
    });
    state.elements.locationChips.removeAttribute('aria-invalid');
    state.elements.location2Chips.removeAttribute('aria-invalid');
    state.elements.threadColorChips.removeAttribute('aria-invalid');
  }

  function getLine(state, lineKey) {
    return state.elements.lines.find(function (line) {
      return line.key === lineKey;
    });
  }

  function isLine2Enabled(state) {
    return !!state.elements.line2Enable.checked;
  }

  function getLocation2Line(state, lineKey) {
    return state.elements.location2Lines.find(function (line) {
      return line.key === lineKey;
    });
  }

  function secondLocationEnabled(state) {
    return !state.elements.location2Panel.hidden;
  }

  function secondContentMode(state) {
    var selected = state.elements.location2ContentModes.find(function (radio) {
      return radio.checked;
    });
    return selected ? selected.value : TEXT_MODE_SAME;
  }

  function secondContentDifferent(state) {
    return secondLocationEnabled(state) && secondContentMode(state) === 'different';
  }

  function isLocation2Line2Enabled(state) {
    return secondContentDifferent(state) && !!state.elements.location2Line2Enable.checked;
  }

  function activeLocation2Lines(state) {
    if (!secondContentDifferent(state)) return [];
    return state.elements.location2Lines.filter(function (line) {
      return line.key === '1' || isLocation2Line2Enabled(state);
    });
  }

  // 課金・カートでは刺繍箇所を単位に扱う。同じ内容でも2箇所分として加算する。
  function embroideryConfigs(state) {
    var primary = {
      slot: '1',
      location: state.elements.location.value,
      font: state.elements.font.value,
      thread: null,
      lines: activeLines(state),
      sameAsPrimary: false
    };
    var configs = [primary];
    if (!secondLocationEnabled(state)) return configs;
    if (secondContentDifferent(state)) {
      configs.push({
        slot: '2',
        location: state.elements.location2Select.value,
        font: state.elements.location2Font.value,
        thread: state.elements.location2Thread.value,
        lines: activeLocation2Lines(state),
        sameAsPrimary: false
      });
    } else {
      configs.push({
        slot: '2',
        location: state.elements.location2Select.value,
        font: state.elements.font.value,
        thread: null,
        lines: activeLines(state),
        sameAsPrimary: true
      });
    }
    return configs;
  }

  // 課金・検証の対象となる行だけを返す（1行目=常に対象、2行目=トグルON時のみ）。
  function activeLines(state) {
    return state.elements.lines.filter(function (line) {
      return line.key === '1' || isLine2Enabled(state);
    });
  }

  function getLineMode(state, line) {
    var selected = line.modes.find(function (radio) {
      return radio.checked;
    });
    return selected ? selected.value : '';
  }

  // ピース行（1枚=1行）の唯一のリストコンテナ（1行目=line1が所有）。両行のテキストもここに同居する。
  function pieceRowsContainer(state) {
    return getLine(state, '1').rows;
  }

  // 行内テキスト入力のdata属性（1行目=name, 2行目=name2）。
  function rowTextAttr(line) {
    if (line.rowAttr) return line.rowAttr;
    return line.key === '1' ? 'data-ua-body-row-name' : 'data-ua-body-row-name2';
  }

  function getLineRowTextInputs(state, line) {
    var container = line.slot === '2' ? state.elements.location2Rows : pieceRowsContainer(state);
    return Array.prototype.slice.call(
      container.querySelectorAll('[' + rowTextAttr(line) + ']')
    );
  }

  function getLineRowColorSelects(state) {
    return Array.prototype.slice.call(
      pieceRowsContainer(state).querySelectorAll('[data-ua-body-row-color]')
    );
  }

  function getLineRowThreadSelects(state) {
    return Array.prototype.slice.call(
      pieceRowsContainer(state).querySelectorAll('[data-ua-body-row-thread]')
    );
  }

  // 「ボディ色・糸色を1枚ごとに変える」トグルの状態。
  function attrIndividualEnabled(state) {
    return !!state.elements.attrIndividualToggle.checked;
  }

  function location2ThreadIndividualEnabled(state) {
    return secondContentDifferent(state) && !!state.elements.location2ThreadIndividual.checked;
  }

  function getLocation2RowThreadSelects(state) {
    return Array.prototype.slice.call(
      state.elements.location2Rows.querySelectorAll('[data-ua-body-row-location2-thread]')
    );
  }

  // 入力値を 0〜100 の整数に丸めて読む（表示値は書き換えない）。
  function readSizeCount(input) {
    if (!input) return 0;
    var value = Math.floor(Number(input.value));
    if (!Number.isFinite(value) || value < 0) return 0;
    if (value > 100) return 100;
    return value;
  }

  // 現在の「サイズ行」DOM一覧（追加順）。
  function getSizeRows(state) {
    if (!state.elements.sizeRows) return [];
    return Array.prototype.slice.call(
      state.elements.sizeRows.querySelectorAll('.ua-body-configurator__size-row')
    );
  }

  // XXL/XXXL などは価格差付きラベル「XXL（+300円）」。S〜XLは素のラベル。
  function sizeOptionLabel(state, size) {
    var base = Number(state.config.sizePrices[state.sizeOrder[0]]);
    var price = Number(state.config.sizePrices[size]);
    var diff = Number.isFinite(price) && Number.isFinite(base) ? price - base : 0;
    return diff > 0 ? size + '（+' + yenFormatter.format(diff) + '円）' : size;
  }

  // change/blur時にサイズ行の枚数を 0〜100 の整数へ正規化する。
  function clampSizeRowQty(input) {
    if (!input) return;
    var value = readSizeCount(input);
    if (String(value) !== input.value) input.value = String(value);
  }

  // サイズ行リストから各サイズの合計枚数を集計（未選択行は無視・重複は防止済み）。
  function getMatrixCounts(state) {
    var counts = {};
    state.sizeOrder.forEach(function (size) {
      counts[size] = 0;
    });
    getSizeRows(state).forEach(function (row) {
      var select = row.querySelector('[data-ua-body-sizerow-select]');
      var qtyInput = row.querySelector('[data-ua-body-sizerow-qty]');
      var size = select ? select.value : '';
      if (size && state.sizeOrder.indexOf(size) !== -1) {
        counts[size] += readSizeCount(qtyInput);
      }
    });
    return counts;
  }

  function getMatrixTotal(state) {
    var counts = getMatrixCounts(state);
    return state.sizeOrder.reduce(function (sum, size) {
      return sum + counts[size];
    }, 0);
  }

  // マトリクスからピースのサイズ配列を導出（state.sizeOrder昇順・各サイズの枚数分）。
  function derivePieceSizes(state) {
    var counts = getMatrixCounts(state);
    var sizes = [];
    state.sizeOrder.forEach(function (size) {
      for (var i = 0; i < counts[size]; i++) sizes.push(size);
    });
    return sizes;
  }

  // 合計を表示に反映し、既存の枚数参照コードが動くよう隠しquantityへミラーする。
  function syncQuantityFromMatrix(state) {
    var total = getMatrixTotal(state);
    if (state.elements.matrixTotal) state.elements.matrixTotal.textContent = String(total);
    if (Number(state.elements.quantity.value) !== total) {
      state.elements.quantity.value = String(total);
    }
    return total;
  }

  // 行カード（1枚ごとの例外指定）を表示する条件。
  function rowCardsVisible(state) {
    var line1 = getLine(state, '1');
    var line2 = getLine(state, '2');
    var line1Individual = getLineMode(state, line1) === TEXT_MODE_INDIVIDUAL;
    var line2Individual = isLine2Enabled(state) && getLineMode(state, line2) === TEXT_MODE_INDIVIDUAL;
    return line1Individual || line2Individual || attrIndividualEnabled(state);
  }

  function location2RowCardsVisible(state) {
    var location2Line1 = getLocation2Line(state, '1');
    var location2Line2 = getLocation2Line(state, '2');
    var location2Line1Individual =
      secondContentDifferent(state) && getLineMode(state, location2Line1) === TEXT_MODE_INDIVIDUAL;
    var location2Line2Individual =
      isLocation2Line2Enabled(state) && getLineMode(state, location2Line2) === TEXT_MODE_INDIVIDUAL;
    return location2Line1Individual || location2Line2Individual || location2ThreadIndividualEnabled(state);
  }

  // 各サイズ行のselectで、他の行が選択済みのサイズをoption disabledにする（重複防止）。
  // 追加ボタンは全サイズ使用済み or 行数がサイズ数に達したら無効化。
  function refreshSizeRowOptions(state) {
    var rows = getSizeRows(state);
    var chosen = {};
    rows.forEach(function (row) {
      var select = row.querySelector('[data-ua-body-sizerow-select]');
      if (select && select.value) chosen[select.value] = true;
    });
    rows.forEach(function (row) {
      var select = row.querySelector('[data-ua-body-sizerow-select]');
      if (!select) return;
      Array.prototype.forEach.call(select.options, function (option) {
        if (!option.value) return;
        option.disabled = !!chosen[option.value] && option.value !== select.value;
      });
      var remove = row.querySelector('[data-ua-body-sizerow-remove]');
      // 最後の1行は削除で空に戻す挙動なので常に押下可。
      if (remove) remove.disabled = false;
    });
    if (state.elements.sizeAddButton) {
      state.elements.sizeAddButton.disabled = rows.length >= state.sizeOrder.length;
    }
  }

  // サイズ行1つ分のDOMを組み立てる（selectの選択肢・増減・削除を配線）。
  function buildSizeRow(state, opts) {
    opts = opts || {};
    var row = document.createElement('div');
    row.className = 'ua-body-configurator__size-row';

    var select = document.createElement('select');
    select.className = 'ua-body-configurator__select ua-body-configurator__size-row-select';
    select.setAttribute('data-ua-body-sizerow-select', '');
    select.setAttribute('aria-label', 'サイズ');
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'サイズを選択';
    select.appendChild(placeholder);
    state.sizeOrder.forEach(function (size) {
      var option = document.createElement('option');
      option.value = size;
      option.textContent = sizeOptionLabel(state, size);
      select.appendChild(option);
    });
    if (typeof opts.size === 'string' && opts.size) select.value = opts.size;
    select.addEventListener('change', function () {
      refreshSizeRowOptions(state);
      clearError(state);
      handleSizeRowsChange(state);
    });
    row.appendChild(select);

    var stepper = document.createElement('div');
    stepper.className = 'ua-body-configurator__size-row-stepper';
    stepper.appendChild(buildSizeStepButton(state, '-1'));
    var qty = document.createElement('input');
    qty.type = 'number';
    qty.inputMode = 'numeric';
    qty.min = '0';
    qty.max = '100';
    qty.step = '1';
    qty.className = 'ua-body-configurator__input ua-body-configurator__size-row-qty';
    qty.setAttribute('data-ua-body-sizerow-qty', '');
    qty.setAttribute('aria-label', '枚数');
    qty.value = String(typeof opts.qty === 'number' ? opts.qty : 1);
    qty.addEventListener('input', function () {
      clearError(state);
      handleSizeRowsChange(state);
    });
    qty.addEventListener('change', function () {
      clampSizeRowQty(qty);
      clearError(state);
      handleSizeRowsChange(state);
    });
    stepper.appendChild(qty);
    stepper.appendChild(buildSizeStepButton(state, '1'));
    row.appendChild(stepper);

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'ua-body-configurator__size-row-remove';
    remove.setAttribute('data-ua-body-sizerow-remove', '');
    remove.setAttribute('aria-label', 'このサイズ行を削除');
    remove.textContent = '×';
    remove.addEventListener('click', function () {
      removeSizeRow(state, row);
    });
    row.appendChild(remove);

    return row;
  }

  function buildSizeStepButton(state, dir) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ua-body-configurator__stepper-btn';
    button.setAttribute('data-ua-body-sizerow-step', '');
    button.setAttribute('data-dir', dir);
    button.setAttribute('aria-label', dir === '1' ? '枚数を1増やす' : '枚数を1減らす');
    button.textContent = dir === '1' ? '＋' : '−';
    button.addEventListener('click', function () {
      var row = button.closest('.ua-body-configurator__size-row');
      var input = row ? row.querySelector('[data-ua-body-sizerow-qty]') : null;
      if (!input) return;
      var step = Number(dir) || 0;
      var current = readSizeCount(input);
      var next = Math.min(100, Math.max(0, current + step));
      if (next === current) return;
      input.value = String(next);
      clearError(state);
      handleSizeRowsChange(state);
    });
    return button;
  }

  function addSizeRow(state, size, qty) {
    var row = buildSizeRow(state, { size: size, qty: qty });
    state.elements.sizeRows.appendChild(row);
    refreshSizeRowOptions(state);
    return row;
  }

  // 削除。最後の1行は削除せず空の1行に戻す。
  function removeSizeRow(state, row) {
    var rows = getSizeRows(state);
    if (rows.length <= 1) {
      state.elements.sizeRows.textContent = '';
      addSizeRow(state, '', 1);
    } else {
      row.remove();
    }
    refreshSizeRowOptions(state);
    clearError(state);
    handleSizeRowsChange(state);
  }

  // 初期化: サイズ行を1つ（未選択）だけ用意して合計をミラーする。
  function initSizeRows(state) {
    state.elements.sizeRows.textContent = '';
    addSizeRow(state, '', 1);
    syncQuantityFromMatrix(state);
  }

  // 既存行の入力値をサイズ別（サイズ内出現順）に集める。マトリクス増減時の値保持に使う。
  function collectRowValuesBySize(state) {
    var container = pieceRowsContainer(state);
    if (!container) return {};
    var rows = Array.prototype.slice.call(container.querySelectorAll('.ua-body-configurator__row'));
    var bySize = {};
    rows.forEach(function (row) {
      var size = row.getAttribute('data-ua-body-piece-size') || '';
      var name1El = row.querySelector('[data-ua-body-row-name]');
      var name2El = row.querySelector('[data-ua-body-row-name2]');
      var location2Name1El = row.querySelector('[data-ua-body-row-location2-name]');
      var location2Name2El = row.querySelector('[data-ua-body-row-location2-name2]');
      var colorEl = row.querySelector('[data-ua-body-row-color]');
      var threadEl = row.querySelector('[data-ua-body-row-thread]');
      if (!bySize[size]) bySize[size] = [];
      bySize[size].push({
        name1: name1El ? name1El.value : undefined,
        name2: name2El ? name2El.value : undefined,
        location2Name1: location2Name1El ? location2Name1El.value : undefined,
        location2Name2: location2Name2El ? location2Name2El.value : undefined,
        color: colorEl ? colorEl.value : undefined,
        colorTouched: colorEl ? colorEl.getAttribute('data-ua-touched') === '1' : false,
        thread: threadEl ? threadEl.value : undefined,
        threadTouched: threadEl ? threadEl.getAttribute('data-ua-touched') === '1' : false
      });
    });
    return bySize;
  }

  function collectLocation2RowValuesBySize(state) {
    var rows = Array.prototype.slice.call(
      state.elements.location2Rows.querySelectorAll('.ua-body-configurator__row')
    );
    var bySize = {};
    rows.forEach(function (row) {
      var size = row.getAttribute('data-ua-body-piece-size') || '';
      var name1 = row.querySelector('[data-ua-body-row-location2-name]');
      var name2 = row.querySelector('[data-ua-body-row-location2-name2]');
      var thread = row.querySelector('[data-ua-body-row-location2-thread]');
      if (!bySize[size]) bySize[size] = [];
      bySize[size].push({
        name1: name1 ? name1.value : '',
        name2: name2 ? name2.value : '',
        thread: thread ? thread.value : '',
        threadTouched: thread ? thread.getAttribute('data-ua-touched') === '1' : false
      });
    });
    return bySize;
  }

  // メイン糸色は、個別指定ONのときは「まだ個別に指定していない枚に一括反映する」コントロールに
  // 役割が変わる（未タッチの行だけが追従する）。見出しをその役割に合わせ、必須バッジを外す。
  // ※ select 側の required/aria-required は変えない（行の初期値をここから配るため実際に必要）。
  function applyThreadColorLabel(state) {
    var individual = attrIndividualEnabled(state);
    if (state.elements.threadColorLegend) {
      state.elements.threadColorLegend.textContent = individual
        ? '糸色（個別に指定していない枚に適用）'
        : '糸色';
    }
    if (state.elements.threadColorRequired) {
      state.elements.threadColorRequired.hidden = individual;
    }
  }

  // 行カード領域（注記・ヘルプ・リスト・進捗）の表示可否をまとめて切り替える。
  function applyRowCardsVisibility(state) {
    var line1 = getLine(state, '1');
    var visible = rowCardsVisible(state);
    // 親も畳む。行カード群は fields グリッドの直下に移したので、空のまま残すと gap だけが残る。
    if (state.elements.pieceRows) state.elements.pieceRows.hidden = !visible;
    if (line1.rows) line1.rows.hidden = !visible;
    if (line1.rowsHelp) line1.rowsHelp.hidden = !visible;
    if (line1.progress) line1.progress.hidden = !visible;
    // 注記はボディ色・糸色の引き継ぎを説明するものなので、その列が出るときだけ出す。
    if (state.elements.rowsNote) {
      state.elements.rowsNote.hidden = !visible || !attrIndividualEnabled(state);
    }
    applyThreadColorLabel(state);
  }

  function applyLocation2RowCardsVisibility(state) {
    var visible = location2RowCardsVisible(state);
    state.elements.location2Rows.hidden = !visible;
    state.elements.location2RowsHelp.hidden = !visible;
    state.elements.location2Progress.hidden = !visible;
  }

  // サイズ行変更 → 合計反映 → ピース行再生成 → 価格・プレビュー更新。
  // 枚数の正本はサイズ内訳。Q1「何枚つくりますか」の答えは、内訳の合計に黙って追随させる
  // （ここでズレを残すと、Q3が「◯枚多い」で止まる原因になる）。
  // qtyBand（選んだ帯）は答えとして保持する＝ズレの通知の根拠になる。
  function wizardSyncTargetFromMatrix(state) {
    if (!state.wizard) return;
    var total = getMatrixTotal(state);
    if (total <= 0) return;
    state.wizard.targetQty = total;
    if (state.elements.wizardQtyNum && total >= 2) {
      state.elements.wizardQtyNum.value = String(total);
    }
  }

  function handleSizeRowsChange(state) {
    syncQuantityFromMatrix(state);
    wizardSyncTargetFromMatrix(state);
    rebuildLineRows(state);
    rebuildLocation2Rows(state);
    applyRowTextColumns(state);
    applyRowCardsVisibility(state);
    applyLocation2RowCardsVisibility(state);
    updateAllLineProgress(state);
    updatePrice(state);
    updateEditor(state);
  }

  // 色糸個別トグル変更 → 行再生成・列表示・価格・プレビュー更新。
  function handleAttrToggle(state) {
    rebuildLineRows(state);
    applyRowTextColumns(state);
    applyRowCardsVisibility(state);
    applyRowsHelp(state);
    updatePrice(state);
    updateEditor(state);
  }

  // 個別モードの各行（=1枚ごと）のテキスト。入力順そのままを返す（未入力は空文字）。
  function getLineIndividualNames(state, line) {
    return getLineRowTextInputs(state, line).map(function (input) {
      return input.value.trim();
    });
  }

  function getLineSameText(line) {
    return line.text.value.trim();
  }

  function availableColors(state) {
    return state.colorOption && Array.isArray(state.colorOption.values) ? state.colorOption.values : [];
  }

  // 行の色ドット（選択中の色のサムネイル）を更新する。
  function refreshRowColorSwatch(state, select) {
    var dot = select.parentNode ? select.parentNode.querySelector('[data-ua-body-row-color-dot]') : null;
    if (!dot) return;
    var image = getColorImage(state, select.value);
    var url = image ? image.thumbnailUrl : '';
    if (url) {
      dot.style.backgroundImage = 'url("' + url.replace(/"/g, '%22') + '")';
      dot.style.backgroundColor = '';
    } else {
      dot.style.backgroundImage = '';
      dot.style.backgroundColor = 'rgba(0,0,0,0.12)';
    }
  }

  // 行の糸色ドット（選択中の糸色の実色hex丸）を更新する。ボディ色ドット（画像）とは別種。
  function refreshRowThreadSwatch(state, select) {
    var dot = select.parentNode ? select.parentNode.querySelector('[data-ua-body-row-thread-dot]') : null;
    if (!dot) return;
    var hex = THREAD_COLOR_HEX[select.value] || '';
    dot.style.backgroundColor = hex || 'rgba(0,0,0,0.12)';
    dot.setAttribute('data-ua-body-thread-empty', hex ? 'false' : 'true');
  }

  function makeRowField(modifier, labelText) {
    var field = document.createElement('label');
    field.className = 'ua-body-configurator__row-field ua-body-configurator__row-field--' + modifier;
    var label = document.createElement('span');
    label.className = 'ua-body-configurator__row-field-label';
    label.textContent = labelText;
    field.appendChild(label);
    return field;
  }

  function buildLocation2PieceRow(state, index, size, opts) {
    var row = document.createElement('div');
    row.className = 'ua-body-configurator__row';
    row.setAttribute('data-ua-body-piece-size', size);

    var indexLabel = document.createElement('span');
    indexLabel.className = 'ua-body-configurator__row-index';
    indexLabel.textContent = index + 1 + '枚目 ' + size;
    row.appendChild(indexLabel);

    var fields = document.createElement('div');
    fields.className = 'ua-body-configurator__row-fields';
    row.appendChild(fields);

    var name1Field = makeRowField('location2-name', '1行目');
    var name1 = document.createElement('input');
    name1.type = 'text';
    name1.maxLength = 10;
    name1.autocomplete = 'off';
    name1.className = 'ua-body-configurator__input ua-body-configurator__row-name';
    name1.setAttribute('data-ua-body-row-location2-name', '');
    name1.setAttribute('aria-label', index + 1 + '枚目の2箇所目1行目テキスト');
    name1.value = typeof opts.name1 === 'string' ? opts.name1 : '';
    name1.style.fontFamily = '"' + opts.fontFamily + '", sans-serif';
    name1Field.appendChild(name1);
    fields.appendChild(name1Field);

    var name2Field = makeRowField('location2-name2', '2行目');
    var name2 = document.createElement('input');
    name2.type = 'text';
    name2.maxLength = 10;
    name2.autocomplete = 'off';
    name2.className = 'ua-body-configurator__input ua-body-configurator__row-name2';
    name2.setAttribute('data-ua-body-row-location2-name2', '');
    name2.setAttribute('aria-label', index + 1 + '枚目の2箇所目2行目テキスト');
    name2.value = typeof opts.name2 === 'string' ? opts.name2 : '';
    name2.style.fontFamily = '"' + opts.fontFamily + '", sans-serif';
    name2Field.appendChild(name2);
    fields.appendChild(name2Field);

    var threadField = makeRowField('location2-thread', '糸色');
    var threadGroup = document.createElement('div');
    threadGroup.className = 'ua-body-configurator__row-thread';
    var threadDot = document.createElement('span');
    threadDot.className = 'ua-body-configurator__row-thread-dot';
    threadDot.setAttribute('data-ua-body-row-thread-dot', '');
    threadDot.setAttribute('aria-hidden', 'true');
    threadGroup.appendChild(threadDot);
    var threadSelect = document.createElement('select');
    threadSelect.className = 'ua-body-configurator__select ua-body-configurator__row-thread-select';
    threadSelect.setAttribute('data-ua-body-row-location2-thread', '');
    threadSelect.setAttribute('aria-label', index + 1 + '枚目の2箇所目の糸色');
    THREAD_COLORS.forEach(function (threadName) {
      var option = document.createElement('option');
      option.value = threadName;
      option.textContent = threadName;
      threadSelect.appendChild(option);
    });
    threadSelect.value = opts.thread || opts.baseThread || THREAD_COLORS[0];
    if (opts.threadTouched) threadSelect.setAttribute('data-ua-touched', '1');
    threadSelect.addEventListener('change', function () {
      this.setAttribute('data-ua-touched', '1');
      refreshRowThreadSwatch(state, this);
      setEditorEmbroiderySlot(state, '2');
      clearError(state);
      updatePrice(state);
      updateEditor(state);
    });
    threadGroup.appendChild(threadSelect);
    threadField.appendChild(threadGroup);
    fields.appendChild(threadField);
    refreshRowThreadSwatch(state, threadSelect);

    return row;
  }

  // 1枚分のピース行DOMを組み立てる。サイズはマトリクス由来のラベル表示（行では変更不可）。
  // テキスト列（1行目/2行目）・色/糸色列の表示はコンテナのクラスで制御する。
  function buildPieceRow(state, index, size, opts) {
    var row = document.createElement('div');
    row.className = 'ua-body-configurator__row';
    row.setAttribute('data-ua-body-piece-size', size);

    var indexLabel = document.createElement('span');
    indexLabel.className = 'ua-body-configurator__row-index';
    indexLabel.textContent = index + 1 + '枚目 ' + size;
    row.appendChild(indexLabel);

    var fields = document.createElement('div');
    fields.className = 'ua-body-configurator__row-fields';
    row.appendChild(fields);

    // 1行目テキスト
    var name1Field = makeRowField('name', '1行目');
    var name1 = document.createElement('input');
    name1.type = 'text';
    name1.maxLength = 10;
    name1.autocomplete = 'off';
    name1.className = 'ua-body-configurator__input ua-body-configurator__row-name';
    name1.setAttribute('data-ua-body-row-name', '');
    name1.setAttribute('aria-label', index + 1 + '枚目の1行目テキスト');
    if (typeof opts.name1 === 'string') name1.value = opts.name1;
    if (opts.fontFamily) name1.style.fontFamily = '"' + opts.fontFamily + '", sans-serif';
    name1Field.appendChild(name1);
    fields.appendChild(name1Field);

    // 2行目テキスト
    var name2Field = makeRowField('name2', '2行目');
    var name2 = document.createElement('input');
    name2.type = 'text';
    name2.maxLength = 10;
    name2.autocomplete = 'off';
    name2.className = 'ua-body-configurator__input ua-body-configurator__row-name2';
    name2.setAttribute('data-ua-body-row-name2', '');
    name2.setAttribute('aria-label', index + 1 + '枚目の2行目テキスト');
    if (typeof opts.name2 === 'string') name2.value = opts.name2;
    if (opts.fontFamily) name2.style.fontFamily = '"' + opts.fontFamily + '", sans-serif';
    name2Field.appendChild(name2);
    fields.appendChild(name2Field);

    // 2箇所目の個別テキスト（別内容を指定したときだけ列を表示）。
    var location2Name1Field = makeRowField('location2-name', '2箇所目 1行目');
    var location2Name1 = document.createElement('input');
    location2Name1.type = 'text';
    location2Name1.maxLength = 10;
    location2Name1.autocomplete = 'off';
    location2Name1.className = 'ua-body-configurator__input ua-body-configurator__row-name';
    location2Name1.setAttribute('data-ua-body-row-location2-name', '');
    location2Name1.setAttribute('aria-label', index + 1 + '枚目の2箇所目1行目テキスト');
    if (typeof opts.location2Name1 === 'string') location2Name1.value = opts.location2Name1;
    if (opts.location2FontFamily) location2Name1.style.fontFamily = '"' + opts.location2FontFamily + '", sans-serif';
    location2Name1Field.appendChild(location2Name1);
    fields.appendChild(location2Name1Field);

    var location2Name2Field = makeRowField('location2-name2', '2箇所目 2行目');
    var location2Name2 = document.createElement('input');
    location2Name2.type = 'text';
    location2Name2.maxLength = 10;
    location2Name2.autocomplete = 'off';
    location2Name2.className = 'ua-body-configurator__input ua-body-configurator__row-name2';
    location2Name2.setAttribute('data-ua-body-row-location2-name2', '');
    location2Name2.setAttribute('aria-label', index + 1 + '枚目の2箇所目2行目テキスト');
    if (typeof opts.location2Name2 === 'string') location2Name2.value = opts.location2Name2;
    if (opts.location2FontFamily) location2Name2.style.fontFamily = '"' + opts.location2FontFamily + '", sans-serif';
    location2Name2Field.appendChild(location2Name2);
    fields.appendChild(location2Name2Field);

    // ボディ色（色ドット=商品写真サムネイル＋select）
    var colorField = makeRowField('color', 'ボディ色');
    var colorGroup = document.createElement('div');
    colorGroup.className = 'ua-body-configurator__row-color';
    var colorDot = document.createElement('span');
    colorDot.className = 'ua-body-configurator__row-color-dot';
    colorDot.setAttribute('data-ua-body-row-color-dot', '');
    colorDot.setAttribute('aria-hidden', 'true');
    colorGroup.appendChild(colorDot);
    var colorSelect = document.createElement('select');
    colorSelect.className = 'ua-body-configurator__select ua-body-configurator__row-color-select';
    colorSelect.setAttribute('data-ua-body-row-color', '');
    colorSelect.setAttribute('aria-label', index + 1 + '枚目のボディ色');
    opts.colors.forEach(function (colorName) {
      var option = document.createElement('option');
      option.value = colorName;
      option.textContent = colorName;
      colorSelect.appendChild(option);
    });
    var initialColor = typeof opts.color === 'string' && opts.color ? opts.color : opts.baseColor;
    if (initialColor) colorSelect.value = initialColor;
    if (opts.colorTouched) colorSelect.setAttribute('data-ua-touched', '1');
    colorSelect.addEventListener('change', function () {
      this.setAttribute('data-ua-touched', '1');
      refreshRowColorSwatch(state, this);
    });
    colorGroup.appendChild(colorSelect);
    colorField.appendChild(colorGroup);
    fields.appendChild(colorField);
    refreshRowColorSwatch(state, colorSelect);

    // 糸色（糸色ドット=単色hex丸＋select）
    var threadField = makeRowField('thread', '糸色');
    var threadGroup = document.createElement('div');
    threadGroup.className = 'ua-body-configurator__row-thread';
    var threadDot = document.createElement('span');
    threadDot.className = 'ua-body-configurator__row-thread-dot';
    threadDot.setAttribute('data-ua-body-row-thread-dot', '');
    threadDot.setAttribute('aria-hidden', 'true');
    threadGroup.appendChild(threadDot);
    var threadSelect = document.createElement('select');
    threadSelect.className = 'ua-body-configurator__select ua-body-configurator__row-thread-select';
    threadSelect.setAttribute('data-ua-body-row-thread', '');
    threadSelect.setAttribute('aria-label', index + 1 + '枚目の糸色');
    var threadPlaceholder = document.createElement('option');
    threadPlaceholder.value = '';
    threadPlaceholder.textContent = '糸色';
    threadSelect.appendChild(threadPlaceholder);
    THREAD_COLORS.forEach(function (threadName) {
      var option = document.createElement('option');
      option.value = threadName;
      option.textContent = threadName;
      threadSelect.appendChild(option);
    });
    var initialThread = typeof opts.thread === 'string' && opts.thread ? opts.thread : opts.baseThread;
    if (initialThread) threadSelect.value = initialThread;
    if (opts.threadTouched) threadSelect.setAttribute('data-ua-touched', '1');
    threadSelect.addEventListener('change', function () {
      this.setAttribute('data-ua-touched', '1');
      refreshRowThreadSwatch(state, this);
    });
    threadGroup.appendChild(threadSelect);
    threadField.appendChild(threadGroup);
    fields.appendChild(threadField);
    refreshRowThreadSwatch(state, threadSelect);

    // 価格ヒント
    var hint = document.createElement('span');
    hint.className = 'ua-body-configurator__row-hint';
    hint.setAttribute('data-ua-body-row-hint', '');
    row.appendChild(hint);

    return row;
  }

  // 行カード（1枚ごとの例外指定）を、マトリクス由来のピース分だけ生成する。
  // 行カードが不要（共通・同色）なら一切生成しない。値保持はサイズ内の出現順で引き継ぐ。
  function rebuildLineRows(state) {
    var line1 = getLine(state, '1');
    var container = line1.rows;
    if (!container) return;

    // 例外指定がどれも無いときは行カードを出さない。
    if (!rowCardsVisible(state)) {
      container.textContent = '';
      return;
    }

    var total = getMatrixTotal(state);
    var sizes = derivePieceSizes(state);
    // 合計が不正（0 や 100超）のときは行カードを作らない（検証で弾く）。
    if (!state.core.isValidQty(total) || sizes.length !== total) {
      container.textContent = '';
      return;
    }

    // 既存値をサイズ別（サイズ内出現順）に集めて引き継ぐ。
    var prevBySize = collectRowValuesBySize(state);
    var perSizeCursor = {};

    var baseColor = getSelectedColor(state);
    var baseThread = state.elements.threadColor.value;
    var colors = availableColors(state);
    var fontFamily = selectedFontFamily(state);
    var location2FontFamily = fontFamilyForName(state.elements.location2Font.value);

    container.textContent = '';
    sizes.forEach(function (size, index) {
      var cursor = perSizeCursor[size] || 0;
      perSizeCursor[size] = cursor + 1;
      var saved = (prevBySize[size] && prevBySize[size][cursor]) || {};
      container.appendChild(
        buildPieceRow(state, index, size, {
          colors: colors,
          baseColor: baseColor,
          baseThread: baseThread,
          fontFamily: fontFamily,
          name1: saved.name1,
          name2: saved.name2,
          location2Name1: saved.location2Name1,
          location2Name2: saved.location2Name2,
          color: saved.color,
          colorTouched: saved.colorTouched,
          thread: saved.thread,
          threadTouched: saved.threadTouched,
          location2FontFamily: location2FontFamily
        })
      );
    });
  }

  function rebuildLocation2Rows(state) {
    var container = state.elements.location2Rows;
    if (!location2RowCardsVisible(state)) {
      container.textContent = '';
      return;
    }
    var total = getMatrixTotal(state);
    var sizes = derivePieceSizes(state);
    if (!state.core.isValidQty(total) || sizes.length !== total) {
      container.textContent = '';
      return;
    }
    var previous = collectLocation2RowValuesBySize(state);
    var cursors = {};
    var fontFamily = fontFamilyForName(state.elements.location2Font.value);
    var baseThread = state.elements.location2Thread.value;
    container.textContent = '';
    sizes.forEach(function (size, index) {
      var cursor = cursors[size] || 0;
      cursors[size] = cursor + 1;
      var saved = (previous[size] && previous[size][cursor]) || {};
      container.appendChild(
        buildLocation2PieceRow(state, index, size, {
          name1: saved.name1,
          name2: saved.name2,
          fontFamily: fontFamily,
          baseThread: baseThread,
          thread: saved.thread,
          threadTouched: saved.threadTouched
        })
      );
    });
  }

  // メインカラーが変わったとき、未編集（未タッチ）の行のボディ色を追従させる。
  function updateUntouchedRowColors(state) {
    var color = getSelectedColor(state);
    if (!color) return;
    getLineRowColorSelects(state).forEach(function (select) {
      if (select.getAttribute('data-ua-touched') === '1' || select.value === color) return;
      select.value = color;
      refreshRowColorSwatch(state, select);
    });
  }

  // メイン糸色が変わったとき、未編集（未タッチ）の行の糸色を追従させる。
  function updateUntouchedRowThreads(state) {
    var thread = state.elements.threadColor.value;
    if (!thread) return;
    getLineRowThreadSelects(state).forEach(function (select) {
      if (select.getAttribute('data-ua-touched') === '1' || select.value === thread) return;
      select.value = thread;
      refreshRowThreadSwatch(state, select);
    });
  }

  function updateUntouchedLocation2RowThreads(state) {
    var thread = state.elements.location2Thread.value;
    if (!thread) return;
    getLocation2RowThreadSelects(state).forEach(function (select) {
      if (select.getAttribute('data-ua-touched') === '1' || select.value === thread) return;
      select.value = thread;
      refreshRowThreadSwatch(state, select);
    });
  }

  // 進捗は1本に集約。全アクティブ個別行（1行目=常時、2行目=トグルON時）の未入力枚数を表示する。
  function updateProgress(state) {
    var line1 = getLine(state, '1');
    var progress = line1.progress;
    if (!progress) return;

    var quantity = Number(state.elements.quantity.value);
    if (!state.core.isValidQty(quantity)) {
      progress.textContent = '「サイズと枚数」で合計を1〜100枚にしてください';
      return;
    }

    var individualLines = [];
    if (getLineMode(state, line1) === TEXT_MODE_INDIVIDUAL) individualLines.push(line1);
    var line2 = getLine(state, '2');
    if (isLine2Enabled(state) && getLineMode(state, line2) === TEXT_MODE_INDIVIDUAL) {
      individualLines.push(line2);
    }
    if (!individualLines.length) {
      progress.textContent = '';
      return;
    }

    var remaining = 0;
    individualLines.forEach(function (line) {
      var filled = getLineIndividualNames(state, line).filter(function (name) {
        return name.length > 0;
      }).length;
      remaining += Math.max(0, quantity - filled);
    });
    progress.textContent = remaining > 0 ? '残り' + remaining + '枚分のテキストが未入力です' : '入力済み';
  }

  function updateLocation2Progress(state) {
    var progress = state.elements.location2Progress;
    var quantity = Number(state.elements.quantity.value);
    if (!location2RowCardsVisible(state)) {
      progress.textContent = '';
      return;
    }
    if (!state.core.isValidQty(quantity)) {
      progress.textContent = '「サイズと枚数」で合計を1〜100枚にしてください';
      return;
    }
    var individualLines = activeLocation2Lines(state).filter(function (line) {
      return getLineMode(state, line) === TEXT_MODE_INDIVIDUAL;
    });
    if (!individualLines.length) {
      progress.textContent = '';
      return;
    }
    var remaining = 0;
    individualLines.forEach(function (line) {
      var filled = getLineIndividualNames(state, line).filter(function (name) {
        return name.length > 0;
      }).length;
      remaining += Math.max(0, quantity - filled);
    });
    progress.textContent = remaining > 0
      ? '残り' + remaining + '枚分のテキストが未入力です'
      : '入力済み';
  }

  function updateAllLineProgress(state) {
    updateProgress(state);
    updateLocation2Progress(state);
  }

  // ピース行コンテナの列表示クラスを現在のモード/トグルに合わせる。
  // 名前1/名前2＝各行の個別モード時、ボディ色/糸色＝色糸個別トグルON時のみ表示。
  function applyRowTextColumns(state) {
    var container = getLine(state, '1').rows;
    if (!container) return;
    var line1 = getLine(state, '1');
    var line2 = getLine(state, '2');
    var showName1 = getLineMode(state, line1) === TEXT_MODE_INDIVIDUAL;
    var showName2 = isLine2Enabled(state) && getLineMode(state, line2) === TEXT_MODE_INDIVIDUAL;
    var location2Line1 = getLocation2Line(state, '1');
    var location2Line2 = getLocation2Line(state, '2');
    var showLocation2Name1 =
      secondContentDifferent(state) && getLineMode(state, location2Line1) === TEXT_MODE_INDIVIDUAL;
    var showLocation2Name2 =
      isLocation2Line2Enabled(state) && getLineMode(state, location2Line2) === TEXT_MODE_INDIVIDUAL;
    var showAttr = attrIndividualEnabled(state);
    container.classList.toggle('ua-body-configurator__rows--l1-name', showName1);
    container.classList.toggle('ua-body-configurator__rows--l2-name', showName2);
    container.classList.toggle('ua-body-configurator__rows--attr', showAttr);
    // テキスト列が1本だけのときは「1行目」ラベルを出さない（何の欄か迷う余地がないため）。
    // 2列以上（2行目や2箇所目）が同時に出るときだけラベルで区別する。
    var textColumnCount = [showName1, showName2, showLocation2Name1, showLocation2Name2]
      .filter(Boolean).length;
    container.classList.toggle('ua-body-configurator__rows--single-text', textColumnCount === 1);
    state.elements.location2Rows.classList.toggle(
      'ua-body-configurator__rows--single-text',
      showLocation2Name1 && !showLocation2Name2
    );
    state.elements.location2Rows.classList.toggle(
      'ua-body-configurator__rows--location2-l1-name',
      showLocation2Name1
    );
    state.elements.location2Rows.classList.toggle(
      'ua-body-configurator__rows--location2-l2-name',
      showLocation2Name2
    );
    state.elements.location2Rows.classList.toggle(
      'ua-body-configurator__rows--location2-thread',
      location2ThreadIndividualEnabled(state)
    );
  }

  // ピース行の上の共通ヘルプ文言（表示中の列に合わせて調整）。サイズは「サイズと枚数」由来。
  function applyRowsHelp(state) {
    var line1 = getLine(state, '1');
    if (!line1.rowsHelp) return;
    var line2 = getLine(state, '2');
    var cols = [];
    if (getLineMode(state, line1) === TEXT_MODE_INDIVIDUAL) cols.push('1行目テキスト（各1〜10文字）');
    if (isLine2Enabled(state) && getLineMode(state, line2) === TEXT_MODE_INDIVIDUAL) cols.push('2行目テキスト（各1〜10文字）');
    var attr = attrIndividualEnabled(state);
    if (attr) cols.push('ボディ色・糸色');
    var message = cols.length ? '各枚の' + cols.join('・') + 'を指定してください。' : '';
    message += 'サイズは「サイズと枚数」で決めた内訳です。';
    // 引き継ぎの説明は行カード先頭の注記（data-ua-body-rows-note）に集約したのでここでは繰り返さない。
    line1.rowsHelp.textContent = message;
  }

  function applyLocation2RowsHelp(state) {
    var cols = [];
    var line1 = getLocation2Line(state, '1');
    var line2 = getLocation2Line(state, '2');
    if (secondContentDifferent(state) && getLineMode(state, line1) === TEXT_MODE_INDIVIDUAL) {
      cols.push('1行目');
    }
    if (isLocation2Line2Enabled(state) && getLineMode(state, line2) === TEXT_MODE_INDIVIDUAL) {
      cols.push('2行目');
    }
    if (location2ThreadIndividualEnabled(state)) cols.push('糸色');
    state.elements.location2RowsHelp.textContent =
      '2箇所目の各枚の' + cols.join('・') +
      (cols.some(function (col) { return col === '1行目' || col === '2行目'; })
        ? '（テキストは各1〜10文字）'
        : '') +
      'を指定してください。';
  }

  function applyLineModeUi(state, line) {
    var isIndividual = getLineMode(state, line) === TEXT_MODE_INDIVIDUAL;
    var lineActive = line.key === '1' || isLine2Enabled(state);

    // ウィザードでは「全員同じ／1枚ごと」に既定を持たせないので、選ぶまで文字欄を出さない。
    line.sameWrap.hidden = isIndividual || (wizardActive(state) && !getLineMode(state, line));
    line.text.required = lineActive && !isIndividual;
    if (lineActive && !isIndividual) {
      line.text.setAttribute('aria-required', 'true');
    } else {
      line.text.removeAttribute('aria-required');
      line.text.removeAttribute('aria-invalid');
    }

    if (line.hasSize) {
      // 上部（テーマ標準）のサイズ欄は常時非表示（サイズは「サイズと枚数」で指定）。
      applySizePickerVisibility(state);
    }

    // 1行目がピース行リストを所有。モード/トグルに応じて行カードを作り直す。
    rebuildLineRows(state);
    applyRowTextColumns(state);
    applyRowCardsVisibility(state);
    applyRowsHelp(state);
    updateProgress(state);
  }

  function setLineMode(state, line, mode) {
    line.modes.forEach(function (radio) {
      radio.checked = radio.value === mode;
    });
    applyLineModeUi(state, line);
  }

  function applyLine2Enabled(state) {
    state.elements.line2Body.hidden = !isLine2Enabled(state);
    state.elements.lines.forEach(function (line) {
      applyLineModeUi(state, line);
    });
  }

  function applyLocation2LineModeUi(state, line) {
    var isIndividual = getLineMode(state, line) === TEXT_MODE_INDIVIDUAL;
    var lineActive = secondContentDifferent(state) &&
      (line.key === '1' || isLocation2Line2Enabled(state));
    line.sameWrap.hidden = isIndividual || (wizardActive(state) && !getLineMode(state, line));
    line.text.required = lineActive && !isIndividual;
    if (lineActive && !isIndividual) {
      line.text.setAttribute('aria-required', 'true');
    } else {
      line.text.removeAttribute('aria-required');
      line.text.removeAttribute('aria-invalid');
    }
  }

  function setEditorEmbroiderySlot(state, slot) {
    if (slot === '2' && !secondLocationEnabled(state)) slot = '1';
    state.editorEmbroiderySlot = slot === '2' ? '2' : '1';
    // 編集する箇所と、シャツの正面／背面を一緒に切り替える。
    var location = state.editorEmbroiderySlot === '2'
      ? state.elements.location2Select.value
      : state.elements.location.value;
    syncEditorViewForLocation(state, location);
    state.elements.editorSlotButtons.forEach(function (button) {
      button.setAttribute(
        'aria-pressed',
        button.getAttribute('data-ua-body-editor-slot') === state.editorEmbroiderySlot ? 'true' : 'false'
      );
    });
  }

  function location2DefaultValue(state) {
    var primary = state.elements.location.value;
    return state.editorConfig.enabledLocations.find(function (location) {
      return location !== primary;
    }) || '';
  }

  function applyLocationUniqueness(state) {
    var primary = state.elements.location.value;
    Array.prototype.forEach.call(state.elements.location2Select.options, function (option) {
      if (!option.value) return;
      var enabled = state.editorConfig.enabledLocations.indexOf(option.value) !== -1;
      option.disabled = !enabled || option.value === primary;
      option.hidden = !enabled || option.value === primary;
    });
    if (state.elements.location2Select.value === primary) {
      state.elements.location2Select.value = location2DefaultValue(state);
    }
    var location2Value = state.elements.location2Select.value;
    state.elements.location2ChipButtons.forEach(function (chip) {
      var location = chip.getAttribute('data-ua-body-location2-chip');
      var enabled = state.editorConfig.enabledLocations.indexOf(location) !== -1;
      var unavailable = !enabled || location === primary;
      chip.hidden = unavailable;
      chip.disabled = unavailable;
      chip.setAttribute('aria-hidden', unavailable ? 'true' : 'false');
      chip.setAttribute('aria-pressed', location === location2Value ? 'true' : 'false');
    });
  }

  function applyLocation2Ui(state) {
    var enabled = secondLocationEnabled(state);
    var different = secondContentDifferent(state);
    state.elements.location2Add.hidden = enabled;
    state.elements.editorSlots.hidden = !enabled;
    state.elements.location2Different.hidden = !different;
    state.elements.location2Line2Body.hidden = !isLocation2Line2Enabled(state);
    activeLocation2Lines(state).forEach(function (line) {
      applyLocation2LineModeUi(state, line);
    });
    state.elements.location2Lines.forEach(function (line) {
      if (activeLocation2Lines(state).indexOf(line) === -1) applyLocation2LineModeUi(state, line);
    });
    if (!enabled) setEditorEmbroiderySlot(state, '1');
    applyLocationUniqueness(state);
    rebuildLineRows(state);
    rebuildLocation2Rows(state);
    applyRowTextColumns(state);
    applyRowCardsVisibility(state);
    applyLocation2RowCardsVisibility(state);
    applyRowsHelp(state);
    applyLocation2RowsHelp(state);
    updateProgress(state);
    updateLocation2Progress(state);
  }

  function enableSecondLocation(state) {
    state.elements.location2Panel.hidden = false;
    if (!state.elements.location2Select.value) {
      state.elements.location2Select.value = location2DefaultValue(state);
    }
    if (!state.elements.location2Thread.value) {
      state.elements.location2Thread.value = state.elements.threadColor.value || THREAD_COLORS[0];
    }
    applyLocation2Ui(state);
    setEditorEmbroiderySlot(state, '2');
    // 追加直後は2箇所を同時に確認できるよう全体表示へ戻す。
    state.editorPreviewMode = 'full';
    syncEditorViewForLocation(state, state.elements.location2Select.value);
  }

  function disableSecondLocation(state) {
    state.elements.location2Panel.hidden = true;
    setEditorEmbroiderySlot(state, '1');
    applyLocation2Ui(state);
    syncEditorViewForLocation(state, state.elements.location.value);
  }

  function getSelectedColor(state) {
    var select = resolveColorSelect(state);
    return select ? select.value : '';
  }

  // 色×サイズ→ボディvariant {variantId, price}。config.variantsByColor（商品メタフィールド由来・{id,price}）で解決。
  function resolveSizeVariant(state, color, size) {
    var byColor = state.config.variantsByColor;
    if (!byColor || typeof byColor !== 'object' || !color || !size) return null;
    var sizes = byColor[color];
    if (!sizes || typeof sizes !== 'object') return null;
    var entry = sizes[size];
    if (!entry || typeof entry !== 'object') return null;
    var id = Number(entry.id);
    var price = Number(entry.price);
    if (!Number.isSafeInteger(id) || id <= 0 || !Number.isFinite(price) || price < 0) return null;
    return { variantId: id, price: price };
  }

  function hasVariantsByColor(state) {
    var byColor = state.config.variantsByColor;
    return !!byColor && typeof byColor === 'object' && !Array.isArray(byColor) && Object.keys(byColor).length > 0;
  }

  // 上部（テーマ標準）のサイズ選択欄のラッパー要素。
  function getSizeControlRow(state) {
    var control = getCurrentSizeSelection(state).control;
    if (!control) return null;
    return control.closest('.product-form__input') || control.closest('fieldset') || control;
  }

  // 旧「サイズは各行で…」案内は廃止（サイズ指定は先頭の「サイズと枚数」カードに一本化）。
  // 既に挿入済みのノードがあれば除去する。
  function removeSizeIndividualNote(state) {
    var note = state.sizeIndividualNote;
    if (note && note.parentNode) note.parentNode.removeChild(note);
    state.sizeIndividualNote = null;
    return note;
  }

  // 上部（テーマ標準）のサイズ欄は両モードとも常時非表示にし、案内文を出す。
  // サイズselectの値は保持したまま display:none にするので、テーマのvariant解決・価格・在庫表示は壊れない。
  function applySizePickerVisibility(state) {
    var row = getSizeControlRow(state);
    if (!row) return;
    // テーマ標準のサイズ欄は値を保持したまま常時非表示（variant解決は壊さない）。案内文は出さない。
    row.style.display = 'none';
    row.setAttribute('data-ua-body-size-hidden', 'true');
    removeSizeIndividualNote(state);
  }

  function applyLocationAvailability(state) {
    var enabledLocations = state.editorConfig.enabledLocations;
    Array.prototype.forEach.call(state.elements.location.options, function (option) {
      if (!option.value) return;
      var enabled = enabledLocations.indexOf(option.value) !== -1;
      option.disabled = !enabled;
      option.hidden = !enabled;
    });
    state.elements.chips.forEach(function (chip) {
      var location = chip.getAttribute('data-ua-body-location-chip');
      var enabled = enabledLocations.indexOf(location) !== -1;
      chip.hidden = !enabled;
      chip.disabled = !enabled;
      chip.setAttribute('aria-hidden', enabled ? 'false' : 'true');
    });
    Array.prototype.forEach.call(state.elements.location2Select.options, function (option) {
      if (!option.value) return;
      var enabled = enabledLocations.indexOf(option.value) !== -1;
      option.disabled = !enabled;
      option.hidden = !enabled;
    });
    applyLocationUniqueness(state);
  }

  function setLocation(state, value) {
    if (value && state.editorConfig.enabledLocations.indexOf(value) === -1) value = '';
    state.elements.location.value = value;
    state.elements.chips.forEach(function (chip) {
      chip.setAttribute('aria-pressed', chip.getAttribute('data-ua-body-location-chip') === value ? 'true' : 'false');
    });
    applyLocationUniqueness(state);
  }

  function setThreadColor(state, value) {
    state.elements.threadColor.value = value;
    state.elements.threadColorChipButtons.forEach(function (chip) {
      chip.setAttribute('aria-pressed', chip.getAttribute('data-ua-body-thread-color-chip') === value ? 'true' : 'false');
    });
    state.elements.threadColorChips.removeAttribute('aria-invalid');
    // メイン糸色の変更を未編集（未タッチ）の行の糸色に追従させる。
    updateUntouchedRowThreads(state);
  }

  function fontFamilyForName(font) {
    return FONT_FAMILIES[font] || FONT_FAMILIES['角ゴシック'];
  }

  function selectedFontFamily(state) {
    return fontFamilyForName(state.elements.font.value);
  }

  function setFontPickerOpen(state, open) {
    state.elements.fontOptions.hidden = !open;
    state.elements.fontTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) loadAllFontPreviews(state);
  }

  function syncFontPicker(state) {
    var font = state.elements.font.value;
    var family = fontFamilyForName(font);
    state.elements.fontSelected.textContent = '選択中';
    state.elements.fontTrigger.setAttribute('aria-label', '書体：' + (font || '未選択'));
    state.elements.fontSelectedSample.textContent = font || '書体を選択';
    state.elements.fontSelectedSample.style.fontFamily = '"' + family + '", sans-serif';
    state.elements.lines.forEach(function (line) {
      line.text.style.fontFamily = '"' + family + '", sans-serif';
    });
    Array.prototype.slice.call(
      pieceRowsContainer(state).querySelectorAll('[data-ua-body-row-name], [data-ua-body-row-name2]')
    ).forEach(function (input) {
      input.style.fontFamily = '"' + family + '", sans-serif';
    });
    var location2Family = fontFamilyForName(state.elements.location2Font.value);
    state.elements.location2Lines.forEach(function (line) {
      line.text.style.fontFamily = '"' + location2Family + '", sans-serif';
    });
    Array.prototype.slice.call(
      state.elements.location2Rows.querySelectorAll(
        '[data-ua-body-row-location2-name], [data-ua-body-row-location2-name2]'
      )
    ).forEach(function (input) {
      input.style.fontFamily = '"' + location2Family + '", sans-serif';
    });
    state.elements.fontChips.forEach(function (button) {
      var selected = button.getAttribute('data-ua-body-font-chip') === font;
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    state.elements.fontSamples.forEach(function (element) {
      element.textContent = element.closest('[data-ua-body-font-chip]').getAttribute('data-ua-body-font-chip');
    });
  }

  function loadAllFontPreviews(state) {
    if (!state.fontPreviewsActivated) {
      state.fontPreviewsActivated = true;
      state.elements.fontChips.forEach(function (button) {
        var font = button.getAttribute('data-ua-body-font-chip');
        var sample = button.querySelector('[data-ua-body-font-sample]');
        sample.style.fontFamily = '"' + fontFamilyForName(font) + '", sans-serif';
      });
    }
    if (!document.fonts || typeof document.fonts.load !== 'function') return;
    Promise.all(FONTS.map(function (font) {
      return document.fonts.load('1em "' + fontFamilyForName(font) + '"');
    })).then(function () {
      syncFontPicker(state);
    }).catch(function () {
      // Individual choices keep their readable fallback if a font cannot load.
    });
  }

  function loadSelectedFont(state) {
    if (!document.fonts || typeof document.fonts.load !== 'function') return;
    document.fonts.load('1em "' + selectedFontFamily(state) + '"').then(function () {
      updateEditor(state);
    }).catch(function () {
      // The browser keeps the fallback visible; validation and ordering can continue.
    });
  }

  function getCurrentVariantId(state) {
    resolveForm(state);
    if (!state.variantInput) return null;

    var variantId = Number(state.variantInput.value);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) return null;
    return variantId;
  }

  function setColorPendingState(state, pending) {
    if (pending) {
      state.root.setAttribute('data-ua-body-color-pending', 'true');
      if (state.colorPicker) state.colorPicker.setAttribute('aria-busy', 'true');
      return;
    }

    state.root.removeAttribute('data-ua-body-color-pending');
    if (state.colorPicker) state.colorPicker.removeAttribute('aria-busy');
  }

  function beginColorVariantResolution(state, color) {
    state.colorVariantPending = {
      color: color,
      initialVariantId: getCurrentVariantId(state)
    };
    setColorPendingState(state, true);
  }

  function finishColorVariantResolution(state) {
    if (!state.colorVariantPending) return;

    state.colorVariantPending = null;
    setColorPendingState(state, false);
    state.variantWaiters.splice(0).forEach(function (waiter) {
      window.clearTimeout(waiter.timeoutId);
      window.clearInterval(waiter.pollId);
      waiter.resolve();
    });
  }

  function maybeFinishColorVariantResolution(state) {
    if (!state.colorVariantPending) return;

    var variantId = getCurrentVariantId(state);
    if (variantId && variantId !== state.colorVariantPending.initialVariantId) {
      finishColorVariantResolution(state);
    }
  }

  function waitForColorVariantResolution(state) {
    maybeFinishColorVariantResolution(state);
    if (!state.colorVariantPending) return Promise.resolve();

    return new Promise(function (resolve, reject) {
      var waiter = { resolve: resolve, timeoutId: null, pollId: null };
      waiter.pollId = window.setInterval(function () {
        maybeFinishColorVariantResolution(state);
      }, 50);
      waiter.timeoutId = window.setTimeout(function () {
        window.clearInterval(waiter.pollId);
        var index = state.variantWaiters.indexOf(waiter);
        if (index !== -1) state.variantWaiters.splice(index, 1);
        reject(new Error('variant-resolution-timeout'));
      }, VARIANT_RESOLUTION_TIMEOUT_MS);
      state.variantWaiters.push(waiter);
    });
  }

  function colorPickerFocusTarget(state) {
    if (!state.colorPickerButtons) return state.variantInput;

    return (
      state.colorPickerButtons.find(function (button) {
        return button.getAttribute('aria-pressed') === 'true';
      }) || state.colorPickerButtons[0] || state.variantInput
    );
  }

  function getSizeFieldset(state) {
    var productInfo = state.mount ? state.mount.closest('product-info') : null;
    if (!productInfo) return null;

    var fieldsets = productInfo.querySelectorAll('fieldset');
    return (
      Array.prototype.find.call(fieldsets, function (fieldset) {
        var radios = fieldset.querySelectorAll('input[type="radio"]');
        return Array.prototype.some.call(radios, function (radio) {
          return Object.prototype.hasOwnProperty.call(state.config.sizePrices, radio.value);
        });
      }) || null
    );
  }

  function getVariantSelects(state) {
    var productInfo = state.mount ? state.mount.closest('product-info') : null;
    var variantSelects = productInfo ? productInfo.querySelector('variant-selects') : null;
    return variantSelects || document.querySelector('variant-selects');
  }

  function getColorOption(state) {
    if (!Array.isArray(state.config.productOptions)) return null;

    return (
      state.config.productOptions.find(function (option) {
        var name = typeof option.name === 'string' ? option.name.replace(/\s+/g, '').toLowerCase() : '';
        return name === 'カラー' || name === '色' || name === 'color' || name === 'colour';
      }) || null
    );
  }

  function resolveColorSelect(state) {
    var variantSelects = getVariantSelects(state);
    if (!variantSelects || !state.colorOption) return null;

    var selects = Array.prototype.slice.call(variantSelects.querySelectorAll('select'));
    var expectedName = 'options[' + state.colorOption.name + ']';
    var select =
      selects.find(function (candidate) {
        return candidate.getAttribute('name') === expectedName;
      }) || selects[Number(state.colorOption.position) - 1] || null;

    if (!select) return null;

    var nativeRow = select.closest('.product-form__input') || select;
    nativeRow.classList.add('ua-body-color-picker__native');
    state.colorSelect = select;
    return select;
  }

  function getImageUrlAtWidth(imageUrl, width) {
    if (typeof imageUrl !== 'string' || !imageUrl) return '';

    try {
      var url = new URL(imageUrl, window.location.href);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return imageUrl;
    }
  }

  function getColorImage(state, color) {
    var image = state.config.colorImages && state.config.colorImages[color];
    if (typeof image === 'string') {
      return {
        thumbnailUrl: getImageUrlAtWidth(image, 100),
        imageUrl: getImageUrlAtWidth(image, 1000),
        backImageUrl: ''
      };
    }
    if (!image || typeof image !== 'object') return null;

    var thumbnailSource = image.thumbnailUrl || image.imageUrl || '';
    var imageSource = image.imageUrl || image.thumbnailUrl || '';
    return {
      thumbnailUrl: getImageUrlAtWidth(thumbnailSource, 100),
      imageUrl: getImageUrlAtWidth(imageSource, 1000),
      backImageUrl: getImageUrlAtWidth(image.backImageUrl || '', 1000)
    };
  }

  function getGalleryImageUrlByAlt(alt) {
    var images = document.querySelectorAll('media-gallery img[alt]');
    var image = Array.prototype.find.call(images, function (candidate) {
      return candidate.alt.trim() === alt;
    });
    return image ? image.currentSrc || image.src || '' : '';
  }

  function deriveBackImageUrl(frontImageUrl) {
    if (!frontImageUrl) return '';
    var backImageUrl = frontImageUrl.replace(/([_-])front(?=[_.-])/i, '$1back');
    return backImageUrl === frontImageUrl ? '' : backImageUrl;
  }

  // 仕上がりイメージは選択中の行を映す。色糸個別ONのときは1枚目の行カードの値、
  // それ以外/未選択のときはメイン選択にフォールバックする（テーマのvariant/ギャラリーは変更しない）。
  function getFirstPieceRow(state) {
    var container = pieceRowsContainer(state);
    if (!container) return null;
    return container.querySelectorAll('.ua-body-configurator__row')[editorPersonIndex(state)] || null;
  }

  function getFirstPieceBodyColor(state) {
    var mainColor = getSelectedColor(state);
    if (!attrIndividualEnabled(state)) return mainColor;
    var row = getFirstPieceRow(state);
    var el = row ? row.querySelector('[data-ua-body-row-color]') : null;
    return el && el.value ? el.value : mainColor;
  }

  function getFirstPieceThreadColor(state) {
    var mainThread = state.elements.threadColor.value;
    if (!attrIndividualEnabled(state)) return mainThread;
    var row = getFirstPieceRow(state);
    var el = row ? row.querySelector('[data-ua-body-row-thread]') : null;
    return el && el.value ? el.value : mainThread;
  }

  function getFirstLocation2ThreadColor(state) {
    var baseThread = state.elements.location2Thread.value;
    if (!location2ThreadIndividualEnabled(state)) return baseThread;
    var select = getLocation2RowThreadSelects(state)[editorPersonIndex(state)];
    return select && select.value ? select.value : baseThread;
  }

  function getEditorImageSources(state) {
    var color = getFirstPieceBodyColor(state);
    var colorImage = getColorImage(state, color);
    var frontImageUrl = colorImage ? colorImage.imageUrl : '';
    var backImageUrl = colorImage ? colorImage.backImageUrl : '';

    frontImageUrl = getGalleryImageUrlByAlt(color) || frontImageUrl;
    backImageUrl =
      getGalleryImageUrlByAlt(color + '（背面）') ||
      getGalleryImageUrlByAlt(color + '(背面)') ||
      backImageUrl ||
      deriveBackImageUrl(frontImageUrl);

    return {
      color: color,
      front: getImageUrlAtWidth(frontImageUrl, 1000),
      back: getImageUrlAtWidth(backImageUrl, 1000)
    };
  }

  function setEditorImageSource(image, source) {
    if (!image) return;
    if (!source) {
      image.removeAttribute('src');
      return;
    }
    if (image.getAttribute('src') === source) return;
    image.src = source;
  }

  // シャツ上プレビュー用の代表テキスト。個別モードは選択中の人（両行とも同じルール）。
  function getEditorPreviewNameForLine(state, lineKey) {
    var line = getLine(state, lineKey);
    return getEditorPreviewNameForLineObject(state, line);
  }

  function getEditorPreviewNameForLineObject(state, line) {
    if (getLineMode(state, line) === TEXT_MODE_INDIVIDUAL) {
      return getLineIndividualNames(state, line)[editorPersonIndex(state)] || '';
    }
    return getLineSameText(line);
  }

  function getEditorPreviewName(state) {
    return getEditorPreviewNameForLine(state, '1');
  }

  // プレビューSVGの文字を1〜2行で描画する。1行=縦中央、2行=行間を空けてスタック。
  // primaryNode/secondaryNode は editor か magnifier の <text> ペア。
  function paintPreviewLines(primaryNode, secondaryNode, opts) {
    var lines = opts.lines;
    var twoLine = lines.length === 2;
    var cx = opts.widthCm / 2;
    var cy = opts.heightCm / 2;
    var spacing = opts.charHeightCm + 0.35; // 行間（中心間距離・cm）
    var ys = twoLine ? [cy - spacing / 2, cy + spacing / 2] : [cy];

    function paint(node, text, y) {
      node.textContent = text;
      node.style.fontFamily = '"' + opts.fontFamily + '", sans-serif';
      node.setAttribute('x', String(cx));
      node.setAttribute('y', String(y));
      node.setAttribute('font-size', String(opts.fontSize));
      node.setAttribute('textLength', String(Array.from(text).length * opts.charWidthCm));
    }

    paint(primaryNode, lines[0], ys[0]);
    if (twoLine) {
      paint(secondaryNode, lines[1], ys[1]);
    } else {
      secondaryNode.textContent = '';
      secondaryNode.removeAttribute('textLength');
    }
  }

  function setEditorView(state, view) {
    if (view !== 'front' && view !== 'back') return;
    state.editorView = view;
    updateEditor(state);
  }

  function syncEditorPreviewModeForText(state, isPlaceholder) {
    var hasText = !isPlaceholder;
    if (!state.editorPreviewHasText && hasText) {
      state.editorPreviewMode = 'zoom';
    } else if (state.editorPreviewHasText && !hasText) {
      state.editorPreviewMode = 'full';
    }
    state.editorPreviewHasText = hasText;
  }

  function updateEditorPreviewDisplay(state, renderPosition, source, hasMessage) {
    var elements = state.elements;
    var stage = elements.editorStage;
    var canvas = elements.editorCanvas;
    var canZoom = Boolean(source && renderPosition && !hasMessage);
    var isZoom = canZoom && state.editorPreviewMode === 'zoom';

    stage.setAttribute('data-preview-mode', isZoom ? 'zoom' : 'full');
    elements.editorPreviewToggle.hidden = !source;
    elements.editorPreviewToggle.disabled = !canZoom;
    setEditorImageSource(elements.editorPreviewToggleImage, source);
    if (renderPosition) {
      elements.editorPreviewToggle.style.setProperty('--ua-body-toggle-target-x', renderPosition.x + '%');
      elements.editorPreviewToggle.style.setProperty('--ua-body-toggle-target-y', renderPosition.y + '%');
    }

    if (isZoom) {
      var rect = stage.getBoundingClientRect();
      var width = rect.width || stage.clientWidth;
      var height = rect.height || stage.clientHeight;
      var translateX = width / 2 - width * renderPosition.x / 100 * EDITOR_ZOOM;
      var translateY = height / 2 - height * renderPosition.y / 100 * EDITOR_ZOOM;
      canvas.style.transform =
        'translate3d(' + translateX + 'px, ' + translateY + 'px, 0) scale(' + EDITOR_ZOOM + ')';
      elements.editorPreviewToggleLabel.textContent = '全体';
      elements.editorPreviewToggle.setAttribute('aria-label', 'シャツ全体を見る');
    } else {
      canvas.style.transform = 'translate3d(0, 0, 0) scale(1)';
      elements.editorPreviewToggleLabel.textContent = 'アップ';
      elements.editorPreviewToggle.setAttribute('aria-label', '刺繍部分をアップで見る');
    }
    return isZoom;
  }

  function syncEditorViewForLocation(state, location) {
    var position = state.editorConfig.positions[location];
    if (position) state.editorView = position.view;
  }

  function hideMagnifier(state) {
    state.elements.magnifier.classList.remove('is-visible');
    state.elements.magnifier.hidden = true;
  }

  function moveMagnifier(state, clientX, clientY) {
    var elements = state.elements;
    if (!MAGNIFIER_ENABLED || state.editorPreviewMode === 'zoom') {
      hideMagnifier(state);
      return;
    }
    var source = elements.editorImage.currentSrc || elements.editorImage.src;
    var rect = elements.editorStage.getBoundingClientRect();
    if (!source || !rect.width || !rect.height) {
      hideMagnifier(state);
      return;
    }

    var x = Math.max(0, Math.min(rect.width, clientX - rect.left));
    var y = Math.max(0, Math.min(rect.height, clientY - rect.top));
    var lens = elements.magnifier;
    lens.hidden = false;
    var lensSize = lens.offsetWidth;
    lens.style.left = x + 'px';
    lens.style.top = y + 'px';
    lens.style.backgroundImage = 'url("' + source.replace(/"/g, '%22') + '")';
    lens.style.backgroundSize = rect.width * MAGNIFIER_ZOOM + 'px ' + rect.height * MAGNIFIER_ZOOM + 'px';
    lens.style.backgroundPosition =
      lensSize / 2 - x * MAGNIFIER_ZOOM + 'px ' +
      (lensSize / 2 - y * MAGNIFIER_ZOOM) + 'px';

    var placement = state.magnifierPlacement;
    if (placement) {
      var frame = elements.magnifierFrame;
      frame.style.left = lensSize / 2 + (rect.width * placement.x / 100 - x) * MAGNIFIER_ZOOM + 'px';
      frame.style.top = lensSize / 2 + (rect.height * placement.y / 100 - y) * MAGNIFIER_ZOOM + 'px';
      frame.style.width = rect.width * placement.width / 100 * MAGNIFIER_ZOOM + 'px';
      frame.style.height = rect.height * placement.height / 100 * MAGNIFIER_ZOOM + 'px';
      frame.hidden = false;
    } else {
      elements.magnifierFrame.hidden = true;
    }

    window.requestAnimationFrame(function () {
      lens.classList.add('is-visible');
    });
  }

  function setupMagnifier(state) {
    var stage = state.elements.editorStage;
    if (!MAGNIFIER_ENABLED) {
      hideMagnifier(state);
      return;
    }

    stage.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'mouse') moveMagnifier(state, event.clientX, event.clientY);
    });
    stage.addEventListener('pointermove', function (event) {
      if (event.pointerType === 'mouse' || state.magnifierTouchPinned) {
        moveMagnifier(state, event.clientX, event.clientY);
      }
    });
    stage.addEventListener('pointerleave', function (event) {
      if (event.pointerType === 'mouse') hideMagnifier(state);
    });
    stage.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse') return;
      state.magnifierTouchPinned = true;
      moveMagnifier(state, event.clientX, event.clientY);
    });
    stage.addEventListener('pointercancel', function () {
      state.magnifierTouchPinned = false;
      hideMagnifier(state);
    });
    document.addEventListener('pointerdown', function (event) {
      if (!state.magnifierTouchPinned || stage.contains(event.target)) return;
      state.magnifierTouchPinned = false;
      hideMagnifier(state);
    }, true);
    window.addEventListener('resize', function () {
      state.magnifierTouchPinned = false;
      hideMagnifier(state);
    });
  }

  function setupAdminShortcut(state) {
    var shortcut = state.elements.adminShortcut;

    document.addEventListener('keydown', function (event) {
      if (!state.root.isConnected || event.repeat) return;

      if (event.key === 'Escape' && !shortcut.hidden) {
        shortcut.hidden = true;
        return;
      }

      if (!event.altKey || !event.shiftKey || event.code !== 'KeyE') return;

      event.preventDefault();
      var shouldReveal = shortcut.hidden;
      shortcut.hidden = !shouldReveal;
      if (shouldReveal) shortcut.focus({ preventScroll: true });
    });
  }

  function compactProductSizeChart(state) {
    var productInfo = state.mount ? state.mount.closest('product-info') : null;
    var description = productInfo
      ? productInfo.querySelector('.product__description')
      : document.querySelector('.product__description');
    if (!description || description.querySelector('[data-ua-body-size-chart]')) return;

    var sizeRows = [];
    var headings = Array.prototype.slice.call(description.querySelectorAll('h4'));
    for (var headingIndex = 0; headingIndex < headings.length; headingIndex++) {
      var heading = headings[headingIndex];
      var compactText = heading.textContent.replace(/[\s\u00a0\u3000]+/g, '');
      var match = compactText.match(
        /^(XXXXL|XXXL|XXL|XL|XS|S|M|L)身丈(\d+)身幅(\d+)肩幅(\d+)袖丈(\d+)$/
      );
      if (!match) {
        if (sizeRows.length) break;
        continue;
      }
      sizeRows.push({
        node: heading,
        size: match[1],
        length: match[2],
        width: match[3],
        shoulder: match[4],
        sleeve: match[5]
      });
    }
    if (sizeRows.length < 3) return;

    var wrap = document.createElement('div');
    wrap.className = 'ua-body-size-chart';
    wrap.setAttribute('data-ua-body-size-chart', '');
    var table = document.createElement('table');
    table.setAttribute('aria-label', 'サイズ表（単位センチメートル）');
    var thead = document.createElement('thead');
    var headRow = document.createElement('tr');
    ['サイズ', '身丈', '身幅', '肩幅', '袖丈'].forEach(function (label) {
      var th = document.createElement('th');
      th.scope = 'col';
      th.textContent = label;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    table.appendChild(thead);
    var tbody = document.createElement('tbody');
    sizeRows.forEach(function (row) {
      var tr = document.createElement('tr');
      [row.size, row.length, row.width, row.shoulder, row.sleeve].forEach(function (value) {
        var td = document.createElement('td');
        td.textContent = value;
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    wrap.appendChild(table);
    var unit = document.createElement('p');
    unit.className = 'ua-body-size-chart__unit';
    unit.textContent = '単位：cm';
    wrap.appendChild(unit);

    // 既定は閉じる。ファーストビューでサイズ表が最も目立つ状態を避け、
    // 「刺繍が頼める」情報を上に出すため（開閉状態の永続化はしない）。
    var details = document.createElement('details');
    details.className = 'ua-body-size-chart-details';
    details.setAttribute('data-ua-body-size-chart-details', '');
    var summary = document.createElement('summary');
    summary.className = 'ua-body-size-chart__summary';
    // サイズ範囲はパース結果から作る（商品ごとに展開が違うためハードコードしない）。
    var firstSize = sizeRows[0].size;
    var lastSize = sizeRows[sizeRows.length - 1].size;
    summary.textContent = firstSize && lastSize && firstSize !== lastSize
      ? 'サイズ詳細を見る（' + firstSize + '〜' + lastSize + '）'
      : 'サイズ詳細を見る';
    details.appendChild(summary);
    details.appendChild(wrap);

    var firstRow = sizeRows[0].node;
    firstRow.parentNode.insertBefore(details, firstRow);
    sizeRows.forEach(function (row) { row.node.remove(); });
    var unitHeading = Array.prototype.find.call(description.querySelectorAll('h4'), function (heading) {
      return /単位\s*[:：]\s*cm/i.test(heading.textContent.replace(/[（）()]/g, ''));
    });
    if (unitHeading) unitHeading.remove();
  }

  // 商品タイトル直下に「刺繍が頼める」ことを1行で出す。ファーストビューに刺繍の語が
  // 一度も出ないままサイズ表が最も目立っていたため、その手前に置く。
  function insertTitleLead(state) {
    var productInfo = state.mount ? state.mount.closest('product-info') : null;
    if (!productInfo) return;
    var existing = productInfo.querySelector('[data-ua-body-title-lead]');
    if (existing) existing.remove();

    var title = productInfo.querySelector('.product__title');
    if (!title || !title.parentNode) return;

    var price = minPiecePrice(state);
    var lead = document.createElement('p');
    lead.className = 'ua-body-configurator__title-lead';
    lead.setAttribute('data-ua-body-title-lead', '');
    // 金額はUSPチップと同じ算出。出せないときは金額部分を省く（誤った金額を出さない）。
    lead.textContent = price === null
      ? '名入れ刺繍込みで注文できます'
      : '名入れ刺繍込みで注文できます。10枚以上なら1枚 ¥' + yenFormatter.format(price) + '〜';
    title.parentNode.insertBefore(lead, title.nextSibling);
  }

  function getEditorSlotPreview(state, slot) {
    if (slot === '2' && !secondLocationEnabled(state)) return null;
    var useDifferent = slot === '2' && secondContentDifferent(state);
    var line1 = useDifferent ? getLocation2Line(state, '1') : getLine(state, '1');
    var line2 = useDifferent ? getLocation2Line(state, '2') : getLine(state, '2');
    var line2Enabled = useDifferent ? isLocation2Line2Enabled(state) : isLine2Enabled(state);
    var name1 = getEditorPreviewNameForLineObject(state, line1);
    var name2 = line2Enabled ? getEditorPreviewNameForLineObject(state, line2) : '';
    var isPlaceholder = !name1 && !name2;
    var location = slot === '2'
      ? state.elements.location2Select.value
      : state.elements.location.value;
    var font = useDifferent
      ? state.elements.location2Font.value
      : state.elements.font.value;
    var threadColor = useDifferent
      ? getFirstLocation2ThreadColor(state)
      : getFirstPieceThreadColor(state);
    return {
      slot: slot,
      location: location,
      position: state.editorConfig.positions[location] || null,
      line1: line1,
      line2Enabled: line2Enabled,
      isPlaceholder: isPlaceholder,
      renderedLines: isPlaceholder
        ? ['ABCDEFGH']
        : [name1, name2].filter(function (line) { return line; }),
      font: font,
      fontFamily: fontFamilyForName(font),
      threadColor: threadColor,
      threadColorHex: THREAD_COLOR_HEX[threadColor] || '#222222'
    };
  }

  function paintEditorSlotPreview(state, preview, frame, name, text1, text2, view, allowPlaceholder) {
    if (
      !preview ||
      !preview.position ||
      preview.position.view !== view ||
      (preview.isPlaceholder && !allowPlaceholder)
    ) {
      frame.hidden = true;
      return false;
    }
    var position = preview.position;
    var fontSize = Math.round(state.editorConfig.characterHeightCm * CHARACTER_HEIGHT_RENDER_SCALE * 100) / 100;
    var opts = {
      lines: preview.renderedLines,
      fontFamily: preview.fontFamily,
      fontSize: fontSize,
      charWidthCm: state.editorConfig.characterWidthCm,
      charHeightCm: state.editorConfig.characterHeightCm,
      widthCm: position.widthCm,
      heightCm: position.heightCm
    };
    name.setAttribute('viewBox', '0 0 ' + position.widthCm + ' ' + position.heightCm);
    name.setAttribute('aria-label', preview.isPlaceholder ? '名前の入力例' : preview.renderedLines.join(' / '));
    name.setAttribute('data-placeholder', preview.isPlaceholder ? 'true' : 'false');
    name.setAttribute('data-light-thread', preview.threadColor === 'しろ' ? 'true' : 'false');
    name.style.setProperty('--ua-body-preview-thread-color', preview.threadColorHex);
    frame.setAttribute('data-placeholder', preview.isPlaceholder ? 'true' : 'false');
    frame.setAttribute('data-ua-body-preview-slot', preview.slot);
    frame.style.setProperty('--ua-body-preview-x', position.x + '%');
    frame.style.setProperty('--ua-body-preview-y', position.y + '%');
    frame.style.setProperty('--ua-body-preview-width', position.width + '%');
    frame.style.setProperty('--ua-body-preview-height', position.height + '%');
    paintPreviewLines(text1, text2, opts);
    frame.hidden = false;
    return true;
  }

  function updateEditor(state) {
    var elements = state.elements;
    syncEditorPersonPicker(state);
    var sources = getEditorImageSources(state);
    var primaryPreview = getEditorSlotPreview(state, '1');
    var secondaryPreview = getEditorSlotPreview(state, '2');
    var selectedPreview =
      state.editorEmbroiderySlot === '2' && secondaryPreview ? secondaryPreview : primaryPreview;
    syncEditorPreviewModeForText(state, selectedPreview.isPlaceholder);

    var view = state.editorView === 'back' ? 'back' : 'front';
    state.magnifierPlacement = null;
    hideMagnifier(state);
    syncFontPicker(state);
    if (!sources[view]) view = sources.front ? 'front' : 'back';
    state.editorView = view;
    elements.editor.setAttribute('data-view', view);
    elements.editor.setAttribute('data-active-slot', selectedPreview.slot);

    setEditorImageSource(elements.editorImage, sources[view]);
    setEditorImageSource(elements.editorPreviewToggleImage, sources[view]);
    setEditorImageSource(elements.editorFrontThumbnail, sources.front);
    setEditorImageSource(elements.editorBackThumbnail, sources.back);
    elements.editorImage.alt = sources.color ? sources.color + 'の' + (view === 'back' ? '背面' : '正面') : '';

    elements.editorViewButtons.forEach(function (button) {
      var buttonView = button.getAttribute('data-ua-body-editor-view');
      button.setAttribute('aria-pressed', buttonView === view ? 'true' : 'false');
      button.disabled = !sources[buttonView];
    });

    var primaryPainted = paintEditorSlotPreview(
      state,
      primaryPreview,
      elements.editorFrame,
      elements.editorName,
      elements.editorNameText,
      elements.editorNameText2,
      view,
      true
    );
    var secondaryPainted = paintEditorSlotPreview(
      state,
      secondaryPreview,
      elements.editorFrame2,
      elements.editorName2,
      elements.editorName2Text,
      elements.editorName2Text2,
      view,
      false
    );

    var renderPosition = selectedPreview.position;
    var selectedMatchesView = !!renderPosition && renderPosition.view === view;
    var message = '';
    if (!sources[view]) {
      message = 'シャツ画像を読み込めませんでした';
    } else if (!renderPosition) {
      message = '刺繍箇所を選択してください';
    } else if (!selectedMatchesView && !primaryPainted && !secondaryPainted) {
      message = '選択した刺繍箇所は' + (renderPosition.view === 'back' ? '背面' : '正面') + 'です';
    }

    var isZoom = updateEditorPreviewDisplay(
      state,
      renderPosition,
      sources[view],
      Boolean(message) || !selectedMatchesView
    );
    if (isZoom) {
      elements.editorFrame.hidden = selectedPreview.slot !== '1' || !primaryPainted;
      elements.editorFrame2.hidden = selectedPreview.slot !== '2' || !secondaryPainted;
    } else {
      elements.editorFrame.hidden = !primaryPainted;
      elements.editorFrame2.hidden = !secondaryPainted;
    }

    if (selectedMatchesView) {
      var magnifierOpts = {
        lines: selectedPreview.renderedLines,
        fontFamily: selectedPreview.fontFamily,
        fontSize: Math.round(state.editorConfig.characterHeightCm * CHARACTER_HEIGHT_RENDER_SCALE * 100) / 100,
        charWidthCm: state.editorConfig.characterWidthCm,
        charHeightCm: state.editorConfig.characterHeightCm,
        widthCm: renderPosition.widthCm,
        heightCm: renderPosition.heightCm
      };
      elements.magnifierName.setAttribute('viewBox', '0 0 ' + renderPosition.widthCm + ' ' + renderPosition.heightCm);
      elements.magnifierName.style.setProperty('--ua-body-preview-thread-color', selectedPreview.threadColorHex);
      elements.magnifierName.setAttribute('data-light-thread', selectedPreview.threadColor === 'しろ' ? 'true' : 'false');
      paintPreviewLines(elements.magnifierNameText, elements.magnifierNameText2, magnifierOpts);
      state.magnifierPlacement = {
        x: renderPosition.x,
        y: renderPosition.y,
        width: renderPosition.width,
        height: renderPosition.height
      };
    }

    var anyFrameVisible = !elements.editorFrame.hidden || !elements.editorFrame2.hidden;
    elements.editorMessage.textContent = message;
    elements.editorMessage.hidden = !message || anyFrameVisible;

    var summary = [sources.color || 'カラー未選択', view === 'back' ? '背面' : '正面'];
    summary.push(selectedPreview.location || '位置未選択');
    summary.push(selectedPreview.font || '書体未選択');
    summary.push(selectedPreview.threadColor || '糸色未選択');
    if (!state.editorPersonLabel.hidden) summary.push((editorPersonIndex(state) + 1) + '枚目');
    if (selectedPreview.line2Enabled) summary.push('2行');
    if (secondaryPreview) summary.unshift(selectedPreview.slot + '箇所目');
    elements.editorSummary.textContent = summary.join(' / ');
    setEditorImageSource(elements.compactImage, sources[view]);
    elements.compactImage.alt = elements.editorImage.alt;
    elements.compactName.textContent =
      (selectedPreview.isPlaceholder ? '' : selectedPreview.renderedLines.join(' ')) ||
      '刺繍する文字を入力してください';
    elements.compactName.style.color = selectedPreview.threadColorHex;
    elements.compactName.style.fontFamily = '"' + selectedPreview.fontFamily + '", sans-serif';
    elements.compactSummary.textContent = summary.join(' / ');
  }

  function scheduleEditorSync(state) {
    window.requestAnimationFrame(function () {
      updateEditor(state);
    });
    window.clearTimeout(state.editorSyncTimer);
    state.editorSyncTimer = window.setTimeout(function () {
      updateEditor(state);
    }, 180);
  }

  // モバイル・ミニプレビューバーの「閉じた」状態はセッション内で永続化する（プライベートモードでも落ちない）。
  function readMinibarDismissed() {
    try {
      return window.sessionStorage.getItem(MINIBAR_DISMISS_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function writeMinibarDismissed() {
    try {
      window.sessionStorage.setItem(MINIBAR_DISMISS_KEY, '1');
    } catch (error) {
      // sessionStorage不可の環境では state のフラグだけで当該表示中は抑止する。
    }
  }

  // モバイルの仕上がりイメージ折りたたみ。閉じているのはCSS（max-width:749px）だけで、
  // デスクトップは常に開いた状態＝追従プレビューの挙動は一切変えない。
  function setEditorCollapsed(state, collapsed) {
    if (!state.elements.editorToggle) return;
    state.editorCollapsed = !!collapsed;
    state.root.classList.toggle('ua-body-configurator--editor-collapsed', state.editorCollapsed);
    state.elements.editorToggle.textContent = state.editorCollapsed ? '仕上がりを見る' : '仕上がりを閉じる';
    state.elements.editorToggle.setAttribute('aria-expanded', state.editorCollapsed ? 'false' : 'true');
    // 閉じている間は display:none で採寸できないため、開いた直後に再描画して
    // ズーム変換（stage の実寸依存）を正しい値で計算し直す。
    if (!state.editorCollapsed) scheduleEditorSync(state);
  }

  function setupEditorCollapse(state) {
    var toggle = state.elements.editorToggle;
    // ボタンが無い（古いliquidがキャッシュされている等）ときは折りたたみ自体を使わない。
    // 開く手段が無いまま閉じてしまうのを避けるため、ここは fail-open にする。
    if (!toggle) {
      state.editorCollapsed = false;
      return;
    }
    setEditorCollapsed(state, true); // 既定は閉じる（実際に閉じて見えるのはモバイルのみ）
    toggle.addEventListener('click', function () {
      setEditorCollapsed(state, !state.editorCollapsed);
    });
  }

  function setupResponsiveEditorLayout(state) {
    var productInfo = state.mount.closest('product-info');
    var mediaWrapper = productInfo ? productInfo.querySelector('.product__media-wrapper') : null;
    var editor = state.elements.editor;
    if (!mediaWrapper || !editor || typeof window.matchMedia !== 'function') return;

    state.minibarDismissed = readMinibarDismissed();
    state.rootInView = false;

    var existingSlot = mediaWrapper.querySelector('[data-ua-body-preview-slot]');
    if (existingSlot) existingSlot.remove();

    var slot = document.createElement('div');
    slot.className = 'ua-body-configurator__desktop-preview-slot';
    slot.setAttribute('data-ua-body-preview-slot', '');
    slot.hidden = true;
    mediaWrapper.appendChild(slot);

    // 在庫表示の直後に「余白フィラー」を用意する。デスクトップでは高さを実測して右カラム
    // （コンフィギュレーターカード）を下げ、左の仕上がりイメージ枠と上辺を揃える。
    // 空でもスペーサーとして機能。将来ここにフィラーコンテンツを入れる。
    var existingFiller = document.querySelector('[data-ua-body-gap-filler]');
    if (existingFiller) existingFiller.remove();
    var gapFiller = document.createElement('div');
    gapFiller.className = 'ua-body-configurator__gap-filler';
    gapFiller.setAttribute('data-ua-body-gap-filler', '');
    // テーマの :empty ルールで非表示にされないよう、空でも中身の入れ物を1つ持たせる（USPチップ用）。
    var gapFillerInner = document.createElement('div');
    gapFillerInner.className = 'ua-body-configurator__gap-filler-inner';
    gapFillerInner.setAttribute('data-ua-body-gap-filler-inner', '');
    // USPチップ（¥360〜 / 発送 / チーム注文）を liquid の <template> から差し込む。デスクトップのみ表示。
    var uspTemplate = document.querySelector('[data-ua-body-usp-chips]');
    if (uspTemplate && uspTemplate.content) {
      gapFillerInner.appendChild(uspTemplate.content.cloneNode(true));
      applyUspMinPriceChip(state, gapFillerInner);
    }
    gapFiller.appendChild(gapFillerInner);
    var inventoryEl = document.querySelector('.product__inventory') ||
      (state.mount ? state.mount.closest('.product__info-container, .product__info-wrapper') : null);
    var invAnchor = document.querySelector('.product__inventory');
    if (invAnchor && invAnchor.parentNode) {
      invAnchor.parentNode.insertBefore(gapFiller, invAnchor.nextSibling);
    } else if (state.mount && state.mount.parentNode) {
      state.mount.parentNode.insertBefore(gapFiller, state.mount);
    }
    state.gapFiller = gapFiller;

    // モバイル用USPチップ。gap-filler はデスクトップ専用（上辺揃え用・モバイルは高さ0/非表示）なので、
    // モバイルでは在庫表示の直後の通常フローに 2×2 で別途表示する（CSSでデスクトップ非表示＝二重表示なし）。
    var existingUspMobile = document.querySelector('[data-ua-body-usp-mobile]');
    if (existingUspMobile) existingUspMobile.remove();
    var uspMobile = document.createElement('div');
    uspMobile.className = 'ua-body-configurator__usp-mobile';
    uspMobile.setAttribute('data-ua-body-usp-mobile', '');
    if (uspTemplate && uspTemplate.content) {
      uspMobile.appendChild(uspTemplate.content.cloneNode(true));
      applyUspMinPriceChip(state, uspMobile);
    }
    gapFiller.parentNode.insertBefore(uspMobile, gapFiller.nextSibling);
    state.uspMobile = uspMobile;

    var anchor = document.createComment('ua-body-editor-anchor');
    editor.parentNode.insertBefore(anchor, editor);
    var compactAnchor = document.createComment('ua-body-compact-anchor');
    state.elements.compactPreview.parentNode.insertBefore(
      compactAnchor,
      state.elements.compactPreview
    );
    // Dawn switches the product page to two columns at 750px. Use the same
    // breakpoint so the preview never falls back into the right column while
    // an empty media column is still visible.
    var desktopMedia = window.matchMedia('(min-width: 750px)');
    var desktopGeometryFrame = 0;
    var desktopGeometryTimer = 0;

    function documentTop(element) {
      return element.getBoundingClientRect().top + window.scrollY;
    }

    function syncDesktopAlignment() {
      if (!desktopMedia.matches || slot.hidden) return;

      // Start from the slot's natural position, then match the editor card to
      // the configurator card. Their preceding content wraps differently at
      // each viewport width, so a fixed margin cannot keep the tops aligned.
      slot.style.marginTop = '0px';
      var requiredMargin = documentTop(state.root) - documentTop(slot);
      // 上方向には引き上げない（負マージンだとプレビューがメディアギャラリーの下端に被るため 0 でクランプ）。
      slot.style.marginTop = Math.max(0, Math.round(requiredMargin * 10) / 10) + 'px';
    }

    function syncDesktopSlotHeight() {
      if (!desktopMedia.matches) return;
      var rootRect = state.root.getBoundingClientRect();
      var slotRect = slot.getBoundingClientRect();
      var availableHeight = rootRect.bottom - slotRect.top;
      slot.style.minHeight = Math.max(editor.offsetHeight, availableHeight) + 'px';
    }

    var geometryRunning = false;
    // 最終安全弁（サーキットブレーカー）: 何らかの環境要因（例: dpr=2 のサブピクセル振動で
    // editor リサイズ→ResizeObserver→再同期がフレームをまたいで連鎖）で geometry sync が
    // 毎フレーム走り続けた場合、追従機能を自動的に無効化してフリーズを回避する。
    // 「フリーズより機能停止（プレビューは通常スクロール）」を選ぶ。
    var followDisabled = false;
    var geometryTimestamps = [];
    // 直近1000msでこの回数を超え、かつ「ユーザー操作が無い」状態が続いたら暴走とみなす。
    // ユーザー操作（スクロール/リサイズ/入力）ごとにカウンタをリセットするので、リサイズドラッグ等の
    // 正当な高頻度同期では作動しない。作動するのは「無操作なのに毎フレーム同期が続く＝フリーズ兆候」のみ。
    var GEOMETRY_RUNAWAY_LIMIT = 24;
    function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
    function noteUserInteraction() { geometryTimestamps.length = 0; }
    function tripFollowBreakerIfRunaway() {
      var t = now();
      geometryTimestamps.push(t);
      while (geometryTimestamps.length && t - geometryTimestamps[0] > 1000) geometryTimestamps.shift();
      if (!followDisabled && geometryTimestamps.length > GEOMETRY_RUNAWAY_LIMIT) {
        followDisabled = true;
        resetEditorFollow(); // editor を通常フロー(static)に戻す
        try { if (typeof desktopGeometryObserver !== 'undefined' && desktopGeometryObserver) desktopGeometryObserver.disconnect(); } catch (e) {}
        try { state.root.setAttribute('data-ua-body-follow-disabled', '1'); } catch (e) {}
        if (window.console && console.warn) {
          console.warn('[ua-body] 追従サーキットブレーカー作動: 無操作で1秒内に geometry sync ' + geometryTimestamps.length + ' 回。追従を無効化しフリーズを回避（プレビューは通常スクロール）。');
        }
      }
    }
    function syncDesktopGeometry() {
      if (!desktopMedia.matches) return;
      // 再入ガード：測定中に ResizeObserver 等から再入すると正帰還ループになりうる。
      if (geometryRunning) return;
      geometryRunning = true;
      try {
        tripFollowBreakerIfRunaway();
        // ウィザードは1画面1問なので、追従プレビュー（fixed/absolute の3状態）・可動域確保の
        // slot 高さ・固定バーは要らない＝止めたままにする。
        // ただし2カラムである以上「左のプレビューと右のカードの上辺が揃っていない」のは
        // ただのズレなので、上辺揃え（slot の marginTop ＋ 在庫直後フィラー）だけは動かす。
        syncDesktopAlignment();
        syncGapAlign();
        if (wizardActive(state)) return;
        syncDesktopSlotHeight();
        if (!followDisabled) syncDesktopFollow();
        // 購入バーはサーキットブレーカーの外側で同期する（追従を止めてもバーは出す）。
        syncPurchaseBar();
      } finally {
        geometryRunning = false;
      }
    }
    function isGeometryRunning() { return geometryRunning; }

    function scheduleDesktopGeometry() {
      window.cancelAnimationFrame(desktopGeometryFrame);
      window.clearTimeout(desktopGeometryTimer);
      desktopGeometryFrame = window.requestAnimationFrame(function () {
        syncDesktopGeometry();
        desktopGeometryTimer = window.setTimeout(syncDesktopGeometry, 180);
      });
    }

    // 画面下の固定購入バー。表示条件（コンフィギュレーターが画面内にある間）はモバイルの既存挙動を踏襲し、
    // デスクトップではコンフィギュレーター列の左端・幅に合わせて配置する。
    // こうすると左カラムの追従プレビューとは水平方向に重ならないので、追従の3状態計算に手を入れずに済む。
    //
    // 呼び出し経路は意図的に4本ある（このテーマはスクロールコンテナが window とは限らず、
    // どれか1本が届かなくてもバーが出ないままにならないようにするため）:
    //   ① window/document(capture) の scroll → syncCompactVisibility
    //   ② scheduleFollow の rAF（スクロールごと・サーキットブレーカーの影響を受けない）
    //   ③ syncDesktopGeometry（resize / ResizeObserver / レイアウト切替）
    //   ④ IntersectionObserver（スクロールイベントが我々に届かない環境の最後の砦）
    var purchaseBarGeometry = { left: null, width: null };

    // 本体の購入ボタン（テーマのフォームの submit）が画面内に見えている間は、同じ文言・同じ機能の
    // 固定バーを引っ込める（同じボタンが縦に2つ並ぶのを避ける）。隠すのはバー側だけで、
    // 本体ボタンは実際の送信経路とアクセシビリティを担うため触らない。
    // 画面端で ON/OFF が往復しないよう、入るとき(ENTER)と出るとき(EXIT)でしきい値を変える。
    var NATIVE_SUBMIT_ENTER = 64; // これだけ画面内に入って初めて「見えている」
    var NATIVE_SUBMIT_EXIT = 8;   // ほぼ画面外に出るまで「見えている」を維持
    var nativeSubmitVisible = false;
    function syncNativeSubmitVisibility() {
      var button = state.submitButton;
      if (!button || !button.isConnected) {
        // バリアント変更でテーマがフォームを差し替えると参照が外れるので取り直す。
        resolveForm(state);
        button = state.submitButton;
      }
      if (!button) {
        nativeSubmitVisible = false;
        return false;
      }
      var buttonRect = button.getBoundingClientRect();
      // fail-closed（ガードで購入フォームごと display:none）のときは 0×0 ＝「見えていない」扱いにし、
      // バーの表示条件には影響させない。
      if (!buttonRect.width && !buttonRect.height) {
        nativeSubmitVisible = false;
        return false;
      }
      // 画面下から入ってきたか。入るとき/出るときでしきい値を変えて端での往復を防ぐ。
      var margin = nativeSubmitVisible ? NATIVE_SUBMIT_EXIT : NATIVE_SUBMIT_ENTER;
      nativeSubmitVisible =
        buttonRect.top < window.innerHeight - margin && buttonRect.bottom > NATIVE_SUBMIT_ENTER;
      // 本体ボタンを上へ通り過ぎた後もバーは出さない。ここで出すと、root の可視判定
      // （IntersectionObserver）が非同期で1フレーム遅れる分だけバーが一瞬復活して消える
      // ＝速いスクロールで点滅になる。しきい値を ENTER で揃えてあるので、
      // 「通り過ぎた」と「見えている」の間に隙間はできない（上下どちらの向きでも連続）。
      var passedAbove = buttonRect.bottom <= NATIVE_SUBMIT_ENTER;
      return nativeSubmitVisible || passedAbove;
    }

    function syncPurchaseBar(rootRect) {
      var bar = state.elements.purchaseBar;
      if (!bar) return;
      if (wizardActive(state)) {
        // ウィザードは各ステップに操作列を持つので固定バーは出さない。
        bar.classList.remove('is-visible');
        return;
      }
      var rect = rootRect || state.root.getBoundingClientRect();
      if (desktopMedia.matches) {
        // 毎スクロールで同値を書き戻さない（不要な style 変異でObserverを起こさないため）。
        var left = Math.round(rect.left);
        var width = Math.round(rect.width);
        if (purchaseBarGeometry.left !== left || purchaseBarGeometry.width !== width) {
          bar.style.left = left + 'px';
          bar.style.width = width + 'px';
          purchaseBarGeometry = { left: left, width: width };
        }
      } else if (purchaseBarGeometry.left !== null) {
        bar.style.left = '';
        bar.style.width = '';
        purchaseBarGeometry = { left: null, width: null };
      }
      // 実測rectとIntersectionObserverの和で判定する。片方の経路が届かなくても表示側に倒す。
      // ただし本体の購入ボタンが見えているなら、そちらを使ってもらいバーは引っ込める。
      var rectInView = rect.top < window.innerHeight && rect.bottom > 0;
      var inView = rectInView || state.rootInView === true;
      bar.classList.toggle('is-visible', inView && !syncNativeSubmitVisibility());
    }

    function syncCompactVisibility() {
      var rootRect = state.root.getBoundingClientRect();
      syncPurchaseBar(rootRect);

      // デスクトップは sticky editor があるのでミニバーは常に非表示。
      // ウィザード中もプレビューが各ステップ内にあるので出さない。
      if (wizardActive(state) || desktopMedia.matches) {
        state.elements.compactPreview.classList.remove('is-visible');
        state.elements.compactPreview.setAttribute('aria-hidden', 'true');
        return;
      }

      var editorRect = editor.getBoundingClientRect();
      // コンフィギュレーター領域が画面内にあるか（IntersectionObserverがあればそれを優先）。
      var rootInView = typeof window.IntersectionObserver === 'function'
        ? state.rootInView
        : rootRect.top < window.innerHeight && rootRect.bottom > 0;
      // フルプレビューカードを上へスクロールし終えたら（重複回避）ミニバーを出す。
      var pastEditor = editorRect.bottom < 72;
      var visible = !state.minibarDismissed && rootInView && pastEditor;
      state.elements.compactPreview.classList.toggle('is-visible', visible);
      state.elements.compactPreview.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    // 追従の上端オフセット（テーマの sticky ヘッダーに隠れない値）。
    function getFollowTop() {
      var base = 20;
      try {
        var header = document.querySelector(
          'sticky-header, .header-wrapper--sticky, .shopify-section-header-sticky, .section-header.animate--sticky'
        );
        if (header) {
          var hs = window.getComputedStyle(header);
          if (hs.position === 'sticky' || hs.position === 'fixed') {
            base = Math.round(header.getBoundingClientRect().height) + 12;
          }
        }
        var cssTop = window.getComputedStyle(editor).getPropertyValue('--ua-body-sticky-top');
        var parsed = parseFloat(cssTop);
        if (Number.isFinite(parsed) && /rem$/.test(cssTop.trim())) parsed = parsed * 10;
        if (Number.isFinite(parsed) && parsed > base) base = parsed;
      } catch (error) {
        // フォールバックは既定の 20px。
      }
      return base;
    }

    // 追従の最終適用値スナップショット（ヒステリシス判定用）。
    var followState = { mode: 'static', top: 0, left: 0, width: 0 };
    function pxNear(a, b) { return Math.abs(a - b) < 1; }

    function resetEditorFollow() {
      editor.style.position = '';
      editor.style.top = '';
      editor.style.left = '';
      editor.style.right = '';
      editor.style.bottom = '';
      editor.style.width = '';
      followState = { mode: 'static', top: 0, left: 0, width: 0 };
    }

    // 追従スタイルの適用。ヒステリシス付き：同じモードで数値差が1px未満なら DOM を書き換えない。
    // dpr=2 のサブピクセル振動で editor の width/left が毎フレーム微差で書き換わり、
    // editor リサイズ→ResizeObserver→再同期 の連鎖（フリーズ）を起こすのを断つ。
    function applyEditorFollow(mode, top, left, width) {
      if (mode === followState.mode &&
        pxNear(top, followState.top) && pxNear(left, followState.left) && pxNear(width, followState.width)) {
        return; // 変化が1px未満＝書き換えない
      }
      if (mode === 'static') {
        resetEditorFollow();
        return;
      }
      if (mode === 'fixed') {
        editor.style.position = 'fixed';
        editor.style.top = Math.round(top) + 'px';
        editor.style.left = Math.round(left) + 'px';
        editor.style.width = Math.round(width) + 'px';
        editor.style.right = '';
        editor.style.bottom = '';
      } else { // absolute（可動域下端でクランプ）
        editor.style.position = 'absolute';
        editor.style.top = 'auto';
        editor.style.bottom = '0';
        editor.style.left = '0';
        editor.style.right = 'auto';
        editor.style.width = '100%';
      }
      followState = { mode: mode, top: top, left: left, width: width };
    }

    // sticky が engage しないテーマ構成のため、JS で position:fixed/absolute の3状態追従を再現する。
    // 判定は slot.getBoundingClientRect()（viewport基準で信頼できる）で行う。
    function syncDesktopFollow() {
      try {
        if (wizardActive(state)) return; // ウィザード中は追従しない（プレビューは通常フロー）
        if (followDisabled) return; // サーキットブレーカー作動後は追従しない（editorはstatic）
        if (!desktopMedia.matches || slot.hidden) {
          applyEditorFollow('static', 0, 0, 0);
          return;
        }
        var slotRect = slot.getBoundingClientRect();
        var editorH = editor.offsetHeight;
        var topOffset = getFollowTop();

        if (slotRect.top >= topOffset - 0.5) {
          applyEditorFollow('static', 0, 0, 0); // 通常フロー：まだ本来の位置
        } else if (slotRect.bottom - editorH > topOffset) {
          applyEditorFollow('fixed', topOffset, slotRect.left, slotRect.width); // 画面上部に固定追従
        } else {
          applyEditorFollow('absolute', 0, 0, 0); // 可動域下端でクランプ
        }
      } catch (error) {
        resetEditorFollow();
      }
    }

    var followFrame = 0;
    function scheduleFollow() {
      if (followFrame) return;
      followFrame = window.requestAnimationFrame(function () {
        followFrame = 0;
        syncDesktopFollow();
        // 追従が無効化されていてもバーは同期する（scroll経路②）。
        syncPurchaseBar();
      });
    }

    // 右カラム（コンフィギュレーターカード）の上辺を、左のプレビュー枠の上辺に揃える。
    // 左は動かさず、在庫直後のフィラーの高さで右を下げる（0以上でクランプ＝上げない）。
    // USPチップの自然な所要高さ（フィラー高さの下限）。デスクトップのみ。チップが揃えに必要な
    // 隙間より高い場合は、上辺揃えより「チップを収める」を優先する（＝コンフィギュレーターが少し下がる）。
    function uspFloorHeight() {
      if (!desktopMedia.matches || slot.hidden) return 0;
      if (!gapFillerInner) return 0;
      return gapFillerInner.offsetHeight || 0;
    }

    function setFillerHeight(px) {
      var filler = state.gapFiller;
      if (!filler) return;
      // 揃えに必要な高さと、チップの所要高さの大きい方を採用（チップがはみ出て隣接カードに被らない）。
      var effective = Math.max(px, uspFloorHeight());
      // テーマの :empty 等で display:none にされないよう明示。min-height を主に使う。
      // テーマのブロック間 margin を打ち消して純粋なスペーサーにする（揃えの過剰押し下げ防止）。
      filler.style.setProperty('display', 'block', 'important');
      filler.style.setProperty('margin', '0', 'important');
      filler.style.minHeight = effective + 'px';
      filler.style.height = effective + 'px';
    }

    // 揃え計算に使う editor の「自然位置(static時)」上端。
    // 重要: editor の style を一切変異させない（変異すると editor を監視する ResizeObserver が
    // 発火し、+180ms トレーリング同期が自分を再スケジュールする自己持続ループ＝フリーズを招く）。
    // editor は static のとき slot 上端に位置する（slot: position:relative / editor: margin:0）。
    // そのオフセットを static のときだけ実測してキャッシュし、追従中(fixed/absolute)は
    // キャッシュ値を使って slot 上端から自然位置を算出する（slot は決して追従状態にならない）。
    var editorSlotOffset = 0;
    function refreshEditorSlotOffset() {
      var pos = editor.style.position;
      if (pos === '' || pos === 'static') {
        editorSlotOffset = editor.getBoundingClientRect().top - slot.getBoundingClientRect().top;
      }
    }
    function editorNaturalTop() {
      return slot.getBoundingClientRect().top + editorSlotOffset;
    }

    // フィラー高さを1px増やしても root が正確に1px下がるとは限らない（margin collapse 等で
    // 一定オフセットが乗る）。実測しながら補正し、両枠の上辺を ±1px に収束させる。
    // 反復は「同一タスク内の上限付き for ループ（最大6回）」。observed 要素を変異させないため
    // ループ中に ResizeObserver は発火せず、必ず有限回で終わる（暴走・フリーズしない）。
    // さらに発散ガード（上限 cap）で誤測定時は前回値を維持して打ち切る。
    function syncGapAlign() {
      var filler = state.gapFiller;
      if (!filler) return;
      if (!desktopMedia.matches || slot.hidden) {
        setFillerHeight(0);
        return;
      }
      refreshEditorSlotOffset();
      var floor = uspFloorHeight();
      var current = 0;
      setFillerHeight(0);
      // 発散ガードの上限：初期ギャップ（filler=0時の必要隙間）＋チップ高＋余裕。
      var initialDiff = editorNaturalTop() - state.root.getBoundingClientRect().top;
      var cap = Math.max(floor, Math.round(initialDiff)) + floor + 120;
      for (var i = 0; i < 6; i++) {
        var diff = editorNaturalTop() - state.root.getBoundingClientRect().top;
        if (Math.abs(diff) <= 1) break;
        var next = Math.max(0, Math.round((current + diff) * 10) / 10);
        if (next > cap) {
          // 発散ガード発動：前回値を維持し、一度だけ警告してループを抜ける（自壊しない）。
          if (!state._gapCapWarned) {
            if (window.console && console.warn) {
              console.warn('[ua-body] gap-align 発散ガード: 要求', next, 'を上限', cap, 'で打ち切り、前回値', current, 'を維持');
            }
            state._gapCapWarned = true;
          }
          setFillerHeight(current);
          break;
        }
        current = next;
        setFillerHeight(current);
      }
    }

    function syncLayout() {
      // 購入バーはデスクトップでも固定表示するため、常に body 直下に置く
      // （祖先の transform/filter などで position:fixed の基準がずれるのを避ける）。
      if (state.elements.purchaseBar.parentNode !== document.body) {
        document.body.appendChild(state.elements.purchaseBar);
      }
      // ウィザードモード：止めるのは追従（fixed/absolute）と固定バーだけで、
      // 仕上がりイメージ自体は常に見せる（刺繍の注文で仕上がりが見えないのは致命的）。
      // デスクトップは左カラムに通常フローで置き（上辺は現行フォームと同じ仕組みで揃える）、
      // モバイルは質問の直下に置く（1カラムなので揃えるものがない＝フィラーは0）。
      if (wizardActive(state) && state.elements.wizardPreviewSlot) {
        if (desktopMedia.matches) {
          slot.hidden = false;
          if (editor.parentNode !== slot) slot.appendChild(editor);
          state.elements.wizardPreviewSlot.hidden = true;
          mediaWrapper.style.alignSelf = 'flex-start';
        } else {
          state.elements.wizardPreviewSlot.hidden = false;
          if (editor.parentNode !== state.elements.wizardPreviewSlot) {
            state.elements.wizardPreviewSlot.appendChild(editor);
          }
          slot.hidden = true;
          mediaWrapper.style.alignSelf = '';
        }
        state.root.classList.remove('ua-body-configurator--desktop-split');
        // 追従しないので可動域を確保する必要がない＝slot は中身（プレビュー）ぶんの高さに戻す。
        slot.style.minHeight = '';
        resetEditorFollow();
        if (desktopMedia.matches) {
          scheduleDesktopGeometry();
        } else {
          slot.style.marginTop = '';
          setFillerHeight(0);
        }
        syncCompactVisibility();
        scheduleEditorSync(state);
        return;
      }
      if (desktopMedia.matches) {
        slot.hidden = false;
        slot.appendChild(editor);
        compactAnchor.parentNode.insertBefore(
          state.elements.compactPreview,
          compactAnchor.nextSibling
        );
        state.root.classList.add('ua-body-configurator--desktop-split');
        // メディア列が情報列の高さに引き伸ばされないようにする（gapフィラーで情報列が伸びても
        // ギャラリー/プレビューの位置が動かない＝上辺揃えの計算がフィードバックで発散しない）。
        mediaWrapper.style.alignSelf = 'flex-start';
        scheduleDesktopGeometry();
      } else {
        anchor.parentNode.insertBefore(editor, anchor.nextSibling);
        document.body.appendChild(state.elements.compactPreview);
        slot.hidden = true;
        state.root.classList.remove('ua-body-configurator--desktop-split');
        slot.style.minHeight = '';
        mediaWrapper.style.alignSelf = '';
        resetEditorFollow();
        setFillerHeight(0);
      }
      syncCompactVisibility();
      scheduleEditorSync(state);
    }

    state.elements.compactOpen.addEventListener('click', function () {
      // 閉じたままスクロールしても何も見えないので、先に開いてから移動する。
      if (state.editorCollapsed) {
        setEditorCollapsed(state, false);
        window.requestAnimationFrame(function () {
          editor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        return;
      }
      editor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    // ミニバーの × は「このセッション中は再表示しない」。バーのタップ（スクロール）とは分離する。
    state.elements.compactDismiss.addEventListener('click', function (event) {
      event.stopPropagation();
      state.minibarDismissed = true;
      writeMinibarDismissed();
      state.elements.compactPreview.classList.remove('is-visible');
      state.elements.compactPreview.setAttribute('aria-hidden', 'true');
    });
    // コンフィギュレーター領域の可視状態は IntersectionObserver で監視（スクロール毎のrect計測を軽減）。
    if (typeof window.IntersectionObserver === 'function') {
      var rootVisibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === state.root) state.rootInView = entry.isIntersecting;
        });
        syncCompactVisibility();
      }, { threshold: 0 });
      rootVisibilityObserver.observe(state.root);
    }
    window.addEventListener('scroll', syncCompactVisibility, { passive: true });
    // スクロールコンテナがこのテーマでは body の可能性があるため、capture でどの要素の scroll も拾う。
    document.addEventListener('scroll', function () {
      noteUserInteraction();
      scheduleFollow();
      syncCompactVisibility();
    }, { passive: true, capture: true });
    window.addEventListener('resize', function () {
      noteUserInteraction();
      syncCompactVisibility();
      scheduleDesktopGeometry();
      scheduleFollow();
    }, { passive: true });
    // ユーザー操作でサーキットブレーカーのカウンタをリセット（正当な高頻度同期での誤作動防止）。
    document.addEventListener('pointerdown', noteUserInteraction, { passive: true, capture: true });
    document.addEventListener('keydown', noteUserInteraction, { passive: true, capture: true });
    if (typeof window.ResizeObserver === 'function') {
      // ノイズフィルタ付き Observer。
      // ・測定中(geometryRunning)のコールバックは無視（再入ループ遮断）。
      // ・1px 未満のサイズ変化は無視（dpr=2 のサブピクセル振動を弾く）。
      // ・editor は width を自分で設定するため、editor の「幅だけの変化」は無視し、
      //   高さ変化（内容増減）のみ意味あり扱いにする＝自作の width 書き込みが自分を再発火させない。
      var roSizes = new WeakMap();
      var desktopGeometryObserver = new ResizeObserver(function (entries) {
        if (isGeometryRunning()) return;
        var meaningful = false;
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          var box = entry.contentRect;
          var prev = roSizes.get(entry.target);
          roSizes.set(entry.target, { w: box.width, h: box.height });
          if (!prev) { meaningful = true; continue; }
          var dw = Math.abs(box.width - prev.w);
          var dh = Math.abs(box.height - prev.h);
          if (entry.target === editor) {
            if (dh >= 1) meaningful = true; // 幅だけの変化は無視
          } else if (dw >= 1 || dh >= 1) {
            meaningful = true;
          }
        }
        if (meaningful) scheduleDesktopGeometry();
      });
      var gallery = mediaWrapper.querySelector('media-gallery');
      if (gallery) desktopGeometryObserver.observe(gallery);
      desktopGeometryObserver.observe(state.root);
      desktopGeometryObserver.observe(editor);
    }
    state.elements.editorImage.addEventListener('load', scheduleDesktopGeometry);
    // ウィザードのON/OFFでレイアウトを切り替え直すため、外から呼べるようにしておく。
    state.syncLayout = syncLayout;
    // ステップが変わると右カードの中身が総入れ替えになるので、上辺揃えを引き直せるようにしておく。
    state.scheduleDesktopGeometry = scheduleDesktopGeometry;
    if (typeof desktopMedia.addEventListener === 'function') {
      desktopMedia.addEventListener('change', syncLayout);
    } else {
      desktopMedia.addListener(syncLayout);
    }
    syncLayout();
  }

  function syncColorPicker(state) {
    var select = resolveColorSelect(state);
    if (!select || !state.colorPickerLabel) return;

    var color = select.value;
    state.colorPickerLabel.textContent = color;
    state.colorPickerButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-ua-body-color') === color ? 'true' : 'false');
    });
  }

  function normalizeColorName(value) {
    return String(value || '').replace(/\s+/g, '').toLowerCase();
  }

  function getFeaturedColors(config, availableColors) {
    var normalizedAvailable = new Map();
    availableColors.forEach(function (color) {
      normalizedAvailable.set(normalizeColorName(color), color);
    });

    var configuredColors = Array.isArray(config.featuredColors) ? config.featuredColors : [];
    if (configuredColors.length) {
      return configuredColors.reduce(function (featured, configuredColor) {
        var actualColor = normalizedAvailable.get(normalizeColorName(configuredColor));
        if (actualColor && featured.indexOf(actualColor) === -1) featured.push(actualColor);
        return featured;
      }, []);
    }

    var featured = [];
    FEATURED_COLOR_RULES.forEach(function (candidates) {
      var actualColor = candidates.reduce(function (match, candidate) {
        return match || normalizedAvailable.get(normalizeColorName(candidate));
      }, null);
      if (actualColor && featured.indexOf(actualColor) === -1) featured.push(actualColor);
    });

    availableColors.some(function (color) {
      if (featured.length >= Math.min(FEATURED_COLOR_LIMIT, availableColors.length)) return true;
      if (featured.indexOf(color) === -1) featured.push(color);
      return false;
    });
    return featured;
  }

  function getColorVariantRequestUrl(state, color) {
    var variantSelects = getVariantSelects(state);
    var colorSelect = resolveColorSelect(state);
    var productInfo = variantSelects ? variantSelects.closest('product-info') : null;
    if (
      !variantSelects ||
      !colorSelect ||
      !productInfo ||
      typeof productInfo.buildRequestUrlWithParams !== 'function'
    ) {
      return '';
    }

    var targetOption = Array.prototype.find.call(colorSelect.options, function (option) {
      return option.value === color;
    });
    if (!targetOption || !targetOption.dataset.optionValueId) return '';

    var optionValueIds = Array.prototype.map.call(variantSelects.querySelectorAll('select'), function (select) {
      var option = select === colorSelect ? targetOption : select.selectedOptions[0];
      return option && option.dataset.optionValueId;
    });
    if (optionValueIds.some(function (optionValueId) { return !optionValueId; })) return '';

    var productUrl = targetOption.dataset.productUrl || productInfo.pendingRequestUrl || productInfo.dataset.url;
    return productInfo.buildRequestUrlWithParams(productUrl, optionValueIds, false);
  }

  function prefetchColorVariant(state, color) {
    var variantSelects = getVariantSelects(state);
    var productInfo = variantSelects ? variantSelects.closest('product-info') : null;
    var requestUrl = getColorVariantRequestUrl(state, color);
    if (!productInfo || typeof productInfo.prefetchProductInfo !== 'function' || !requestUrl) {
      return Promise.resolve();
    }

    return productInfo.prefetchProductInfo(requestUrl).catch(function () {
      // 先読み失敗時も通常の色変更リクエストで再取得できるため、UIにはエラーを出さない。
    });
  }

  function scheduleFeaturedColorPrefetch(state, featuredColors) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (navigator.connection && navigator.connection.saveData) return;

    var queue = featuredColors.filter(function (color) {
      return color !== resolveColorSelect(state).value;
    });

    function prefetchNext() {
      var color = queue.shift();
      if (!color) return;
      prefetchColorVariant(state, color).finally(function () {
        window.setTimeout(scheduleNext, 40);
      });
    }

    function scheduleNext() {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(prefetchNext, { timeout: 1500 });
      } else {
        window.setTimeout(prefetchNext, 100);
      }
    }

    scheduleNext();
  }

  function createColorPicker(state) {
    state.colorOption = getColorOption(state);
    if (!state.colorOption || !Array.isArray(state.colorOption.values) || !state.colorOption.values.length) {
      throw new Error('カラー選択肢を取得できません。');
    }
    if (!state.config.colorImages || typeof state.config.colorImages !== 'object') {
      throw new Error('カラー画像を取得できません。');
    }

    var variantSelects = getVariantSelects(state);
    var colorSelect = resolveColorSelect(state);
    if (!variantSelects || !colorSelect || !variantSelects.parentNode) {
      throw new Error('カラー選択欄を取得できません。');
    }

    var picker = document.createElement('div');
    picker.className = 'ua-body-color-picker';
    picker.setAttribute('data-ua-body-color-picker', '');

    var label = document.createElement('p');
    label.className = 'ua-body-color-picker__label';
    // 見出しの語は設置先で変わる（カード内なら「ボディ色」）。後から差し替えられるよう参照を持つ。
    var labelLead = document.createTextNode('カラー: ');
    label.appendChild(labelLead);
    state.colorPickerLabel = document.createElement('strong');
    state.colorPickerLabel.setAttribute('data-ua-body-color-label', '');
    label.appendChild(state.colorPickerLabel);
    picker.appendChild(label);

    var featuredColors = getFeaturedColors(state.config, state.colorOption.values);
    var featuredColorSet = new Set(featuredColors);
    var otherColorCount = state.colorOption.values.length - featuredColors.length;

    var featuredGrid = document.createElement('div');
    featuredGrid.className = 'ua-body-color-picker__grid ua-body-color-picker__grid--featured';
    featuredGrid.setAttribute('role', 'group');
    featuredGrid.setAttribute('aria-label', '代表カラー');
    picker.appendChild(featuredGrid);

    var more = document.createElement('details');
    more.className = 'ua-body-color-picker__more';
    more.setAttribute('data-ua-body-color-more', '');

    var moreSummary = document.createElement('summary');
    moreSummary.className = 'ua-body-color-picker__more-summary';
    moreSummary.appendChild(document.createTextNode('その他のカラー'));
    var moreCount = document.createElement('span');
    moreCount.className = 'ua-body-color-picker__more-count';
    moreCount.textContent = '（' + otherColorCount + '色）';
    moreSummary.appendChild(moreCount);
    more.appendChild(moreSummary);

    var moreGrid = document.createElement('div');
    moreGrid.className = 'ua-body-color-picker__grid ua-body-color-picker__grid--more';
    moreGrid.setAttribute('role', 'group');
    moreGrid.setAttribute('aria-label', 'その他のカラー');
    more.appendChild(moreGrid);
    if (otherColorCount > 0) picker.appendChild(more);

    state.colorPickerButtons = state.colorOption.values.map(function (color) {
      var button = document.createElement('button');
      var colorImage = getColorImage(state, color);
      button.className = 'ua-body-color-picker__swatch';
      button.type = 'button';
      button.setAttribute('data-ua-body-color', color);
      button.setAttribute('aria-label', 'カラー: ' + color);
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('title', color);

      if (colorImage && colorImage.thumbnailUrl) {
        var image = document.createElement('img');
        image.src = colorImage.thumbnailUrl;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        button.appendChild(image);
      } else {
        var fallback = document.createElement('span');
        fallback.className = 'ua-body-color-picker__fallback';
        fallback.textContent = color;
        fallback.setAttribute('aria-hidden', 'true');
        button.appendChild(fallback);
      }

      button.addEventListener('click', function () {
        if (state.submitting) return;

        var select = resolveColorSelect(state);
        if (!select) {
          showError(state, 'カラー選択欄を確認できません。ページを再読み込みしてください。', button);
          return;
        }

        clearError(state);
        if (select.value === color && !state.colorVariantPending) {
          syncColorPicker(state);
          return;
        }

        beginColorVariantResolution(state, color);
        select.value = color;
        if (select.value !== color) {
          finishColorVariantResolution(state);
          showError(state, '選択したカラーを設定できませんでした。もう一度お試しください。', button);
          return;
        }

        syncColorPicker(state);
        select.dispatchEvent(new Event('change', { bubbles: true }));
        scheduleEditorSync(state);
      });

      ['pointerenter', 'focus'].forEach(function (eventName) {
        button.addEventListener(eventName, function () {
          prefetchColorVariant(state, color);
        });
      });
      button.addEventListener('touchstart', function () {
        prefetchColorVariant(state, color);
      }, { passive: true });

      if (featuredColorSet.has(color)) {
        featuredGrid.appendChild(button);
      } else {
        moreGrid.appendChild(button);
      }
      return button;
    });

    // コンフィギュレーターカードの先頭（「サイズと枚数」の前）へ移設する。
    // どの服かを決める操作（色・サイズ）をカード内に集約し、カードだけ見て設定を完了できるようにする。
    // 複製はしない（同じ状態を2箇所で持つと色ズレが再発する）。
    // 失敗したらテーマの元の位置（variant-selects の直前）に置く＝色が選べない状態を作らない。
    var slot = state.root ? state.root.querySelector('[data-ua-body-color-slot]') : null;
    var placedInCard = false;
    if (slot) {
      try {
        slot.appendChild(picker);
        slot.hidden = false;
        placedInCard = true;
      } catch (error) {
        placedInCard = false;
      }
    }
    if (!placedInCard) {
      if (slot) slot.hidden = true;
      variantSelects.parentNode.insertBefore(picker, variantSelects);
    } else {
      picker.classList.add('ua-body-color-picker--in-card');
      labelLead.nodeValue = 'ボディ色: ';
    }

    state.colorPicker = picker;
    state.colorMore = more;
    state.colorPickerInCard = placedInCard;
    // 初期選択色が代表カラーの外にある場合だけ「その他のカラー」を開いておく
    // （選択中のスウォッチが折りたたみの中に隠れたまま、を防ぐ）。以降の開閉はユーザーに任せる。
    if (otherColorCount > 0 && !featuredColorSet.has(colorSelect.value)) more.open = true;
    syncColorPicker(state);
    scheduleFeaturedColorPrefetch(state, featuredColors);
  }

  function getCurrentSizeSelection(state) {
    var variantSelects = getVariantSelects(state);
    var scope = variantSelects || document;
    var fieldset = getSizeFieldset(state);
    var selectedControls = scope.querySelectorAll('input[type="radio"]:checked, select');
    var control =
      Array.prototype.find.call(selectedControls, function (selectedControl) {
        return Object.prototype.hasOwnProperty.call(state.config.sizePrices, selectedControl.value);
      }) || null;
    var radio = control && control.matches('input[type="radio"]') ? control : null;
    var size = control ? control.value : '';
    var hasPrice = Object.prototype.hasOwnProperty.call(state.config.sizePrices, size);

    return {
      variantSelects: variantSelects,
      fieldset: fieldset,
      control: control,
      radio: radio,
      size: size,
      price: hasPrice ? state.config.sizePrices[size] : null
    };
  }

  function setVariantSubmitState(state, sizeSelection, variantId) {
    resolveForm(state);
    if (!state.submitButton) return;

    var disabled = !sizeSelection.size || sizeSelection.price === null || !variantId;
    if (disabled) {
      state.submitButton.setAttribute('aria-disabled', 'true');
      state.submitButton.setAttribute('data-ua-body-disabled', 'true');
    } else if (state.submitButton.hasAttribute('data-ua-body-disabled') && !state.submitting) {
      state.submitButton.removeAttribute('aria-disabled');
      state.submitButton.removeAttribute('data-ua-body-disabled');
    }

    state.elements.purchaseSubmit.disabled = disabled || state.submitting;
    state.elements.purchaseSubmit.setAttribute(
      'aria-disabled',
      disabled || state.submitting ? 'true' : 'false'
    );
  }

  function bandLabel(band) {
    if (band.maxCharacters === 5) return '5文字以下';
    return band.maxCharacters + '文字';
  }

  function getTextBand(state, text) {
    var coreBand = state.core.getNameBand(text);
    if (!coreBand) return null;
    return state.embroideryBands.find(function (band) {
      return band.code === coreBand.code;
    }) || null;
  }

  // その行の現在の入力から「1枚ごとの文字」配列を返す。未完成/不正なら null。
  // 検証メッセージは出さない（ライブ価格プレビュー専用）。
  function linePieceTexts(state, line, quantity) {
    var core = state.core;
    var mode = getLineMode(state, line);
    if (mode === TEXT_MODE_SAME) {
      var text = getLineSameText(line);
      if (!core.isValidNameText(text)) return null;
      var same = [];
      for (var p = 0; p < quantity; p++) same.push(text);
      return same;
    }
    if (mode === TEXT_MODE_INDIVIDUAL) {
      var names = getLineIndividualNames(state, line);
      if (names.length !== quantity) return null;
      if (
        names.some(function (name) {
          return !core.isValidNameText(name);
        })
      ) {
        return null;
      }
      return names.slice();
    }
    return null;
  }

  function uniqueValueCount(values) {
    var seen = {};
    values.forEach(function (value) {
      seen[String(value)] = true;
    });
    return Object.keys(seen).length;
  }

  // 実際の入力値で判定する。個別入力UIを開いただけでは個別ネーム料・糸色変更料を加算しない。
  function getSurchargeState(state, quantity) {
    if (!state.core.isValidQty(quantity)) {
      return { ready: false, individualName: false, individualThread: false };
    }

    // 個別ネームは「枚をまたいで文字が2種類以上」で該当。行・箇所がいくつ割れていても1枚につき1回。
    var nameReady = true;
    var nameSplit = false;
    embroideryConfigs(state).forEach(function (config) {
      config.lines.forEach(function (line) {
        var pieceTexts = linePieceTexts(state, line, quantity);
        if (!pieceTexts) {
          nameReady = false;
          return;
        }
        if (uniqueValueCount(pieceTexts) > 1) nameSplit = true;
      });
    });

    var threadColors = [];
    var threadColorSets = [];
    var threadReady = true;
    if (attrIndividualEnabled(state)) {
      var threadSelects = getLineRowThreadSelects(state);
      if (threadSelects.length !== quantity) {
        threadReady = false;
      } else {
        threadColors = threadSelects.map(function (select) {
          return select.value;
        });
        if (threadColors.some(function (color) { return THREAD_COLORS.indexOf(color) === -1; })) {
          threadReady = false;
        }
      }
    } else {
      var mainThread = state.elements.threadColor.value;
      if (THREAD_COLORS.indexOf(mainThread) === -1) {
        threadReady = false;
      } else {
        for (var t = 0; t < quantity; t++) threadColors.push(mainThread);
      }
    }
    if (threadReady) threadColorSets.push(threadColors);

    if (secondContentDifferent(state)) {
      var location2Threads = [];
      if (location2ThreadIndividualEnabled(state)) {
        var location2ThreadSelects = getLocation2RowThreadSelects(state);
        if (location2ThreadSelects.length !== quantity) {
          threadReady = false;
        } else {
          location2Threads = location2ThreadSelects.map(function (select) {
            return select.value;
          });
          if (location2Threads.some(function (color) { return THREAD_COLORS.indexOf(color) === -1; })) {
            threadReady = false;
          }
        }
      } else {
        var location2Thread = state.elements.location2Thread.value;
        if (THREAD_COLORS.indexOf(location2Thread) === -1) {
          threadReady = false;
        } else {
          for (var l2t = 0; l2t < quantity; l2t++) location2Threads.push(location2Thread);
        }
      }
      if (threadReady) threadColorSets.push(location2Threads);
    }

    return {
      ready: nameReady && threadReady,
      individualName: nameReady && quantity > 1 && nameSplit,
      individualThread: threadReady && quantity > 1 && threadColorSets.some(function (colors) {
        return uniqueValueCount(colors) > 1;
      })
    };
  }

  function breakdownRowsForLine(state, config, line, pieceTexts) {
    var groups = {};
    pieceTexts.forEach(function (text) {
      var band = getTextBand(state, text);
      if (!band) return;
      if (!groups[band.code]) groups[band.code] = { band: band, count: 0 };
      groups[band.code].count += 1;
    });
    return state.embroideryBands
      .filter(function (band) { return !!groups[band.code]; })
      .map(function (band) {
        return {
          slot: config.slot,
          location: config.location,
          lineKey: line.key,
          label: bandLabel(band),
          price: band.unitPrice,
          count: groups[band.code].count
        };
      });
  }

  function renderBreakdownRows(state, rows) {
    var container = state.elements.embroideryBreakdown;
    container.textContent = '';
    rows.forEach(function (row) {
      var wrap = document.createElement('div');
      wrap.className = 'ua-body-configurator__price-row ua-body-configurator__price-row--embroidery';
      var dt = document.createElement('dt');
      if (row.kind === 'fee') {
        dt.textContent = row.label + '　' + formatYen(row.price) + '／注文';
      } else if (row.kind === 'surcharge') {
        dt.textContent = row.label + '　' + formatYen(row.price) + ' × ' + row.count + '枚';
      } else {
        dt.textContent = (row.location ? row.location + '・' : '') +
          row.lineKey + '行目　' + row.label + '　' + formatYen(row.price) + ' × ' + row.count + '枚';
      }
      var dd = document.createElement('dd');
      dd.textContent = formatYen(row.kind === 'fee' ? row.price : row.price * row.count);
      wrap.appendChild(dt);
      wrap.appendChild(dd);
      container.appendChild(wrap);
    });
  }

  function renderBodyBreakdown(state, rows) {
    var container = state.elements.bodyBreakdown;
    container.textContent = '';
    rows.forEach(function (row) {
      var wrap = document.createElement('div');
      wrap.className = 'ua-body-configurator__price-row ua-body-configurator__price-row--body';
      var dt = document.createElement('dt');
      dt.textContent = 'ボディ ' + (row.color ? row.color + ' ' : '') + row.size + ' × ' + row.count + '枚';
      var dd = document.createElement('dd');
      dd.textContent = formatYen(row.price * row.count);
      wrap.appendChild(dt);
      wrap.appendChild(dd);
      container.appendChild(wrap);
    });
  }

  // piece index i の刺繍単価合計（有効な行だけ）。未確定なら null。
  function pieceEmbroideryPrice(state, index, quantity) {
    var total = 0;
    var ready = true;
    embroideryConfigs(state).forEach(function (config) {
      config.lines.forEach(function (line) {
        var text;
        if (getLineMode(state, line) === TEXT_MODE_SAME) {
          text = getLineSameText(line);
        } else {
          var inputs = getLineRowTextInputs(state, line);
          text = inputs[index] ? inputs[index].value.trim() : '';
        }
        if (!state.core.isValidNameText(text)) {
          ready = false;
          return;
        }
        var band = getTextBand(state, text);
        if (!band) {
          ready = false;
          return;
        }
        total += band.unitPrice;
      });
    });
    return ready ? total : null;
  }

  function updateRowHints(state, quantity) {
    var line1 = getLine(state, '1');
    var rows = line1.rows.querySelectorAll('.ua-body-configurator__row');
    var pieceSizes = derivePieceSizes(state);
    var attr = attrIndividualEnabled(state);
    var mainColor = getSelectedColor(state);
    var surchargeState = getSurchargeState(state, quantity);
    var surchargePerPiece = surchargeState.ready
      ? ((surchargeState.individualName ? state.surcharges.individualName.unitPrice : 0) +
        (surchargeState.individualThread ? state.surcharges.individualThread.unitPrice : 0))
      : 0;
    // まず全行分のヒント文字列を作る。全行が同じ文字列になる場合は情報量ゼロなので出さない
    // （行カードを1段に保つため）。糸色個別指定などで行ごとに金額が割れるときだけ表示する。
    var hints = [];
    var hintNodes = [];
    for (var i = 0; i < rows.length; i++) {
      var hint = rows[i].querySelector('[data-ua-body-row-hint]');
      if (!hint) continue;
      hintNodes.push(hint);
      var size = pieceSizes[i] || rows[i].getAttribute('data-ua-body-piece-size') || '';
      var colorEl = rows[i].querySelector('[data-ua-body-row-color]');
      var color = attr && colorEl ? colorEl.value : mainColor;
      var resolved = color && size ? resolveSizeVariant(state, color, size) : null;
      if (!resolved) {
        hints.push('');
        continue;
      }
      var emb = pieceEmbroideryPrice(state, i, quantity);
      hints.push(
        emb !== null
          ? '1枚 ' + formatYen(resolved.price + emb + surchargePerPiece)
          : 'ボディ ' + formatYen(resolved.price)
      );
    }

    var allSame = hints.every(function (text) { return text === hints[0]; });
    hintNodes.forEach(function (node, index) {
      node.textContent = allSame ? '' : hints[index];
    });
  }

  function updatePrice(state) {
    var els = state.elements;
    var quantity = Number(els.quantity.value);
    var quantityIsValid = state.core.isValidQty(quantity);

    if (!quantityIsValid) {
      els.embroideryBreakdown.textContent = '';
      els.embroideryTotal.textContent = '—';
      els.bodyBreakdown.textContent = '';
      els.bodyTotal.textContent = '—';
      els.orderTotal.textContent = '—';
      els.purchaseTotal.textContent = '—';
      wizardScheduleRender(state);
      return;
    }

    // 刺繍内訳（各行・文字数帯ごと）
    var embRows = [];
    var embroiderySubtotal = 0;
    var embReady = true;
    embroideryConfigs(state).forEach(function (config) {
      config.lines.forEach(function (line) {
        var pieceTexts = linePieceTexts(state, line, quantity);
        if (!pieceTexts) {
          embReady = false;
          return;
        }
        breakdownRowsForLine(state, config, line, pieceTexts).forEach(function (row) {
          embRows.push(row);
          embroiderySubtotal += row.price * row.count;
        });
      });
    });

    var surchargeState = getSurchargeState(state, quantity);
    if (!surchargeState.ready) {
      embReady = false;
    }
    ['individualName', 'individualThread'].forEach(function (key) {
      if (!surchargeState[key]) return;
      embRows.push({
        kind: 'surcharge',
        label: state.surcharges[key].label,
        price: state.surcharges[key].unitPrice,
        count: quantity
      });
      embroiderySubtotal += state.surcharges[key].unitPrice * quantity;
    });
    if (quantity <= state.smallLotFee.maxQuantity) {
      embRows.push({
        kind: 'fee',
        label: state.smallLotFee.label + '（1〜9枚）',
        price: state.smallLotFee.unitPrice,
        count: 1
      });
      embroiderySubtotal += state.smallLotFee.unitPrice;
    }
    renderBreakdownRows(state, embRows);

    // ボディ内訳（各ピースのボディ色×サイズごと）。サイズ=マトリクス由来、
    // ボディ色=色糸個別OFF時はメイン色を全ピースに、ON時は各行の色を使用。
    var bodyRows = [];
    var bodySubtotal = 0;
    var bodyReady = true;
    updateRowHints(state, quantity);
    if (!hasVariantsByColor(state)) bodyReady = false;
    var pieceSizes = derivePieceSizes(state);
    var attr = attrIndividualEnabled(state);
    var colorSelects = attr ? getLineRowColorSelects(state) : [];
    var mainColor = getSelectedColor(state);
    var groups = {};
    var order = [];
    for (var i = 0; i < quantity; i++) {
      var size = pieceSizes[i] || '';
      var color = attr ? (colorSelects[i] ? colorSelects[i].value : '') : mainColor;
      var resolved = color && size ? resolveSizeVariant(state, color, size) : null;
      if (!resolved) {
        bodyReady = false;
        continue;
      }
      var key = color + ' ' + size;
      if (!groups[key]) {
        groups[key] = { color: color, size: size, count: 0, price: resolved.price };
        order.push(key);
      }
      groups[key].count += 1;
    }
    order.forEach(function (key) {
      var group = groups[key];
      bodyRows.push(group);
      bodySubtotal += group.price * group.count;
    });
    renderBodyBreakdown(state, bodyRows);

    els.embroideryTotal.textContent = embReady ? formatYen(embroiderySubtotal) : '—';
    els.bodyTotal.textContent = bodyReady ? formatYen(bodySubtotal) : '—';

    if (embReady && bodyReady) {
      var orderTotal = embroiderySubtotal + bodySubtotal;
      els.orderTotal.textContent = formatYen(orderTotal);
      els.purchaseTotal.textContent = formatYen(orderTotal);
    } else {
      els.orderTotal.textContent = '—';
      els.purchaseTotal.textContent = '—';
    }

    wizardScheduleRender(state);
  }

  function syncVariant(state) {
    if (state.cartEditPairId || state.previewView === 'bss-mobile-r3') {
      var url = new URL(window.location.href);
      if (state.cartEditPairId) url.searchParams.set('ua_edit', state.cartEditPairId);
      if (state.previewView === 'bss-mobile-r3') url.searchParams.set('view', state.previewView);
      if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url.href);
    }
    var sizeSelection = getCurrentSizeSelection(state);
    var variantId = getCurrentVariantId(state);
    if (state.colorVariantPending && variantId && variantId !== state.colorVariantPending.initialVariantId) {
      finishColorVariantResolution(state);
    }
    state.currentSizeSelection = sizeSelection;
    state.currentVariantId = variantId;
    state.root.setAttribute('data-ua-body-selected-size', sizeSelection.size || 'unknown');
    state.root.setAttribute('data-ua-body-selected-variant', variantId ? String(variantId) : 'unknown');
    setVariantSubmitState(state, sizeSelection, variantId);
    setSubmitLabel(state);
    syncColorPicker(state);
    updateUntouchedRowColors(state);
    applySizePickerVisibility(state);
    updatePrice(state);
    scheduleEditorSync(state);
  }

  // すべての variant 変更シグナル（select/input の change・variant input の MutationObserver・
  // フォームの id change）を一元処理する。観測ログ＋冪等化＋マイクロタスク層ループ遮断器。
  // フリーズ機序: 実環境で theme(product-info) が prefetch 済みの解決済み Promise から variant を
  // 再描画し続けると、rAF に一度も戻らない純マイクロタスクループになる。ここで我々側の反応を
  // 上限で打ち切り、ループの片翼を折る（＝自コード経路の封鎖・切り分け）。
  function handleVariantSignal(state, source) {
    if (state.variantReactionsDisabled) return;
    var t = nowMs();
    state.variantSignalStamps.push(t);
    while (state.variantSignalStamps.length && t - state.variantSignalStamps[0] > 1000) {
      state.variantSignalStamps.shift();
    }
    var rate = state.variantSignalStamps.length;
    var value = state.variantInput ? state.variantInput.value : '';
    if (rate > VARIANT_SIGNAL_LIMIT) {
      state.variantReactionsDisabled = true;
      try { if (state.variantObserver) state.variantObserver.disconnect(); } catch (e) {}
      if (window.console && console.warn) {
        console.warn('[ua-body] variant同期ループ遮断器作動 rate=' + rate + '/s source=' + source + ' value=' + value + '（以後の自動variant同期を停止）');
      }
      return;
    }
    // 冪等化: 前回シグナルから value が変わっていなければ何もしない（無駄反応を抑止）。
    if (value === state.lastVariantSignalValue) return;
    state.lastVariantSignalValue = value;
    maybeFinishColorVariantResolution(state);
    scheduleVariantSync(state);
  }

  function scheduleVariantSync(state) {
    window.requestAnimationFrame(function () {
      syncVariant(state);
    });
    window.clearTimeout(state.variantSyncTimer);
    state.variantSyncTimer = window.setTimeout(function () {
      syncVariant(state);
    }, 120);
  }

  function locationFocusTarget(state) {
    var visibleChip = state.elements.chips.find(function (chip) {
      return chip.offsetParent !== null;
    });
    return visibleChip || state.elements.location;
  }

  function location2FocusTarget(state) {
    var visibleChip = state.elements.location2ChipButtons.find(function (chip) {
      return chip.offsetParent !== null;
    });
    return visibleChip || state.elements.location2Select;
  }

  function threadColorFocusTarget(state) {
    var visibleChip = state.elements.threadColorChipButtons.find(function (chip) {
      return chip.offsetParent !== null;
    });
    return visibleChip || state.elements.threadColor;
  }

  function invalidResult(message, target, ariaTarget) {
    return { valid: false, message: message, target: target, ariaTarget: ariaTarget || target };
  }

  function validateOrder(state) {
    clearInvalidState(state);

    var core = state.core;
    var font = state.elements.font.value;
    var location = state.elements.location.value;
    var sizeRowsList = getSizeRows(state);
    var firstSizeRow = sizeRowsList[0] || null;
    var firstSizeQty = (firstSizeRow && firstSizeRow.querySelector('[data-ua-body-sizerow-qty]')) ||
      state.elements.sizeAddButton || state.elements.quantity;

    // サイズ未選択なのに枚数>0 の行は fail-closed。
    var pendingRow = sizeRowsList.find(function (row) {
      var select = row.querySelector('[data-ua-body-sizerow-select]');
      var qtyInput = row.querySelector('[data-ua-body-sizerow-qty]');
      return select && !select.value && readSizeCount(qtyInput) > 0;
    });
    if (pendingRow) {
      return invalidResult('追加したサイズを選択してください。', pendingRow.querySelector('[data-ua-body-sizerow-select]'));
    }

    var total = getMatrixTotal(state);

    if (total <= 0) {
      return invalidResult('必要なサイズと枚数を追加してください。', firstSizeQty);
    }
    if (total > 100 || !core.isValidQty(total)) {
      return invalidResult('合計枚数は100枚までにしてください。', firstSizeQty);
    }
    var quantity = total;

    var line1 = getLine(state, '1');
    var line2 = getLine(state, '2');
    var line2Enabled = isLine2Enabled(state);
    var activeLineList = line2Enabled ? [line1, line2] : [line1];
    var location2Enabled = secondLocationEnabled(state);
    var location2Different = secondContentDifferent(state);
    var location2Line1 = getLocation2Line(state, '1');
    var location2Line2 = getLocation2Line(state, '2');
    var location2Line2Enabled = isLocation2Line2Enabled(state);
    var location2ActiveLineList = location2Different
      ? (location2Line2Enabled ? [location2Line1, location2Line2] : [location2Line1])
      : [];

    // モード確認 & 共通テキストの事前検証（同じ文字モードのみ）。
    var sameTexts = {};
    for (var li = 0; li < activeLineList.length; li++) {
      var aline = activeLineList[li];
      var amode = getLineMode(state, aline);
      if (amode !== TEXT_MODE_SAME && amode !== TEXT_MODE_INDIVIDUAL) {
        return invalidResult(aline.key + '行目の入力方法を選択してください。', aline.modes[0]);
      }
      if (amode === TEXT_MODE_SAME) {
        var sameText = getLineSameText(aline);
        if (!core.isValidNameText(sameText)) {
          return invalidResult(aline.key + '行目の文字を1〜10文字で入力してください。', aline.text);
        }
        sameTexts[aline.key] = sameText;
      }
    }
    var location2SameTexts = {};
    for (var l2i = 0; l2i < location2ActiveLineList.length; l2i++) {
      var location2ActiveLine = location2ActiveLineList[l2i];
      var location2Mode = getLineMode(state, location2ActiveLine);
      if (location2Mode !== TEXT_MODE_SAME && location2Mode !== TEXT_MODE_INDIVIDUAL) {
        return invalidResult(
          '2箇所目' + location2ActiveLine.key + '行目の入力方法を選択してください。',
          location2ActiveLine.modes[0]
        );
      }
      if (location2Mode === TEXT_MODE_SAME) {
        var location2SameText = getLineSameText(location2ActiveLine);
        if (!core.isValidNameText(location2SameText)) {
          return invalidResult(
            '2箇所目' + location2ActiveLine.key + '行目の文字を1〜10文字で入力してください。',
            location2ActiveLine.text
          );
        }
        location2SameTexts[location2ActiveLine.key] = location2SameText;
      }
    }

    // サイズ・色別の在庫情報。
    if (!hasVariantsByColor(state)) {
      return invalidResult('サイズ・色別の在庫情報を読み込めませんでした。ページを再読み込みしてください。', line1.rows);
    }

    // サイズ=マトリクス由来。ボディ色/糸色=色糸個別トグル、テキスト=行モードで供給元が変わる。
    var attr = attrIndividualEnabled(state);
    var pieceSizes = derivePieceSizes(state);
    var mainColor = getSelectedColor(state);
    var mainThread = state.elements.threadColor.value;
    var line1Individual = getLineMode(state, line1) === TEXT_MODE_INDIVIDUAL;
    var line2Individual = line2Enabled && getLineMode(state, line2) === TEXT_MODE_INDIVIDUAL;
    var location2Line1Individual =
      location2Different && getLineMode(state, location2Line1) === TEXT_MODE_INDIVIDUAL;
    var location2Line2Individual =
      location2Line2Enabled && getLineMode(state, location2Line2) === TEXT_MODE_INDIVIDUAL;

    var name1Inputs = line1Individual ? getLineRowTextInputs(state, line1) : [];
    var name2Inputs = line2Individual ? getLineRowTextInputs(state, line2) : [];
    var location2Name1Inputs = location2Line1Individual ? getLineRowTextInputs(state, location2Line1) : [];
    var location2Name2Inputs = location2Line2Individual ? getLineRowTextInputs(state, location2Line2) : [];
    var location2ThreadIndividual = location2ThreadIndividualEnabled(state);
    var location2ThreadSelects = location2ThreadIndividual ? getLocation2RowThreadSelects(state) : [];
    var location2BaseThread = state.elements.location2Thread.value;
    var colorSelects = attr ? getLineRowColorSelects(state) : [];
    var threadSelects = attr ? getLineRowThreadSelects(state) : [];

    // 使用する行入力は必ず枚数と一致するはず（不一致＝内部整合崩れ）。
    if (
      pieceSizes.length !== quantity ||
      (line1Individual && name1Inputs.length !== quantity) ||
      (line2Individual && name2Inputs.length !== quantity) ||
      (location2Line1Individual && location2Name1Inputs.length !== quantity) ||
      (location2Line2Individual && location2Name2Inputs.length !== quantity) ||
      (location2ThreadIndividual && location2ThreadSelects.length !== quantity) ||
      (attr && (colorSelects.length !== quantity || threadSelects.length !== quantity))
    ) {
      return invalidResult('入力欄を再生成します。もう一度お試しください。', firstSizeQty);
    }

    // 色糸個別OFF時はメインのボディ色・糸色を全ピースに使う。
    if (!attr) {
      if (!mainColor) {
        return invalidResult('ボディのカラーを選択してください。', colorPickerFocusTarget(state));
      }
      if (THREAD_COLORS.indexOf(mainThread) === -1) {
        return invalidResult('糸色を選択してください。', threadColorFocusTarget(state), state.elements.threadColorChips.offsetParent !== null ? state.elements.threadColorChips : state.elements.threadColor);
      }
    }

    // 1枚ずつのピース情報を確定（サイズ・ボディ色・糸色・各行テキスト）。fail-closed。
    var pieces = [];
    for (var s = 0; s < quantity; s++) {
      var rowSize = pieceSizes[s] || '';
      if (!Object.prototype.hasOwnProperty.call(state.config.sizePrices, rowSize)) {
        return invalidResult('サイズ内訳が不正です。「サイズと枚数」を指定し直してください。', firstSizeQty);
      }

      var rowColor = attr ? (colorSelects[s] ? colorSelects[s].value : '') : mainColor;
      var rowThread = attr ? (threadSelects[s] ? threadSelects[s].value : '') : mainThread;
      var rowLocation2Thread = '';
      if (attr && !rowColor) {
        return invalidResult(s + 1 + '枚目のボディ色を選択してください。', colorSelects[s] || line1.rows);
      }
      if (attr && THREAD_COLORS.indexOf(rowThread) === -1) {
        return invalidResult(s + 1 + '枚目の糸色を選択してください。', threadSelects[s] || line1.rows);
      }
      if (location2Enabled) {
        if (!location2Different) {
          rowLocation2Thread = rowThread;
        } else {
          rowLocation2Thread = location2ThreadIndividual
            ? (location2ThreadSelects[s] ? location2ThreadSelects[s].value : '')
            : location2BaseThread;
          if (THREAD_COLORS.indexOf(rowLocation2Thread) === -1) {
            return invalidResult(
              '2箇所目の' + (s + 1) + '枚目の糸色を選択してください。',
              location2ThreadSelects[s] || state.elements.location2Thread
            );
          }
        }
      }

      var rowVariant = resolveSizeVariant(state, rowColor, rowSize);
      if (!rowVariant) {
        return invalidResult(
          s + 1 + '枚目（' + rowColor + ' ' + rowSize + '）のボディを確認できません。別のサイズか色をお選びください。',
          attr && colorSelects[s] ? colorSelects[s] : firstSizeQty
        );
      }

      var line1Text;
      if (!line1Individual) {
        line1Text = sameTexts['1'];
      } else {
        line1Text = name1Inputs[s].value.trim();
        if (!core.isValidNameText(line1Text)) {
          return invalidResult('1行目の' + (s + 1) + '枚目のテキストを1〜10文字で入力してください。', name1Inputs[s]);
        }
      }

      var line2Text = '';
      if (line2Enabled) {
        if (!line2Individual) {
          line2Text = sameTexts['2'];
        } else {
          line2Text = name2Inputs[s].value.trim();
          if (!core.isValidNameText(line2Text)) {
            return invalidResult('2行目の' + (s + 1) + '枚目のテキストを1〜10文字で入力してください。', name2Inputs[s]);
          }
        }
      }

      var location2Line1Text = '';
      var location2Line2Text = '';
      if (location2Enabled) {
        if (!location2Different) {
          location2Line1Text = line1Text;
          location2Line2Text = line2Text;
        } else {
          location2Line1Text = location2Line1Individual
            ? location2Name1Inputs[s].value.trim()
            : location2SameTexts['1'];
          if (!core.isValidNameText(location2Line1Text)) {
            return invalidResult(
              '2箇所目1行目の' + (s + 1) + '枚目のテキストを1〜10文字で入力してください。',
              location2Name1Inputs[s] || location2Line1.text
            );
          }
          if (location2Line2Enabled) {
            location2Line2Text = location2Line2Individual
              ? location2Name2Inputs[s].value.trim()
              : location2SameTexts['2'];
            if (!core.isValidNameText(location2Line2Text)) {
              return invalidResult(
                '2箇所目2行目の' + (s + 1) + '枚目のテキストを1〜10文字で入力してください。',
                location2Name2Inputs[s] || location2Line2.text
              );
            }
          }
        }
      }

      pieces.push({
        index: s,
        size: rowSize,
        bodyColor: rowColor,
        threadColor: rowThread,
        location2ThreadColor: rowLocation2Thread,
        variantId: rowVariant.variantId,
        price: rowVariant.price,
        line1Text: line1Text,
        line2Text: line2Text,
        location2Line1Text: location2Line1Text,
        location2Line2Text: location2Line2Text
      });
    }

    if (FONTS.indexOf(font) === -1) {
      return invalidResult('書体を選択してください。', state.elements.font);
    }
    if (state.editorConfig.enabledLocations.indexOf(location) === -1) {
      return invalidResult(
        '刺繍箇所を選択してください。',
        locationFocusTarget(state),
        state.elements.locationChips.offsetParent !== null ? state.elements.locationChips : state.elements.location
      );
    }
    var location2 = state.elements.location2Select.value;
    var location2Font = location2Different ? state.elements.location2Font.value : font;
    var location2Thread = location2Different ? location2BaseThread : '';
    if (location2Enabled) {
      if (state.editorConfig.enabledLocations.indexOf(location2) === -1 || location2 === location) {
        return invalidResult(
          '2箇所目は1箇所目と異なる刺繍箇所を選択してください。',
          location2FocusTarget(state),
          state.elements.location2Chips.offsetParent !== null ? state.elements.location2Chips : state.elements.location2Select
        );
      }
      if (location2Different && FONTS.indexOf(location2Font) === -1) {
        return invalidResult('2箇所目の書体を選択してください。', state.elements.location2Font);
      }
      if (
        location2Different &&
        !location2ThreadIndividual &&
        THREAD_COLORS.indexOf(location2Thread) === -1
      ) {
        return invalidResult('2箇所目の糸色を選択してください。', state.elements.location2Thread);
      }
    }

    // 個別ネーム料・糸色変更料は実際の確定値で判定する。モードを選んだだけでは加算しない。
    var threadColors = pieces.map(function (piece) {
      return piece.threadColor;
    });
    var location2ThreadColors = location2Enabled
      ? pieces.map(function (piece) { return piece.location2ThreadColor; })
      : [];
    var surchargeLines = [];

    // 枚をまたいで文字が割れている行を集める。何行割れていても加算は1枚につき1回。
    var nameTextSets = [pieces.map(function (piece) { return piece.line1Text; })];
    if (line2Enabled) {
      nameTextSets.push(pieces.map(function (piece) { return piece.line2Text; }));
    }
    if (location2Enabled && location2Different) {
      nameTextSets.push(pieces.map(function (piece) { return piece.location2Line1Text; }));
      if (location2Line2Enabled) {
        nameTextSets.push(pieces.map(function (piece) { return piece.location2Line2Text; }));
      }
    }
    if (
      quantity > 1 &&
      nameTextSets.some(function (texts) { return uniqueValueCount(texts) > 1; })
    ) {
      surchargeLines.push({
        code: state.surcharges.individualName.code,
        label: state.surcharges.individualName.label,
        unitPrice: state.surcharges.individualName.unitPrice,
        variantId: state.surcharges.individualName.variantId,
        count: quantity,
        rule: '2行でも1枚につき1回'
      });
    }

    if (
      quantity > 1 &&
      (
        uniqueValueCount(threadColors) > 1 ||
        (location2ThreadColors.length && uniqueValueCount(location2ThreadColors) > 1)
      )
    ) {
      surchargeLines.push({
        code: state.surcharges.individualThread.code,
        label: state.surcharges.individualThread.label,
        unitPrice: state.surcharges.individualThread.unitPrice,
        variantId: state.surcharges.individualThread.variantId,
        count: quantity
      });
    }

    // ボディ分配（ボディ色×サイズごとに集計。所属ピースも保持）。
    var bodyGroups = {};
    var bodyOrder = [];
    var bodySubtotal = 0;
    pieces.forEach(function (piece) {
      var bodyKey = piece.bodyColor + ' ' + piece.size;
      var bodyGroup = bodyGroups[bodyKey];
      if (!bodyGroup) {
        bodyGroup = bodyGroups[bodyKey] = {
          color: piece.bodyColor,
          size: piece.size,
          count: 0,
          variantId: piece.variantId,
          price: piece.price,
          pieces: []
        };
        bodyOrder.push(bodyKey);
      }
      bodyGroup.count += 1;
      bodyGroup.pieces.push(piece);
    });
    var bodyLines = bodyOrder.map(function (bodyKey) {
      var bodyGroup = bodyGroups[bodyKey];
      bodySubtotal += bodyGroup.price * bodyGroup.count;
      return bodyGroup;
    });

    // 刺繍ライン：刺繍箇所・文字数帯ごとに集計する。2箇所は同じ料金帯でも別商品行にする。
    var bandGroups = {};
    var bandOrder = [];
    var embroiderySubtotal = 0;
    var validatedConfigs = [{
      slot: '1',
      location: location,
      font: font,
      thread: null,
      threadProp: 'threadColor',
      line2Enabled: line2Enabled,
      line1Prop: 'line1Text',
      line2Prop: 'line2Text'
    }];
    if (location2Enabled) {
      validatedConfigs.push({
        slot: '2',
        location: location2,
        font: location2Font,
        thread: location2Different && !location2ThreadIndividual ? location2Thread : null,
        threadProp: 'location2ThreadColor',
        line2Enabled: location2Different ? location2Line2Enabled : line2Enabled,
        line1Prop: 'location2Line1Text',
        line2Prop: 'location2Line2Text'
      });
    }
    validatedConfigs.forEach(function (config) {
      pieces.forEach(function (piece) {
        var lineTexts = [{ lineKey: '1', text: piece[config.line1Prop] }];
        if (config.line2Enabled) lineTexts.push({ lineKey: '2', text: piece[config.line2Prop] });
        lineTexts.forEach(function (entry) {
          var textBand = getTextBand(state, entry.text);
          if (!textBand) return;
          var groupKey = config.slot + ':' + textBand.code;
          if (!bandGroups[groupKey]) {
            bandGroups[groupKey] = {
              band: textBand,
              count: 0,
              units: [],
              slot: config.slot,
              location: config.location,
              font: config.font
            };
            bandOrder.push(groupKey);
          }
          var unitThread = config.thread || piece[config.threadProp] || piece.threadColor;
          embroiderySubtotal += textBand.unitPrice;
          bandGroups[groupKey].count += 1;
          bandGroups[groupKey].units.push({
            index: piece.index,
            slot: config.slot,
            location: config.location,
            lineKey: entry.lineKey,
            text: entry.text,
            size: piece.size,
            bodyColor: piece.bodyColor,
            threadColor: unitThread
          });
        });
      });
    });
    var bandLines = bandOrder.map(function (groupKey) { return bandGroups[groupKey]; });
    if (!bandLines.length) {
      return invalidResult('ネーム刺繍の文字数料金を確認できません。', firstSizeQty);
    }

    surchargeLines.forEach(function (surchargeLine) {
      embroiderySubtotal += surchargeLine.unitPrice * surchargeLine.count;
    });
    var smallLotFeeLine = null;
    if (quantity <= state.smallLotFee.maxQuantity) {
      smallLotFeeLine = {
        code: state.smallLotFee.code,
        label: state.smallLotFee.label,
        unitPrice: state.smallLotFee.unitPrice,
        variantId: state.smallLotFee.variantId,
        count: 1
      };
      embroiderySubtotal += smallLotFeeLine.unitPrice;
    }

    return {
      valid: true,
      quantity: quantity,
      font: font,
      location: location,
      line2Enabled: line2Enabled,
      location2Enabled: location2Enabled,
      location2Different: location2Different,
      location2: location2,
      location2Font: location2Font,
      location2Thread: location2Thread,
      pieces: pieces,
      bandLines: bandLines,
      surchargeLines: surchargeLines,
      smallLotFeeLine: smallLotFeeLine,
      bodyLines: bodyLines,
      bodySubtotal: bodySubtotal,
      embroiderySubtotal: embroiderySubtotal
    };
  }

  function makePairId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'ua-' + window.crypto.randomUUID();
    }
    return 'ua-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function publishCartEvent(type, variantId, response) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    if (type === 'error') {
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'ua-body-configurator',
        productVariantId: variantId,
        errors: response.errors || response.description,
        message: response.message
      });
      return;
    }

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'ua-body-configurator',
      productVariantId: variantId,
      cartData: response
    });
  }

  function responseErrorMessage(response) {
    var message = response.description || response.message || response.errors;
    if (typeof message === 'string') return message;
    if (message) return JSON.stringify(message);
    return 'カートに追加できませんでした。時間をおいてもう一度お試しください。';
  }

  function setLoading(state, loading) {
    resolveForm(state);
    if (!state.submitButton) return;

    if (loading) {
      state.submitButton.setAttribute('aria-disabled', 'true');
      state.submitButton.classList.add('loading');
      state.elements.purchaseSubmit.disabled = true;
      state.elements.purchaseSubmit.setAttribute('aria-disabled', 'true');
      state.elements.purchaseSubmit.textContent = state.cartEdit ? '保存中…' : '追加中…';
      if (state.spinner) state.spinner.classList.remove('hidden');
      return;
    }

    state.submitButton.classList.remove('loading');
    if (state.spinner) state.spinner.classList.add('hidden');
    state.submitButton.removeAttribute('aria-disabled');
    state.submitButton.removeAttribute('data-ua-body-disabled');
    state.elements.purchaseSubmit.textContent = cartSubmitLabel(state);
    setVariantSubmitState(state, getCurrentSizeSelection(state), getCurrentVariantId(state));
    wizardRender(state);
  }

  // 刺繍ライン内訳：帯に属するピース単位を列挙（枚目・行・テキスト・サイズ・ボディ色・糸色）。
  function describeBandUnits(units) {
    return units
      .map(function (unit) {
        return (unit.index + 1) + '枚目 ' + unit.location + ' ' + unit.lineKey + '行目「' + unit.text + '」（' +
          unit.size + '／' + unit.bodyColor + '／糸:' + unit.threadColor + '）';
      })
      .join(' / ');
  }

  function appendCartSections(state, payload) {
    if (state.cart && typeof state.cart.getSectionsToRender === 'function') {
      payload.sections = state.cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;
    }
    return payload;
  }

  // Cart sets are read from the current shopper's cart, never from browser storage.
  function cartSetItems(cart, pairId) {
    return (cart.items || []).filter(function (item) {
      return item.properties && item.properties._ua_pair_id === pairId &&
        ['body', 'name', 'surcharge'].indexOf(item.properties._ua_item_type) !== -1;
    });
  }

  function cartSetSignature(items) {
    return JSON.stringify(items.map(function (item) {
      return [item.variant_id, item.quantity, Object.keys(item.properties || {}).sort().map(function (key) {
        return [key, item.properties[key]];
      })];
    }).sort(function (a, b) { return JSON.stringify(a).localeCompare(JSON.stringify(b)); }));
  }

  function cartEditRequest(action, body) {
    var base = (window.Shopify && window.Shopify.routes.root) || '/';
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    } else { options.cache = 'no-store'; }
    return window.fetch(base + 'cart' + (action ? '/' + action : '') + '.js', options).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.status) throw new Error(responseErrorMessage(json));
        return json;
      });
    });
  }

  function parseCartSet(state, items) {
    var bodies = items.filter(function (item) { return item.properties._ua_item_type === 'body'; });
    if (!bodies.length || bodies.some(function (item) { return Number(item.product_id) !== Number(state.config.productId); })) {
      throw new Error('この商品のセットをカートで確認できませんでした。');
    }
    var slots = {};
    items.filter(function (item) { return item.properties._ua_item_type === 'name'; }).forEach(function (item) {
      var props = item.properties;
      var location = props['刺繍箇所'];
      var slot = slots[location] || (slots[location] = { location: location, font: props['書体'], pieces: {}, order: props._ua_slot });
      if (slot.font !== props['書体']) throw new Error('刺繍の書体を確認できませんでした。');
      var units;
      if (props._ua_units) {
        units = JSON.parse(props._ua_units);
      } else {
        // Existing carts predate structured units. Only accept the complete known format.
        units = [];
        var source = String(props['内訳'] || '');
        var re = /(\d+)枚目 (.*?) ([12])行目「([\s\S]*?)」（([^／]+)／([^／]+)／糸:([^）]+)）/g;
        var match;
        var reconstructed = [];
        while ((match = re.exec(source))) {
          if (match[2] !== location) throw new Error('刺繍箇所を確認できませんでした。');
          units.push([Number(match[1]) - 1, match[3], match[4], match[5], match[6], match[7]]);
          reconstructed.push(match[0]);
        }
        if (!units.length || reconstructed.join(' / ') !== source) throw new Error('刺繍内容を読み戻せませんでした。');
      }
      if (!Array.isArray(units) || !units.length) throw new Error('刺繍内容が見つかりませんでした。');
      units.forEach(function (unit) {
        if (!Array.isArray(unit) || unit.length !== 6 || !Number.isInteger(unit[0]) || unit[0] < 0 || unit[0] >= 100 ||
          ['1', '2'].indexOf(unit[1]) === -1 || !state.core.isValidNameText(unit[2]) ||
          state.sizeOrder.indexOf(unit[3]) === -1 || THREAD_COLORS.indexOf(unit[5]) === -1) {
          throw new Error('刺繍内容の形式を確認できませんでした。');
        }
        var piece = slot.pieces[unit[0]] || (slot.pieces[unit[0]] = { size: unit[3], color: unit[4], thread: unit[5] });
        if (piece.size !== unit[3] || piece.color !== unit[4] || piece.thread !== unit[5] || piece[unit[1]] !== undefined) {
          throw new Error('枚ごとの刺繍内容を確認できませんでした。');
        }
        piece[unit[1]] = unit[2];
      });
    });
    var configs = Object.keys(slots).map(function (key) { return slots[key]; }).sort(function (a, b) {
      return (Number(a.order) || state.editorConfig.enabledLocations.indexOf(a.location) + 1) -
        (Number(b.order) || state.editorConfig.enabledLocations.indexOf(b.location) + 1);
    });
    if (!configs.length || configs.length > 2) throw new Error('刺繍箇所を確認できませんでした。');
    var quantity = bodies.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    if (!state.core.isValidQty(quantity)) throw new Error('枚数を確認できませんでした。');
    configs.forEach(function (config) {
      if (FONTS.indexOf(config.font) === -1 || state.editorConfig.enabledLocations.indexOf(config.location) === -1) {
        throw new Error('現在選択できない書体または刺繍箇所が含まれています。');
      }
      config.pieces = Object.keys(config.pieces).sort(function (a, b) { return Number(a) - Number(b); })
        .map(function (key) { return config.pieces[key]; });
      // The cart's quantity stepper can resize a single, uniform set without rewriting its description.
      if (config.pieces.length !== quantity && bodies.length === 1 && config.pieces.every(function (piece) {
        return JSON.stringify(piece) === JSON.stringify(config.pieces[0]);
      })) {
        var first = config.pieces[0];
        config.pieces = Array.from({ length: quantity }, function () { return Object.assign({}, first); });
      }
      if (config.pieces.length !== quantity || config.pieces.some(function (piece) { return !piece['1']; })) {
        throw new Error('枚数と名前の内訳が一致しません。カートをご確認ください。');
      }
      var hasSecond = !!config.pieces[0]['2'];
      if (config.pieces.some(function (piece) { return !!piece['2'] !== hasSecond; })) throw new Error('2行目の内訳を確認できませんでした。');
    });
    var counts = {};
    configs[0].pieces.forEach(function (piece, index) {
      var variant = resolveSizeVariant(state, piece.color, piece.size);
      if (!variant) throw new Error('ボディの色・サイズを確認できませんでした。');
      counts[variant.variantId] = (counts[variant.variantId] || 0) + 1;
      if (configs[1] && (configs[1].pieces[index].size !== piece.size || configs[1].pieces[index].color !== piece.color)) {
        throw new Error('2箇所のボディ内訳が一致しません。');
      }
    });
    if (bodies.some(function (item) { return counts[item.variant_id] !== item.quantity; }) || Object.keys(counts).length !== bodies.length) {
      throw new Error('ボディの枚数と刺繍内容が一致しません。');
    }
    // The configurator's row order is grouped by size. Keep each person's two slots together.
    var indices = configs[0].pieces.map(function (piece, index) { return index; }).sort(function (a, b) {
      return state.sizeOrder.indexOf(configs[0].pieces[a].size) - state.sizeOrder.indexOf(configs[0].pieces[b].size) || a - b;
    });
    configs.forEach(function (config) { config.pieces = indices.map(function (index) { return config.pieces[index]; }); });
    return configs;
  }

  function cartReviewUrl(state) {
    var url = new URL(window.routes.cart_url, window.location.origin);
    if (state.previewView === 'bss-mobile-r3') url.searchParams.set('view', 'bss-mobile-r3');
    return url.href;
  }

  function restoreCartSet(state) {
    var pairId = new URLSearchParams(window.location.search).get('ua_edit');
    if (!pairId) return;
    state.cartEditLoading = true;
    var notice = document.createElement('div');
    notice.className = 'ua-body-cart-edit';
    var message = document.createElement('p');
    message.textContent = 'カートの設定を読み込んでいます…';
    var cancel = document.createElement('a');
    cancel.href = cartReviewUrl(state);
    cancel.textContent = '変更せずカートに戻る';
    notice.appendChild(message);
    notice.appendChild(cancel);
    state.root.insertBefore(notice, state.root.firstChild);
    state.cartEditNotice = message;
    wizardRender(state);
    cartEditRequest('').then(function (cart) {
      var items = cartSetItems(cart, pairId);
      var configs = parseCartSet(state, items);
      state.cartEdit = { pairId: pairId, signature: cartSetSignature(items) };
      state.cartEditRestoring = true;
      var els = state.elements;
      var pieces = configs[0].pieces;
      var quantity = pieces.length;
      var counts = {};
      pieces.forEach(function (piece) { counts[piece.size] = (counts[piece.size] || 0) + 1; });
      els.sizeRows.textContent = '';
      state.sizeOrder.forEach(function (size) { if (counts[size]) addSizeRow(state, size, counts[size]); });
      syncQuantityFromMatrix(state);
      els.attrIndividualToggle.checked = pieces.some(function (piece) {
        return piece.color !== getSelectedColor(state) || piece.thread !== pieces[0].thread;
      });
      setLocation(state, configs[0].location);
      els.font.value = configs[0].font;
      setThreadColor(state, pieces[0].thread);
      els.location2Panel.hidden = !configs[1];
      // Restored secondary styles must not be silently overwritten by the simplified wizard.
      state.cartEditPreserveStyle = !!configs[1] && (configs[1].font !== configs[0].font || configs[1].pieces.some(function (piece, i) {
        return piece.thread !== pieces[i].thread;
      }));
      configs.forEach(function (config, slot) {
        var lines = slot ? els.location2Lines : els.lines;
        var secondLine = slot ? els.location2Line2Enable : els.line2Enable;
        secondLine.checked = !!config.pieces[0]['2'];
        if (slot) {
          els.location2Select.value = config.location;
          els.location2ContentModes.forEach(function (radio) { radio.checked = radio.value === 'different'; });
          els.location2Font.value = config.font;
          els.location2Thread.value = config.pieces[0].thread;
          els.location2ThreadIndividual.checked = config.pieces.some(function (piece) { return piece.thread !== config.pieces[0].thread; });
        }
        lines.forEach(function (line) {
          var values = config.pieces.map(function (piece) { return piece[line.key] || ''; });
          var mode = uniqueValueCount(values) > 1 ? TEXT_MODE_INDIVIDUAL : TEXT_MODE_SAME;
          line.modes.forEach(function (radio) { radio.checked = radio.value === mode; });
          line.text.value = values[0];
        });
      });
      applyLine2Enabled(state);
      applyLocation2Ui(state);
      configs.forEach(function (config, slot) {
        (slot ? els.location2Lines : els.lines).forEach(function (line) {
          getLineRowTextInputs(state, line).forEach(function (input, index) { input.value = config.pieces[index][line.key] || ''; });
        });
      });
      getLineRowColorSelects(state).forEach(function (select, index) {
        select.value = pieces[index].color;
        select.setAttribute('data-ua-touched', '1');
        refreshRowColorSwatch(state, select);
      });
      getLineRowThreadSelects(state).forEach(function (select, index) {
        select.value = pieces[index].thread;
        select.setAttribute('data-ua-touched', '1');
        refreshRowThreadSwatch(state, select);
      });
      getLocation2RowThreadSelects(state).forEach(function (select, index) {
        select.value = configs[1].pieces[index].thread;
        select.setAttribute('data-ua-touched', '1');
        refreshRowThreadSwatch(state, select);
      });
      state.cartEditRestoring = false;
      state.cartEditLoading = false;
      if (state.wizard) {
        state.wizard.qtyBand = quantity === 1 ? 'one' : quantity < 10 ? 'few' : 'team';
        state.wizard.targetQty = quantity;
        state.wizard.qtyStated = quantity;
        els.wizardQtyNum.value = String(quantity);
        state.wizard.step = wizardSteps(state).indexOf('review');
      }
      updateAllLineProgress(state);
      loadSelectedFont(state);
      updatePrice(state);
      setEditorEmbroiderySlot(state, '1');
      updateEditor(state);
      wizardRender(state);
      setLoading(state, false);
      message.textContent = 'カートの設定を引き継ぎました。変更して保存すると、元のセットを更新します。';
      state.root.scrollIntoView({ block: 'start' });
    }).catch(function (error) {
      state.cartEditRestoring = false;
      state.cartEditLoading = false;
      state.cartEditBlocked = true;
      message.textContent = error.message + ' 元のセットはカートに残っています。';
      wizardRender(state);
      state.root.scrollIntoView({ block: 'start' });
    });
  }

  function replaceCartSet(state, order) {
    var edit = state.cartEdit;
    var revision = makePairId();
    order.includeSmallLotFee = false;
    var expected = buildPayload(state, order, edit.pairId).items;
    var additions = [];
    var kept = [];
    var original = [];
    var toRemove = [];
    var deletionStarted = false;
    function newLines(cart) {
      return cartSetItems(cart, edit.pairId).filter(function (item) { return item.properties._ua_revision === revision; });
    }
    function oldLines(cart) {
      return cartSetItems(cart, edit.pairId).filter(function (item) { return item.properties._ua_revision !== revision; });
    }
    function expectedLines(items) {
      return items.map(function (item) { return { variant_id: item.id, quantity: item.quantity, properties: item.properties }; });
    }
    function removeItems(items) {
      if (!items.length) return Promise.resolve();
      var updates = {};
      items.forEach(function (item) { updates[item.key] = 0; });
      return cartEditRequest('update', { updates: updates });
    }
    function setQuantity(item, quantity) {
      // change.js validates stock. Reuse body lines so editing never requires twice the stock.
      return cartEditRequest('change', { id: item.key, quantity: quantity });
    }
    function verifyAdded(cart) {
      return cartSetSignature(newLines(cart)) === cartSetSignature(expectedLines(additions));
    }
    state.submitting = true;
    setLoading(state, true);
    return cartEditRequest('').then(function (cart) {
      original = oldLines(cart);
      if (cartSetSignature(original) !== edit.signature) {
        throw new Error('編集中にカートが変更されました。カートからもう一度開いてください。');
      }
      expected.forEach(function (item) {
        var match = original.find(function (old) {
          var props = Object.assign({}, old.properties);
          delete props._ua_revision;
          return cartSetSignature([{ variant_id: old.variant_id, quantity: 1, properties: props }]) ===
            cartSetSignature([{ variant_id: item.id, quantity: 1, properties: item.properties }]);
        });
        if (match) {
          item.properties = match.properties;
          kept.push({ item: match, quantity: item.quantity });
        } else {
          item.properties._ua_revision = revision;
          additions.push(item);
        }
      });
      toRemove = original.filter(function (item) { return !kept.some(function (entry) { return entry.item === item; }); });
      return additions.length ? cartEditRequest('add', { items: additions }).catch(function () {
        // A lost response can still mean the add succeeded. Read back before deciding.
      }) : Promise.resolve();
    }).then(function () {
      return cartEditRequest('');
    }).then(function (cart) {
      if (!verifyAdded(cart)) throw new Error('変更内容を追加できませんでした。在庫と通信状況をご確認ください。');
      if (cartSetSignature(oldLines(cart)) !== edit.signature) throw new Error('編集中にカートが変更されました。カートをご確認ください。');
      return kept.reduce(function (promise, entry) {
        if (entry.item.quantity === entry.quantity) return promise;
        return promise.then(function () { return setQuantity(entry.item, entry.quantity); });
      }, Promise.resolve());
    }).then(function () {
      return cartEditRequest('');
    }).then(function (cart) {
      var beforeRemoval = expectedLines(expected).concat(toRemove);
      if (cartSetSignature(cartSetItems(cart, edit.pairId)) !== cartSetSignature(beforeRemoval)) {
        throw new Error('カートの数量を確認できませんでした。');
      }
      deletionStarted = true;
      return removeItems(toRemove).catch(function () { /* Verify an ambiguous update response below. */ });
    }).then(function () {
      return cartEditRequest('');
    }).then(function (cart) {
      if (cartSetSignature(cartSetItems(cart, edit.pairId)) !== cartSetSignature(expectedLines(expected))) {
        throw new Error('カートの更新を完了できませんでした。');
      }
      state.cartEditBlocked = true; // Avoid resubmitting after a successful edit if fees cannot be checked.
      return window.UaSmallLotFee.reconcile();
    }).then(function () {
      window.location.assign(cartReviewUrl(state));
    }).catch(function (error) {
      return cartEditRequest('').then(function (cart) {
        // If removals may have committed, retain everything and require a cart check.
        if (deletionStarted && toRemove.some(function (old) {
          return !oldLines(cart).some(function (item) { return item.key === old.key && item.quantity === old.quantity; });
        })) throw error;
        return kept.reduce(function (promise, entry) {
          var current = oldLines(cart).find(function (item) { return item.key === entry.item.key; });
          if (!current) throw error;
          if (current.quantity === entry.item.quantity) return promise;
          return promise.then(function () { return setQuantity(current, entry.item.quantity); });
        }, Promise.resolve()).then(function () { return cartEditRequest(''); }).then(function (restored) {
          if (original.length && cartSetSignature(oldLines(restored)) !== edit.signature) throw error;
          return removeItems(newLines(restored));
        }).then(function () { return window.UaSmallLotFee.reconcile(); }).then(function () {
          showError(state, error.message + ' 元のセットは変更していません。');
        });
      }).catch(function () {
        state.cartEditBlocked = true;
        state.cartEditNotice.textContent = '更新結果を確認できませんでした。カートに戻って内容をご確認ください。';
        showError(state, '追加操作を止めました。上のリンクからカートをご確認ください。');
      });
    }).finally(function () {
      state.submitting = false;
      setLoading(state, false);
      wizardRender(state);
    });
  }

  function editorPersonIndex(state) {
    var count = Math.max(1, getMatrixTotal(state));
    state.editorPerson = Math.min(count - 1, Math.max(0, state.editorPerson || 0));
    return state.editorPerson;
  }

  function followEditorPerson(state, target) {
    var row = target && target.closest && target.closest('.ua-body-configurator__row');
    if (!row) return;
    var rows = Array.prototype.slice.call(row.parentNode.querySelectorAll('.ua-body-configurator__row'));
    state.editorPerson = Math.max(0, rows.indexOf(row));
    setEditorEmbroiderySlot(state, state.elements.location2Rows.contains(row) ? '2' : '1');
  }

  function syncEditorPersonPicker(state) {
    var els = state.elements;
    if (!state.editorPersonSelect) {
      var label = document.createElement('label');
      label.className = 'ua-body-editor-person';
      label.textContent = 'プレビューする人';
      var select = document.createElement('select');
      select.className = 'ua-body-configurator__select';
      select.setAttribute('aria-label', 'プレビューする人');
      select.addEventListener('change', function () {
        state.editorPerson = Number(select.value) || 0;
        updateEditor(state);
      });
      label.appendChild(select);
      els.editorSummary.parentNode.insertBefore(label, els.editorSummary);
      state.editorPersonSelect = select;
      state.editorPersonLabel = label;
    }
    var count = getMatrixTotal(state);
    var index = editorPersonIndex(state);
    state.editorPersonLabel.hidden = count < 2 || !(rowCardsVisible(state) || location2RowCardsVisible(state));
    if (state.editorPersonLabel.hidden) return;
    var sizes = derivePieceSizes(state);
    var names = getLineMode(state, getLine(state, '1')) === TEXT_MODE_INDIVIDUAL ? getLineIndividualNames(state, getLine(state, '1')) : [];
    var labels = sizes.map(function (size, i) { return (i + 1) + '枚目・' + size + (names[i] ? '・' + names[i] : ''); });
    var signature = JSON.stringify(labels);
    if (state.editorPersonOptions !== signature) {
      state.editorPersonSelect.textContent = '';
      labels.forEach(function (text, i) {
        var option = document.createElement('option');
        option.value = String(i);
        option.textContent = text;
        state.editorPersonSelect.appendChild(option);
      });
      state.editorPersonOptions = signature;
    }
    state.editorPersonSelect.value = String(index);
  }

  function clearResolvedInputError(state, target) {
    if (!target || target.getAttribute('aria-invalid') !== 'true') return;
    var order = validateOrder(state);
    if (!order.valid && order.ariaTarget === target) target.setAttribute('aria-invalid', 'true');
  }

  function cartSubmitLabel(state) {
    return state.cartEdit ? '変更を保存してカートに戻る' : '刺繍込みでカートに追加';
  }


  function buildPayload(state, order, pairId) {
    var bodyVariantIds = order.bodyLines
      .map(function (bodyLine) {
        return bodyLine.variantId;
      })
      .join(',');

    var items = order.bodyLines.map(function (bodyLine) {
      return {
        id: bodyLine.variantId,
        quantity: bodyLine.count,
        properties: {
          _ua_pair_id: pairId,
          _ua_item_type: 'body',
          _ua_configurator: CONFIGURATOR_TAG
        }
      };
    });

    order.bandLines.forEach(function (bandLine) {
      var properties = {
        '加工種別': 'ネーム刺繍',
        '内訳': describeBandUnits(bandLine.units),
        '書体': bandLine.font,
        '文字の高さ': '〜12mm',
        '刺繍箇所': bandLine.location,
        _ua_pair_id: pairId,
        _ua_body_variant_ids: bodyVariantIds,
        _ua_price_band: bandLine.band.code,
        _ua_slot: bandLine.slot,
        _ua_units: JSON.stringify(bandLine.units.map(function (unit) {
          return [unit.index, unit.lineKey, unit.text, unit.size, unit.bodyColor, unit.threadColor];
        })),
        _ua_item_type: 'name',
        _ua_configurator: CONFIGURATOR_TAG
      };
      items.push({
        id: bandLine.band.variantId,
        quantity: bandLine.count,
        properties: properties
      });
    });

    order.surchargeLines.forEach(function (surchargeLine) {
      var surchargeProperties = {
        '加工種別': surchargeLine.label,
        '料金': formatYen(surchargeLine.unitPrice) + '／枚'
      };
      if (surchargeLine.rule) surchargeProperties['加算ルール'] = surchargeLine.rule;
      surchargeProperties._ua_pair_id = pairId;
      surchargeProperties._ua_body_variant_ids = bodyVariantIds;
      surchargeProperties._ua_surcharge_code = surchargeLine.code;
      surchargeProperties._ua_item_type = 'surcharge';
      surchargeProperties._ua_configurator = CONFIGURATOR_TAG;
      items.push({
        id: surchargeLine.variantId,
        quantity: surchargeLine.count,
        properties: surchargeProperties
      });
    });

    if (order.includeSmallLotFee && order.smallLotFeeLine) {
      items.push({
        id: order.smallLotFeeLine.variantId,
        quantity: 1,
        properties: {
          '加工種別': '小ロット対応費',
          '対象': 'ネーム刺繍1〜9枚',
          '料金': formatYen(order.smallLotFeeLine.unitPrice) + '／注文',
          _ua_pair_id: 'ua-small-lot-order',
          _ua_small_lot_fee: 'true',
          _ua_item_type: 'small_lot_fee',
          _ua_configurator: CONFIGURATOR_TAG
        }
      });
    }

    return appendCartSections(state, { items: items });
  }

  function addConfiguredProduct(state, order) {
    if (state.cartEditLoading || state.cartEditBlocked || state.submitting) return;
    if (state.cartEdit) return replaceCartSet(state, order);
    if (!order.bodyLines || !order.bodyLines.length) {
      showError(state, 'ボディを確認できません。サイズを選び直してください。', state.variantInput);
      return;
    }
    var bodyVariantId = order.bodyLines[0].variantId;
    var pairId = makePairId();
    state.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (state.cart && typeof state.cart.setActiveElement === 'function') {
      state.cart.setActiveElement(document.activeElement);
    }

    state.submitting = true;
    state.hadError = false;
    setLoading(state, true);

    if (!window.UaSmallLotFee || typeof window.UaSmallLotFee.prepareForAdd !== 'function') {
      state.submitting = false;
      setLoading(state, false);
      showError(state, '小ロット対応費を確認できませんでした。ページを再読み込みしてください。');
      return;
    }

    return window.UaSmallLotFee.prepareForAdd(order.quantity)
      .then(function (feeState) {
        order.includeSmallLotFee = !!feeState.includeFee;
        var payload = buildPayload(state, order, pairId);
        var request = fetchConfig('javascript');
        request.headers['X-Requested-With'] = 'XMLHttpRequest';
        request.headers['Content-Type'] = 'application/json';
        request.body = JSON.stringify(payload);
        return window.fetch(window.routes.cart_add_url, request);
      })
      .then(function (httpResponse) {
        return httpResponse.json().then(function (response) {
          return { ok: httpResponse.ok, body: response };
        });
      })
      .then(function (result) {
        var response = result.body;
        if (!result.ok || response.status) {
          throw new Error(responseErrorMessage(response));
        }
        return response;
      })
      .then(function (response) {
        clearError(state);
        publishCartEvent('update', bodyVariantId, response);

        if (!state.cart) {
          window.location = cartReviewUrl(state);
          return;
        }
        try {
          state.cart.renderContents(response);
        } catch (renderError) {
          console.warn('[ua-body-configurator] cart render failed after successful add', renderError);
          window.location = cartReviewUrl(state);
        }
      })
      .catch(function (error) {
        state.hadError = true;
        console.error('[ua-body-configurator] cart add failed', error);
        if (window.UaSmallLotFee && typeof window.UaSmallLotFee.reconcile === 'function') {
          window.UaSmallLotFee.reconcile().catch(function (reconcileError) {
            console.error('[ua-body-configurator] small-lot fee recovery failed', reconcileError);
          });
        }
        showError(state, 'カートを確認できませんでした。通信環境をご確認のうえ、もう一度お試しください。');
      })
      .finally(function () {
        state.submitting = false;
        setLoading(state, false);
        if (state.cart && state.cart.classList.contains('is-empty')) state.cart.classList.remove('is-empty');
      });
  }

  function showOrderValidationError(state, order) {
    order.ariaTarget.setAttribute('aria-invalid', 'true');
    showError(state, order.message, order.target);
  }

  function validateAndAddConfiguredProduct(state) {
    clearError(state);
    var order = validateOrder(state);
    if (!order.valid) {
      showOrderValidationError(state, order);
      return;
    }

    addConfiguredProduct(state, order);
  }

  function onSubmit(state, event) {
    // form.id は input[name="id"] にシャドウされ要素を返すため getAttribute で比較する
    var targetId = event.target && event.target.getAttribute ? event.target.getAttribute('id') : null;
    if (targetId !== state.config.formId) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (state.submitting) return;

    clearError(state);
    var order = validateOrder(state);
    if (!order.valid) {
      showOrderValidationError(state, order);
      return;
    }

    if (!state.colorVariantPending) {
      addConfiguredProduct(state, order);
      return;
    }

    state.submitting = true;
    setLoading(state, true);
    waitForColorVariantResolution(state)
      .then(function () {
        state.submitting = false;
        setLoading(state, false);
        validateAndAddConfiguredProduct(state);
      })
      .catch(function () {
        state.submitting = false;
        setLoading(state, false);
        showError(
          state,
          'カラー変更後の商品情報を確認できませんでした。もう一度カラーを選択してからお試しください。',
          colorPickerFocusTarget(state)
        );
      });
  }

  // ───────────────────────────────────────────────────────────────────────
  // 質問形式の注文フロー（ウィザード）
  //
  // 別実装ではない。DOM は現行フォームのまま1つで、ウィザードは
  // 「いまどのブロックを見せるか」を決める薄い表示層。
  // 料金計算・バリデーション・カート投入・fail-closed ガードには一切触らない。
  // 「つぎへ」の活性判定も、そのステップに対応する既存入力の妥当性そのもので決める。
  // ───────────────────────────────────────────────────────────────────────
  var WIZARD_HIDDEN_CLASS = 'ua-body-wizard-hidden';
  var WIZARD_ORDER = Object.freeze(['qty', 'place', 'body', 'text', 'loc2text', 'font', 'thread', 'review']);
  var WIZARD_COPY = Object.freeze({
    qty: { q: '何枚つくりますか？', sub: 'あとから変えられます。' },
    place: { q: 'どこに入れますか？', sub: '刺繍する場所を選んでください。2箇所に入れることもできます。' },
    body: { q: '色とサイズを選んでください', sub: 'サイズごとの枚数を決めます。' },
    text: {
      q: '入れる文字を教えてください',
      sub: '行ごとに「全員同じ文字」か「1枚ごとに変える」かを選べます。1〜10文字・料金は¥360〜620です。'
    },
    loc2text: { q: '2箇所目には何を入れますか？', sub: '1箇所目と同じでも、別の内容でも構いません。' },
    font: { q: '書体を選んでください', sub: '選んだ書体が仕上がりイメージに反映されます。' },
    thread: { q: '糸の色を選んでください', sub: 'ボディの色に対して読みやすい色をお選びください。' },
    review: { q: 'この内容でよろしいですか？', sub: '' }
  });

  function wizardActive(state) {
    return !!(state && state.wizard && state.wizard.active);
  }

  // 2箇所目を使わない注文では「2箇所目には何を入れますか」を出さない。
  function wizardSteps(state) {
    return WIZARD_ORDER.filter(function (key) {
      return !(key === 'loc2text' && !secondLocationEnabled(state));
    });
  }

  function wizardStepBlocks(state, key) {
    var els = state.elements;
    if (key === 'qty') return [els.wizardQty];
    if (key === 'place') return [els.locationField, els.location2Field];
    if (key === 'body') return [els.colorSlot, els.sizeField];
    if (key === 'text') return [els.textField, els.pieceRows];
    if (key === 'loc2text') return [els.location2Field];
    if (key === 'font') return [els.fontPicker];
    if (key === 'thread') return [els.threadColorField];
    return [];
  }

  // 「何枚つくりますか」の答え。枚数の正本はあくまでサイズ行なので、
  // 選ばれた枚数を最初のサイズ行へ流し込み、残りの行は畳む（内訳は次の質問で決める）。
  function wizardSetTargetQty(state, value) {
    var next = Math.max(1, Math.min(100, Math.floor(Number(value)) || 0));
    state.wizard.targetQty = next;
    var rows = getSizeRows(state);
    for (var i = rows.length - 1; i >= 1; i--) rows[i].remove();
    var first = getSizeRows(state)[0];
    if (first) {
      var qtyInput = first.querySelector('[data-ua-body-sizerow-qty]');
      if (qtyInput) qtyInput.value = String(next);
    }
    refreshSizeRowOptions(state);
    clearError(state);
    handleSizeRowsChange(state);
  }

  function wizardSizeRowPending(state) {
    return getSizeRows(state).some(function (row) {
      var select = row.querySelector('[data-ua-body-sizerow-select]');
      var qtyInput = row.querySelector('[data-ua-body-sizerow-qty]');
      return select && !select.value && readSizeCount(qtyInput) > 0;
    });
  }

  // その行がまだ足りていない理由。空文字＝この行は完成している。
  function wizardLineHint(state, prefix, line, quantity) {
    var mode = getLineMode(state, line);
    if (!mode) return prefix + 'の入力方法（全員同じ文字／1枚ごとに変える）を選んでください。';
    if (mode === TEXT_MODE_SAME) {
      return state.core.isValidNameText(getLineSameText(line))
        ? ''
        : prefix + 'の文字を1〜10文字で入力してください。';
    }
    var names = getLineIndividualNames(state, line);
    var filled = names.filter(function (name) {
      return state.core.isValidNameText(name);
    }).length;
    if (names.length !== quantity || filled !== quantity) {
      return prefix + '：' + filled + ' / ' + quantity + '件 入力済み。';
    }
    return '';
  }

  function wizardLinesHint(state, lines, prefixOf, quantity) {
    var hint = '';
    lines.some(function (line) {
      hint = wizardLineHint(state, prefixOf(line), line, quantity);
      return !!hint;
    });
    return hint;
  }

  // Q1で選んだ「帯」と実際の合計がずれたときだけ、進行は止めずに知らせる。
  // 枚数の正本はサイズ内訳なので、ここで押し戻すことはしない。
  function wizardQtyBandNote(state, quantity) {
    var band = state.wizard.qtyBand;
    if (band === 'one' && quantity > 1) {
      return '「1枚だけ」でお選びでしたが、いまの合計は' + quantity + '枚です。このまま進めます。';
    }
    if (band === 'team' && quantity < 10) {
      return '「10枚以上」でお選びでしたが、いまの合計は' + quantity + '枚です。このまま進めます。';
    }
    return '';
  }

  function wizardQtyInBand(band, quantity) {
    if (quantity <= 0) return false;
    if (band === 'one') return quantity === 1;
    if (band === 'few') return quantity >= 2 && quantity <= 9;
    if (band === 'team') return quantity >= 10;
    return false;
  }

  function wizardStepState(state, key) {
    var els = state.elements;
    var quantity = getMatrixTotal(state);
    var target = state.wizard.targetQty;

    if (key === 'qty') {
      return { ready: target > 0, hint: '' };
    }
    if (key === 'place') {
      if (!els.location.value) return { ready: false, hint: '刺繍する場所を選んでください。' };
      if (secondLocationEnabled(state) && !els.location2Select.value) {
        return { ready: false, hint: '2箇所目の場所を選んでください。' };
      }
      return { ready: true, hint: '' };
    }
    if (key === 'body') {
      if (!getSelectedColor(state)) return { ready: false, hint: 'ボディの色を選んでください。' };
      if (wizardSizeRowPending(state)) return { ready: false, hint: '追加したサイズを選んでください。' };
      // 枚数の正本はサイズ内訳。合計そのものが注文枚数なので、Q1の答えとのズレでは止めない。
      // 合計はカード内の「合計 ◯枚」に出ているので、ここで重ねて出さない。
      if (quantity < 1) return { ready: false, hint: 'サイズごとの枚数を入れてください。' };
      // 本人が枚数を打ち込んでいたときだけ、変わったことを知らせる（止めはしない）。
      var stated = state.wizard.qtyStated;
      if (stated > 0 && stated !== quantity) {
        return {
          ready: true,
          note: true,
          hint: 'ご注文枚数を ' + stated + '枚 → ' + quantity + '枚 に更新しました。'
        };
      }
      return { ready: true, hint: wizardQtyBandNote(state, quantity), note: true };
    }
    if (key === 'text') {
      if (!state.core.isValidQty(quantity)) {
        return { ready: false, hint: '先に「色とサイズ」で枚数を決めてください。' };
      }
      var textHint = wizardLinesHint(state, activeLines(state), function (line) {
        return line.key + '行目';
      }, quantity);
      return { ready: !textHint, hint: textHint };
    }
    if (key === 'loc2text') {
      if (!secondContentDifferent(state)) return { ready: true, hint: '' };
      if (!state.core.isValidQty(quantity)) {
        return { ready: false, hint: '先に「色とサイズ」で枚数を決めてください。' };
      }
      var loc2Hint = wizardLinesHint(state, activeLocation2Lines(state), function (line) {
        return '2箇所目の' + line.key + '行目';
      }, quantity);
      return { ready: !loc2Hint, hint: loc2Hint };
    }
    if (key === 'font') {
      return { ready: FONTS.indexOf(els.font.value) !== -1, hint: '' };
    }
    if (key === 'thread') {
      var threadOk = THREAD_COLORS.indexOf(els.threadColor.value) !== -1;
      return { ready: threadOk, hint: threadOk ? '' : '糸の色を選んでください。' };
    }
    // 確認：合計が出せていない＝どこかが未入力。押せば既存のバリデーションが場所を教えてくれる。
    var priced = els.orderTotal && els.orderTotal.textContent !== '—';
    return {
      ready: true,
      hint: priced ? '' : '入力に不足があります。各項目の「変更」から見直してください。'
    };
  }

  function wizardSizeText(state) {
    var counts = getMatrixCounts(state);
    return state.sizeOrder
      .filter(function (size) { return counts[size] > 0; })
      .map(function (size) { return size + '×' + counts[size]; })
      .join('・');
  }

  function wizardLineSummary(state, line) {
    var mode = getLineMode(state, line);
    if (!mode) return '未選択';
    if (mode === TEXT_MODE_SAME) return getLineSameText(line) + '（全員同じ文字）';
    var names = getLineIndividualNames(state, line).filter(Boolean);
    if (!names.length) return '未入力（1枚ごと）';
    return names.slice(0, 3).join('・') + (names.length > 3 ? ' ほか' : '') + '（1枚ごと）';
  }

  function wizardReviewRows(state) {
    var els = state.elements;
    var rows = [];
    rows.push({ label: '枚数', value: getMatrixTotal(state) + '枚', step: 'qty' });
    var places = [els.location.value];
    if (secondLocationEnabled(state)) places.push(els.location2Select.value);
    rows.push({ label: '場所', value: places.filter(Boolean).join(' ＋ '), step: 'place' });
    rows.push({
      label: '色・サイズ',
      value: (getSelectedColor(state) || '未選択') + ' / ' + (wizardSizeText(state) || '未指定'),
      step: 'body'
    });
    activeLines(state).forEach(function (line) {
      rows.push({
        label: els.location.value + '・' + line.key + '行目',
        value: wizardLineSummary(state, line),
        step: 'text'
      });
    });
    if (secondLocationEnabled(state)) {
      if (!secondContentDifferent(state)) {
        rows.push({ label: els.location2Select.value, value: '1箇所目と同じ内容', step: 'loc2text' });
      } else {
        activeLocation2Lines(state).forEach(function (line) {
          rows.push({
            label: els.location2Select.value + '・' + line.key + '行目',
            value: wizardLineSummary(state, line),
            step: 'loc2text'
          });
        });
      }
    }
    rows.push({ label: '書体', value: els.font.value, step: 'font' });
    rows.push({ label: '糸色', value: els.threadColor.value || '未選択', step: 'thread' });
    return rows;
  }

  function wizardRenderReview(state) {
    var container = state.elements.wizardReview;
    container.textContent = '';
    wizardReviewRows(state).forEach(function (row) {
      var line = document.createElement('div');
      line.className = 'ua-body-wizard__rrow';
      var copy = document.createElement('span');
      var label = document.createElement('span');
      label.className = 'ua-body-wizard__rlabel';
      label.textContent = row.label;
      var value = document.createElement('b');
      value.textContent = row.value;
      copy.appendChild(label);
      copy.appendChild(value);
      var jump = document.createElement('button');
      jump.type = 'button';
      jump.className = 'ua-body-wizard__rjump';
      jump.setAttribute('data-ua-body-wizard-jump', row.step);
      jump.textContent = '変更';
      line.appendChild(copy);
      line.appendChild(jump);
      container.appendChild(line);
    });
  }

  // ── まとめて貼り付け ────────────────────────────────────────
  // 1枚ごとの名前を改行区切りで流し込む入力補助。書き込み先は各枚の欄そのもので、
  // 値を入れたあとは既存のinputイベントを流して進捗・料金・プレビューを更新させる。
  // （＝独自の注文データを持たない。貼り付けたあとの扱いは手入力と完全に同じ）
  function wizardFillRowInput(input, value) {
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // いま「1枚ごとに変える」で、かつ2枚以上ある行だけが対象。
  function wizardBulkTargets(state) {
    var quantity = getMatrixTotal(state);
    var targets = [];
    if (!state.core.isValidQty(quantity) || quantity < 2) return targets;
    activeLines(state).forEach(function (line) {
      if (getLineMode(state, line) !== TEXT_MODE_INDIVIDUAL) return;
      targets.push({ key: '1:' + line.key, slot: '1', line: line, label: line.key + '行目' });
    });
    activeLocation2Lines(state).forEach(function (line) {
      if (getLineMode(state, line) !== TEXT_MODE_INDIVIDUAL) return;
      targets.push({ key: '2:' + line.key, slot: '2', line: line, label: '2箇所目の' + line.key + '行目' });
    });
    return targets;
  }

  function wizardApplyBulk(state, panel) {
    var target = panel.target;
    var quantity = getMatrixTotal(state);
    var inputs = getLineRowTextInputs(state, target.line);
    if (!inputs.length || inputs.length !== quantity) {
      panel.note.textContent = '先に「色とサイズ」で枚数を確定してください。';
      return;
    }
    var values = String(panel.area.value)
      .split('\n')
      .map(function (text) { return text.trim(); })
      .filter(function (text) { return text.length > 0; });
    var truncated = 0;
    var applied = 0;
    for (var i = 0; i < inputs.length && i < values.length; i += 1) {
      var value = values[i];
      if (state.core.textLength(value) > 10) {
        value = Array.from(value).slice(0, 10).join('');
        truncated += 1;
      }
      wizardFillRowInput(inputs[i], value);
      applied += 1;
    }
    var message = applied + '件を各枚の欄に入れました。';
    if (values.length > inputs.length) {
      message += ' ' + (values.length - inputs.length) + '件は枚数（' + quantity + '枚）を超えるので使っていません。';
    } else if (values.length < inputs.length) {
      // 足りないぶんは消さずに残す（貼り直しで既存の入力を巻き添えにしない）。
      message += ' 残り' + (inputs.length - values.length) + '枚はそのままにしました。';
    }
    if (truncated) {
      message += ' 10文字を超えた' + truncated + '件は先頭10文字にしました。';
    }
    panel.note.textContent = message;
  }

  function wizardBuildBulkPanel(state, target) {
    var wrap = document.createElement('div');
    wrap.className = 'ua-body-wizard__bulk';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ua-body-wizard__bulk-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    wrap.appendChild(toggle);

    var body = document.createElement('div');
    body.className = 'ua-body-wizard__bulk-body';
    body.hidden = true;
    wrap.appendChild(body);

    var area = document.createElement('textarea');
    area.className = 'ua-body-configurator__input ua-body-wizard__bulk-area';
    area.setAttribute('rows', '5');
    area.setAttribute('placeholder', 'やまだ\nたなか\nさとう');
    area.setAttribute('aria-label', target.label + 'を改行区切りでまとめて入力');
    body.appendChild(area);

    var note = document.createElement('p');
    note.className = 'ua-body-configurator__help ua-body-wizard__bulk-note';
    note.setAttribute('aria-live', 'polite');
    body.appendChild(note);

    var apply = document.createElement('button');
    apply.type = 'button';
    apply.className = 'ua-body-wizard__bulk-apply';
    apply.textContent = '各枚の欄に入れる';
    body.appendChild(apply);

    var panel = { wrap: wrap, toggle: toggle, body: body, area: area, note: note, target: target };

    toggle.addEventListener('click', function () {
      panel.body.hidden = !panel.body.hidden;
      toggle.setAttribute('aria-expanded', panel.body.hidden ? 'false' : 'true');
      if (!panel.body.hidden) panel.area.focus({ preventScroll: true });
    });
    area.addEventListener('input', function () {
      var count = String(panel.area.value).split('\n').filter(function (text) {
        return text.trim().length > 0;
      }).length;
      panel.note.textContent = count + '件を読み取れます。1行に1人ぶん、改行で区切ってください。';
    });
    apply.addEventListener('click', function () { wizardApplyBulk(state, panel); });

    return panel;
  }

  function wizardSyncBulk(state) {
    var slots = state.elements.wizardBulkSlots;
    if (!slots || !slots['1']) return;
    var targets = wizardBulkTargets(state);
    var quantity = getMatrixTotal(state);
    var seen = {};
    targets.forEach(function (target) {
      var slot = slots[target.slot];
      if (!slot) return;
      var panel = state.wizard.bulkPanels[target.key];
      if (!panel) {
        panel = wizardBuildBulkPanel(state, target);
        state.wizard.bulkPanels[target.key] = panel;
      }
      panel.target = target;
      if (panel.wrap.parentNode !== slot) slot.appendChild(panel.wrap);
      panel.wrap.hidden = false;
      panel.toggle.textContent = target.label + 'をまとめて貼り付ける（' + quantity + '枚ぶん）';
      seen[target.key] = true;
    });
    Object.keys(state.wizard.bulkPanels).forEach(function (key) {
      if (!seen[key]) state.wizard.bulkPanels[key].wrap.hidden = true;
    });
    ['1', '2'].forEach(function (slotKey) {
      var slot = slots[slotKey];
      if (!slot) return;
      slot.hidden = !targets.some(function (target) { return target.slot === slotKey; });
    });
  }

  // ウィザードでは書体・糸色は1問ずつしか聞かない。2箇所目に別内容を入れる場合も
  // 書体・糸色は1箇所目のものを使う（1枚ごとの糸色指定は「くわしい設定」の担当）。
  function wizardMirrorLocation2Style(state) {
    var els = state.elements;
    if (state.cartEditRestoring || state.cartEditPreserveStyle || !secondContentDifferent(state)) return false;
    var changed = false;
    if (els.location2Font.value !== els.font.value) {
      els.location2Font.value = els.font.value;
      changed = true;
    }
    var thread = els.threadColor.value;
    if (THREAD_COLORS.indexOf(thread) !== -1 && els.location2Thread.value !== thread) {
      els.location2Thread.value = thread;
      updateUntouchedLocation2RowThreads(state);
      changed = true;
    }
    return changed;
  }

  // テーマ本体の購入ボタンはコンフィギュレーターの直下にある。質問の途中でこれが見えていると
  // 「つぎへ」と並んで2つ目のCTAになってしまうので、確認ステップまでは畳む。
  // 参照は毎回引き直す（バリアント変更でテーマがフォームごと差し替えるため）。
  function wizardSyncNativeSubmit(state, visible) {
    var form = state.config && state.config.formId
      ? document.getElementById(state.config.formId)
      : null;
    var submit = form ? form.querySelector('[type="submit"]') : null;
    if (!submit) return;
    var hidden = submit.getAttribute('data-ua-body-wizard-hid') === '1';
    if (visible) {
      if (!hidden) return;
      submit.style.removeProperty('display');
      submit.removeAttribute('data-ua-body-wizard-hid');
      return;
    }
    if (hidden) return;
    // アプリ由来のCSS（ymq-option.css 等）がこのボタンに display を !important で当てているため、
    // クラスでは勝てない。インライン宣言（作者スタイルの中で最優先）で畳み、印を付けて元に戻せるようにする。
    submit.style.setProperty('display', 'none', 'important');
    submit.setAttribute('data-ua-body-wizard-hid', '1');
  }

  function wizardRender(state) {
    if (!wizardActive(state)) return;
    if (!state.wizard.mirroring && wizardMirrorLocation2Style(state)) {
      // 引き写した値で価格・プレビューを引き直す。再入は1段でとまる。
      state.wizard.mirroring = true;
      try {
        updatePrice(state);
        updateEditor(state);
      } finally {
        state.wizard.mirroring = false;
      }
    }
    var els = state.elements;
    var steps = wizardSteps(state);
    if (state.wizard.step > steps.length - 1) state.wizard.step = steps.length - 1;
    if (state.wizard.step < 0) state.wizard.step = 0;
    var key = steps[state.wizard.step];
    var isReview = key === 'review';

    // Q1に戻った時点で入力欄には現在の合計が入っている＝本人がその数を見た。
    // 「◯枚と入れたのに違う」の通知はここで役目を終える（見た数と言い続けると食い違う）。
    if (key === 'qty' && state.wizard.qtyStated > 0) {
      var seen = getMatrixTotal(state);
      if (seen > 0) state.wizard.qtyStated = seen;
    }

    var previousKey = state.root.getAttribute('data-ua-body-wizard-step');
    state.root.setAttribute('data-ua-body-wizard-step', key);
    if (previousKey !== key && ['text', 'loc2text', 'font', 'thread'].indexOf(key) !== -1) {
      setEditorEmbroiderySlot(state, key === 'loc2text' ? '2' : '1');
      updateEditor(state);
    }

    // 各ステップ＝既存ブロックの表示／非表示。ブロックそのものには手を入れない。
    var shown = wizardStepBlocks(state, key);
    Array.prototype.forEach.call(els.fields.children, function (child) {
      child.classList.toggle(WIZARD_HIDDEN_CLASS, shown.indexOf(child) === -1);
    });
    els.wizardQty.hidden = key !== 'qty';

    if (els.wizardSteps.children.length !== steps.length) {
      els.wizardSteps.textContent = '';
      steps.forEach(function () {
        els.wizardSteps.appendChild(document.createElement('i'));
      });
    }
    Array.prototype.forEach.call(els.wizardSteps.children, function (bar, index) {
      bar.className = index <= state.wizard.step ? 'is-done' : '';
    });

    var copy = WIZARD_COPY[key];
    els.wizardNum.textContent = isReview
      ? '確認'
      : 'QUESTION ' + (state.wizard.step + 1) + ' / ' + (steps.length - 1);
    els.wizardQuestion.textContent = copy.q;
    var sub = copy.sub;
    if (key === 'body') {
      sub = 'サイズごとの枚数を入れてください。合計がご注文枚数になります。';
    }
    if (key === 'loc2text') {
      sub = '1箇所目（' + (els.location.value || '') + '）と同じでも、別の内容でも構いません。';
    }
    els.wizardSub.textContent = sub;
    els.wizardSub.hidden = !sub;

    if (els.pricing) els.pricing.classList.toggle(WIZARD_HIDDEN_CLASS, !isReview);
    if (els.delivery) els.delivery.classList.toggle(WIZARD_HIDDEN_CLASS, !isReview);
    // 確認ステップでも本体ボタンは出さない。同じ文言の黒いボタンが縦に2つ並ぶため、
    // ウィザード中は「刺繍込みでカートに追加」をウィザードの1つに集約する
    // （押したときの経路は本体ボタンのclick＝テーマのフォーム送信のままで変えていない）。
    wizardSyncNativeSubmit(state, false);
    els.wizardReview.hidden = !isReview;
    if (isReview) wizardRenderReview(state);
    wizardSyncBulk(state);

    els.wizardQtyBands.forEach(function (button) {
      button.setAttribute(
        'aria-pressed',
        button.getAttribute('data-ua-body-wizard-qty-band') === state.wizard.qtyBand ? 'true' : 'false'
      );
    });
    els.wizardQtyNumWrap.hidden = !state.wizard.qtyBand || state.wizard.qtyBand === 'one';

    var status = wizardStepState(state, key);
    els.wizardHint.textContent = status.hint;
    els.wizardHint.hidden = !status.hint;
    // 進めない理由（既定）と、進めるけれど知らせたいこと（is-note）を見た目で分ける。
    els.wizardHint.classList.toggle('is-note', !!status.note);
    els.wizardNext.disabled = !status.ready || state.submitting || state.cartEditLoading || state.cartEditBlocked;
    els.wizardNext.textContent = isReview
      ? cartSubmitLabel(state)
      : (state.wizard.returnToReview ? '確認へもどる' : 'つぎへ');
    // 確認から「変更」で来ているときは、戻る先は確認しかない＝「確認へもどる」に一本化する。
    els.wizardBack.hidden = state.wizard.step === 0 || (state.wizard.returnToReview && !isReview);
    // 確定額は糸色まで決まらないと出せない（現行フォームと同じ条件）。
    // それまで「—」を出しっぱなしにせず、出せるところまで＝ボディ代の小計を見せて育てる。
    var orderTotal = els.orderTotal ? els.orderTotal.textContent : '—';
    var bodyTotal = els.bodyTotal ? els.bodyTotal.textContent : '—';
    var totalValue = orderTotal;
    var pending = false;
    if (orderTotal === '—') {
      if (bodyTotal !== '—') {
        totalValue = bodyTotal + '（ボディ代のみ）';
      } else {
        totalValue = 'サイズと枚数を選ぶと出ます';
        pending = true;
      }
    }
    els.wizardTotal.textContent = totalValue;
    if (els.wizardTotalRow) els.wizardTotalRow.classList.toggle('is-pending', pending);
    // 表示ブロックの入れ替えで左右の高さが変わるので、上辺揃えを引き直す（rAFで1回にまとまる）。
    if (typeof state.scheduleDesktopGeometry === 'function') state.scheduleDesktopGeometry();
  }

  function wizardScheduleRender(state) {
    if (!wizardActive(state)) return;
    if (state.wizard.renderFrame) return;
    state.wizard.renderFrame = window.requestAnimationFrame(function () {
      state.wizard.renderFrame = 0;
      wizardRender(state);
    });
  }

  function wizardScrollToQuestion(state) {
    var head = state.elements.wizard;
    if (!head || typeof window.scrollTo !== 'function') return;
    var headRect = head.getBoundingClientRect();
    var navEl = state.elements.wizardNav;
    var navRect = navEl ? navEl.getBoundingClientRect() : headRect;
    // カード見出しと次へ/戻るボタンの両方がすでに画面内なら、スクロールで動かさない
    // （見えているのに毎回上下に動くと、切り替わったこと自体が分かりにくくなるため）。
    if (headRect.top >= 80 && navRect.bottom <= window.innerHeight) return;
    var top = headRect.top + window.scrollY - 90;
    try {
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    } catch (error) {
      window.scrollTo(0, Math.max(0, top));
    }
  }

  // スクロールが起きない場合でも「質問が切り替わった」ことが分かるよう、
  // 見出し（QUESTION n/m・質問文）と、入れ替わったブロック本体に短いフェードを付ける。
  function wizardApplyEnterAnimation(targets) {
    if (!targets.length) return null;
    var i;
    for (i = 0; i < targets.length; i++) {
      targets[i].classList.remove('is-entering');
    }
    // reflowを挟まないと、remove直後のaddではアニメーションが再発火しない。
    void targets[0].offsetWidth;
    for (i = 0; i < targets.length; i++) {
      targets[i].classList.add('is-entering');
    }
    return targets;
  }

  function wizardAnimateStep(state) {
    var els = state.elements;
    var isReview = state.root && state.root.getAttribute('data-ua-body-wizard-step') === 'review';
    var targets = [];
    if (els.wizard) targets.push(els.wizard);
    if (isReview) {
      if (els.wizardReview) targets.push(els.wizardReview);
    } else if (els.fields) {
      targets.push(els.fields);
    }
    if (state.wizard.enterTimer) {
      window.clearTimeout(state.wizard.enterTimer);
      state.wizard.enterTimer = 0;
    }
    var applied = wizardApplyEnterAnimation(targets);
    if (!applied) return;
    state.wizard.enterTimer = window.setTimeout(function () {
      var i;
      for (i = 0; i < applied.length; i++) {
        applied[i].classList.remove('is-entering');
      }
      state.wizard.enterTimer = 0;
    }, 260);
  }

  function wizardGo(state, delta) {
    var steps = wizardSteps(state);
    if (delta > 0 && state.wizard.returnToReview) {
      // 確認画面の「変更」で来た質問からは、残りの質問を通らず確認へ直帰する。
      state.wizard.returnToReview = false;
      state.wizard.step = steps.indexOf('review');
    } else {
      state.wizard.step = Math.max(0, Math.min(steps.length - 1, state.wizard.step + delta));
    }
    wizardRender(state);
    wizardAnimateStep(state);
    wizardScrollToQuestion(state);
  }

  function wizardJump(state, key) {
    var index = wizardSteps(state).indexOf(key);
    if (index < 0) return;
    state.wizard.returnToReview = true;
    state.wizard.step = index;
    wizardRender(state);
    wizardAnimateStep(state);
    wizardScrollToQuestion(state);
  }

  // カート追加は現行フォームと同じ経路（テーマのフォーム送信 → onSubmit）を通す。
  function wizardSubmit(state) {
    resolveForm(state);
    if (state.submitting) return;
    if (
      state.submitButton &&
      !state.submitButton.disabled &&
      state.submitButton.getAttribute('aria-disabled') !== 'true'
    ) {
      state.submitButton.click();
      return;
    }
    validateAndAddConfiguredProduct(state);
  }

  function wizardEnter(state) {
    var els = state.elements;
    state.wizard.active = true;
    state.wizard.returnToReview = false;
    // 「くわしい設定」で枚数を触ってから戻ってきた場合、Q1の答えを現在のサイズ内訳に合わせる
    // （合わないままだとQ3が「◯枚多い」で止まってしまう）。初回起動時は合計0なので何もしない。
    var current = getMatrixTotal(state);
    if (current > 0) {
      state.wizard.targetQty = current;
      state.wizard.qtyBand = current === 1 ? 'one' : current <= 9 ? 'few' : 'team';
      state.wizard.qtyStated = 0;
      els.wizardQtyNum.value = String(current);
    }
    state.root.setAttribute('data-ua-body-wizard', 'on');
    els.wizard.hidden = false;
    els.wizardNav.hidden = false;
    els.wizardResume.hidden = true;
    if (els.editorToggle) els.editorToggle.hidden = true;
    setEditorCollapsed(state, false);
    if (typeof state.syncLayout === 'function') state.syncLayout();
    wizardRender(state);
  }

  function wizardExit(state) {
    var els = state.elements;
    state.wizard.active = false;
    state.root.removeAttribute('data-ua-body-wizard');
    state.root.removeAttribute('data-ua-body-wizard-step');
    Array.prototype.forEach.call(els.fields.children, function (child) {
      child.classList.remove(WIZARD_HIDDEN_CLASS);
    });
    els.wizardQty.hidden = true;
    els.wizard.hidden = true;
    els.wizardNav.hidden = true;
    els.wizardReview.hidden = true;
    els.wizardPreviewSlot.hidden = true;
    els.wizardResume.hidden = false;
    // まとめて貼り付けはウィザードの入力補助なので、現行フォームでは出さない。
    Object.keys(state.wizard.bulkPanels).forEach(function (key) {
      state.wizard.bulkPanels[key].wrap.hidden = true;
    });
    ['1', '2'].forEach(function (slotKey) {
      var slot = els.wizardBulkSlots ? els.wizardBulkSlots[slotKey] : null;
      if (slot) slot.hidden = true;
    });
    if (els.pricing) els.pricing.classList.remove(WIZARD_HIDDEN_CLASS);
    if (els.delivery) els.delivery.classList.remove(WIZARD_HIDDEN_CLASS);
    if (els.editorToggle) els.editorToggle.hidden = false;
    wizardSyncNativeSubmit(state, true);
    setEditorCollapsed(state, true);
    // 入力はDOMごと共有しているので何も移し替えない。表示条件だけ現行フォームの規則に戻す。
    // ただし現行フォームに戻るときだけは liquid の既定（全員同じ文字）を復元する。
    // setupWizard で外した checked のままだと getLineMode が '' を返し、価格が「—」で止まる。
    // ua-body-price-fix-20260913
    els.lines.concat(els.location2Lines).forEach(function (line) {
      if (getLineMode(state, line)) return;
      line.modes.forEach(function (radio) { radio.checked = radio.value === TEXT_MODE_SAME; });
    });
    applyLine2Enabled(state);
    applyLocation2Ui(state);
    if (typeof state.syncLayout === 'function') state.syncLayout();
    updatePrice(state);
    updateEditor(state);
  }

  function setupWizard(state) {
    var els = state.elements;
    var required = [
      els.wizard, els.wizardSteps, els.wizardNum, els.wizardQuestion, els.wizardSub,
      els.wizardResume, els.wizardQty, els.wizardQtyNum, els.wizardQtyNumWrap,
      els.wizardPreviewSlot, els.wizardReview, els.wizardNav, els.wizardHint,
      els.wizardBack, els.wizardNext, els.wizardTotal, els.wizardEscape,
      els.fields, els.sizeField, els.textField, els.location2Field, els.locationField
    ];
    // 1つでも欠けていたら（＝古いliquidがCDNに残っている等）ウィザードは起動せず、
    // 現行フォームがそのまま出る。ここは fail-open にする（注文できない状態を作らない）。
    if (required.some(function (element) { return !element; })) return;
    if (!els.wizardQtyBands.length) return;

    state.wizard = {
      active: false,
      step: 0,
      targetQty: 0,
      qtyBand: '',
      // 「くわしい枚数」に本人が打ち込んだ数。帯ボタンで入る既定値（1/5/12）は含めない。
      // 内訳の合計がこれと違ったときだけ「◯枚→◯枚に更新しました」と知らせる。
      qtyStated: 0,
      returnToReview: false,
      renderFrame: 0,
      bulkPanels: {}
    };

    // 「全員同じ／1枚ごと」に既定を持たせない。どちらの注文も多く、既定を置くと
    // 選んだつもりのない組み合わせに流れるため、選ぶまで進めない。
    els.lines.concat(els.location2Lines).forEach(function (line) {
      line.modes.forEach(function (radio) { radio.checked = false; });
    });

    els.wizardQtyBands.forEach(function (button) {
      button.addEventListener('click', function () {
        var band = button.getAttribute('data-ua-body-wizard-qty-band');
        state.wizard.qtyBand = band;
        // 帯ボタンで入る数は既定値であって本人が決めた数ではない＝ズレの通知の対象にしない。
        state.wizard.qtyStated = 0;
        var current = getMatrixTotal(state);
        // すでに入れたサイズ内訳がその帯に収まっているなら壊さない（枚数の正本は内訳）。
        if (wizardQtyInBand(band, current)) {
          state.wizard.targetQty = current;
          if (current >= 2) els.wizardQtyNum.value = String(current);
          wizardRender(state);
          return;
        }
        var value = Number(button.getAttribute('data-ua-body-wizard-qty-value')) || 1;
        els.wizardQtyNum.value = String(value);
        wizardSetTargetQty(state, value);
        wizardRender(state);
      });
    });

    els.wizardQtyNum.addEventListener('input', function () {
      var value = Math.max(2, Math.min(100, Math.floor(Number(els.wizardQtyNum.value)) || 2));
      // 本人が打ち込んだ数だけ覚えておく（プログラムからの value 代入では input が飛ばない）。
      state.wizard.qtyStated = value;
      wizardSetTargetQty(state, value);
      wizardRender(state);
    });

    els.wizardNext.addEventListener('click', function () {
      if (els.wizardNext.disabled) return;
      if (wizardSteps(state)[state.wizard.step] === 'review') {
        wizardSubmit(state);
        return;
      }
      wizardGo(state, 1);
    });
    els.wizardBack.addEventListener('click', function () { wizardGo(state, -1); });
    els.wizardEscape.addEventListener('click', function () { wizardExit(state); });
    els.wizardResume.addEventListener('click', function () { wizardEnter(state); });
    els.wizardReview.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-ua-body-wizard-jump]') : null;
      if (!button) return;
      wizardJump(state, button.getAttribute('data-ua-body-wizard-jump'));
    });

    // 既存の入力に反応して進捗・活性・合計を引き直す（判定は既存ロジックの読み取りのみ）。
    ['input', 'change', 'click'].forEach(function (type) {
      state.root.addEventListener(type, function () { wizardScheduleRender(state); });
    });

    wizardEnter(state);
  }

  function bindEvents(state) {
    state.elements.purchaseSubmit.addEventListener('click', function () {
      resolveForm(state);
      if (
        state.submitting ||
        !state.submitButton ||
        state.submitButton.getAttribute('aria-disabled') === 'true'
      ) return;
      state.submitButton.click();
    });

    state.elements.lines.forEach(function (line) {
      line.modes.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          setEditorEmbroiderySlot(state, '1');
          setLineMode(state, line, radio.value);
          clearError(state);
          updatePrice(state);
          updateEditor(state);
        });
      });
    });

    state.elements.line2Enable.addEventListener('change', function () {
      setEditorEmbroiderySlot(state, '1');
      applyLine2Enabled(state);
      clearError(state);
      updatePrice(state);
      updateEditor(state);
    });

    state.elements.editorViewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setEditorView(state, button.getAttribute('data-ua-body-editor-view'));
      });
    });

    state.elements.editorSlotButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var slot = button.getAttribute('data-ua-body-editor-slot');
        setEditorEmbroiderySlot(state, slot);
        var location = slot === '2'
          ? state.elements.location2Select.value
          : state.elements.location.value;
        syncEditorViewForLocation(state, location);
        updateEditor(state);
      });
    });

    state.elements.editorPreviewToggle.addEventListener('click', function () {
      if (state.elements.editorPreviewToggle.disabled) return;
      state.editorPreviewMode = state.editorPreviewMode === 'zoom' ? 'full' : 'zoom';
      updateEditor(state);
    });

    window.addEventListener('resize', function () {
      scheduleEditorSync(state);
    });

    state.elements.chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        setEditorEmbroiderySlot(state, '1');
        var location = chip.getAttribute('data-ua-body-location-chip');
        setLocation(state, location);
        syncEditorViewForLocation(state, location);
        clearError(state);
        updateEditor(state);
      });
    });

    state.elements.location.addEventListener('change', function () {
      setEditorEmbroiderySlot(state, '1');
      setLocation(state, state.elements.location.value);
      syncEditorViewForLocation(state, state.elements.location.value);
      clearError(state);
      updateEditor(state);
    });

    state.elements.fontTrigger.addEventListener('click', function () {
      setFontPickerOpen(state, state.elements.fontOptions.hidden);
    });

    state.elements.fontChips.forEach(function (button) {
      button.addEventListener('click', function () {
        setEditorEmbroiderySlot(state, '1');
        state.elements.font.value = button.getAttribute('data-ua-body-font-chip');
        setFontPickerOpen(state, false);
        clearError(state);
        updateEditor(state);
        loadSelectedFont(state);
        state.elements.fontTrigger.focus({ preventScroll: true });
      });
    });

    state.elements.fontPicker.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || state.elements.fontOptions.hidden) return;
      event.preventDefault();
      setFontPickerOpen(state, false);
      state.elements.fontTrigger.focus({ preventScroll: true });
    });

    document.addEventListener('click', function (event) {
      if (state.elements.fontOptions.hidden || state.elements.fontPicker.contains(event.target)) return;
      setFontPickerOpen(state, false);
    });

    state.elements.threadColorChipButtons.forEach(function (chip) {
      chip.addEventListener('click', function () {
        setEditorEmbroiderySlot(state, '1');
        setThreadColor(state, chip.getAttribute('data-ua-body-thread-color-chip'));
        clearError(state);
        updatePrice(state);
        updateEditor(state);
      });
    });

    state.elements.threadColor.addEventListener('change', function () {
      setEditorEmbroiderySlot(state, '1');
      setThreadColor(state, state.elements.threadColor.value);
      clearError(state);
      updateEditor(state);
    });

    state.elements.location2Add.addEventListener('click', function () {
      enableSecondLocation(state);
      clearError(state);
      updatePrice(state);
      updateEditor(state);
      location2FocusTarget(state).focus({ preventScroll: true });
    });

    state.elements.location2Remove.addEventListener('click', function () {
      disableSecondLocation(state);
      clearError(state);
      updatePrice(state);
      updateEditor(state);
      state.elements.location2Add.focus({ preventScroll: true });
    });

    state.elements.location2Select.addEventListener('change', function () {
      setEditorEmbroiderySlot(state, '2');
      applyLocationUniqueness(state);
      syncEditorViewForLocation(state, state.elements.location2Select.value);
      clearError(state);
      updatePrice(state);
      updateEditor(state);
    });

    // チップ選択も select の値を更新して change を発火させ、上のハンドラに一本化する（二重実装しない）。
    state.elements.location2ChipButtons.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var location = chip.getAttribute('data-ua-body-location2-chip');
        state.elements.location2Select.value = location;
        state.elements.location2Select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    state.elements.location2ContentModes.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        setEditorEmbroiderySlot(state, '2');
        applyLocation2Ui(state);
        clearError(state);
        updatePrice(state);
        updateEditor(state);
      });
    });

    state.elements.location2Lines.forEach(function (line) {
      line.modes.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          setEditorEmbroiderySlot(state, '2');
          applyLocation2LineModeUi(state, line);
          rebuildLineRows(state);
          rebuildLocation2Rows(state);
          applyRowTextColumns(state);
          applyRowCardsVisibility(state);
          applyLocation2RowCardsVisibility(state);
          applyRowsHelp(state);
          applyLocation2RowsHelp(state);
          updateProgress(state);
          updateLocation2Progress(state);
          clearError(state);
          updatePrice(state);
          updateEditor(state);
        });
      });
    });

    state.elements.location2Line2Enable.addEventListener('change', function () {
      setEditorEmbroiderySlot(state, '2');
      applyLocation2Ui(state);
      clearError(state);
      updatePrice(state);
      updateEditor(state);
    });

    state.elements.location2Font.addEventListener('change', function () {
      setEditorEmbroiderySlot(state, '2');
      syncFontPicker(state);
      clearError(state);
      updateEditor(state);
    });

    state.elements.location2Thread.addEventListener('change', function () {
      setEditorEmbroiderySlot(state, '2');
      updateUntouchedLocation2RowThreads(state);
      clearError(state);
      updatePrice(state);
      updateEditor(state);
    });

    state.elements.location2ThreadIndividual.addEventListener('change', function () {
      setEditorEmbroiderySlot(state, '2');
      applyLocation2Ui(state);
      clearError(state);
      updatePrice(state);
      updateEditor(state);
    });

    // 「＋サイズを追加」。空の新規サイズ行を足して、そのselectへフォーカスする。
    // 各サイズ行内の select / 枚数入力 / 増減 / 削除は生成時に配線済み。
    state.elements.sizeAddButton.addEventListener('click', function () {
      if (state.elements.sizeAddButton.disabled) return;
      var row = addSizeRow(state, '', 1);
      clearError(state);
      handleSizeRowsChange(state);
      var select = row.querySelector('[data-ua-body-sizerow-select]');
      if (select) select.focus({ preventScroll: true });
    });

    // 「ボディ色・糸色を1枚ごとに変える」トグル。行カードの色/糸色列を出し入れする。
    state.elements.attrIndividualToggle.addEventListener('change', function () {
      clearError(state);
      handleAttrToggle(state);
    });

    ['focusin', 'click'].forEach(function (type) {
      state.root.addEventListener(type, function (event) {
        if (!event.target.closest('.ua-body-configurator__row')) return;
        followEditorPerson(state, event.target);
        updateEditor(state);
      });
    });
    state.root.addEventListener('input', function (event) {
      if (event.target === state.editorPersonSelect) state.editorPerson = Number(event.target.value) || 0;
      followEditorPerson(state, event.target);
      clearResolvedInputError(state, event.target);
      if (event.target && event.target.matches(
        '[data-ua-body-location2-line-text], [data-ua-body-row-location2-name], [data-ua-body-row-location2-name2]'
      )) {
        setEditorEmbroiderySlot(state, '2');
      } else if (event.target && event.target.matches(
        '[data-ua-body-line-text], [data-ua-body-row-name], [data-ua-body-row-name2]'
      )) {
        setEditorEmbroiderySlot(state, '1');
      }
      clearError(state);
      updateAllLineProgress(state);
      updatePrice(state);
      updateEditor(state);
    });
    state.root.addEventListener('change', function (event) {
      followEditorPerson(state, event.target);
      clearResolvedInputError(state, event.target);
      clearError(state);
      updatePrice(state);
      // 行カードのボディ色/糸色 select 変更（change・rootへバブル）でも仕上がりイメージを選択中の行に追従。
      updateEditor(state);
    });

    var sizeFieldset = getSizeFieldset(state);
    if (sizeFieldset) {
      sizeFieldset.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[type="radio"]')) handleVariantSignal(state, 'size-radio');
      });
    }

    var variantSelects = getVariantSelects(state);
    if (variantSelects) {
      variantSelects.addEventListener('change', function (event) {
        if (event.target && event.target.matches('select')) syncColorPicker(state);
        handleVariantSignal(state, 'variant-select');
      });
    }

    state.variantInput.addEventListener('change', function () {
      handleVariantSignal(state, 'variant-input-change');
    });
    state.variantObserver = new window.MutationObserver(function () {
      handleVariantSignal(state, 'variant-observer');
    });
    observeVariantInput(state);

    document.addEventListener(
      'change',
      function (event) {
        var input = event.target;
        if (!input || !input.matches || !input.matches('input[name="id"]')) return;

        var form = input.closest('form');
        if (!form || form.getAttribute('id') !== state.config.formId) return;

        resolveForm(state);
        handleVariantSignal(state, 'form-id-change');
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        onSubmit(state, event);
      },
      true
    );

    window.addEventListener('pageshow', function () {
      scheduleVariantSync(state);
    });
  }

  function failClosed(state, error) {
    state.root.setAttribute('data-state', 'error');
    console.error('[ua-body-configurator] initialization failed', error);
    showError(
      state,
      '刺繍設定を読み込めませんでした（' + error.message + '）。ページを再読み込みしても直らない場合はお問い合わせください。'
    );
  }

  function init(root) {
    if (initializedRoots.has(root)) return;
    initializedRoots.add(root);

    var state = {
      root: root,
      cartEditPairId: new URLSearchParams(window.location.search).get('ua_edit'),
      previewView: new URLSearchParams(window.location.search).get('view'),
      elements: getElements(root),
      submitting: false,
      hadError: false,
      variantSyncTimer: null,
      editorSyncTimer: null,
      variantWaiters: [],
      colorVariantPending: null,
      variantSignalStamps: [],
      variantReactionsDisabled: false,
      lastVariantSignalValue: null,
      editorView: 'front',
      editorEmbroiderySlot: '1',
      editorPreviewMode: 'full',
      editorPreviewHasText: false,
      fontPreviewsActivated: false,
      magnifierTouchPinned: false,
      magnifierPlacement: null
    };

    try {
      state.config = parseConfig(root);
      state.editorConfig = parseEditorConfig(root);
      state.mount = document.getElementById('UaBodyConfiguratorMount-' + state.config.sectionId);
      if (!state.mount) throw new Error('コンフィギュレーターの表示位置が見つかりません。');
      state.mount.querySelectorAll('[data-ua-body-configurator]').forEach(function (existingRoot) {
        if (existingRoot !== root) existingRoot.remove();
      });
      state.mount.appendChild(root);

      resolveForm(state);
      validateBootstrap(state);
      state.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      createColorPicker(state);
      setupEditorCollapse(state);
      // レイアウト層より先に起動する（初回の syncLayout がウィザードの前提で走るように）。
      setupWizard(state);
      setupResponsiveEditorLayout(state);
      setupMagnifier(state);
      setupAdminShortcut(state);
      compactProductSizeChart(state);
      insertTitleLead(state);
      initSizeRows(state);
      applyLine2Enabled(state);
      applyLocation2Ui(state);
      loadSelectedFont(state);
      applyLocationAvailability(state);
      setLocation(state, state.elements.location.value || state.editorConfig.enabledLocations[0] || '');
      syncEditorViewForLocation(state, state.elements.location.value);
      setThreadColor(state, state.elements.threadColor.value);
      bindEvents(state);
      syncVariant(state);
      updateEditor(state);
      wizardRender(state);

      var guard = document.getElementById(state.config.guardId);
      if (guard) guard.remove();
      state.mount.classList.add('ua-body-configurator-mount--ready');
      state.root.setAttribute('data-state', 'ready');
      restoreCartSet(state);
    } catch (error) {
      failClosed(state, error);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ua-body-configurator]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    if (event.target.matches && event.target.matches('[data-ua-body-configurator]')) init(event.target);
    event.target.querySelectorAll('[data-ua-body-configurator]').forEach(init);
  });
})();
